"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5872],{

/***/ 1280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1182);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_override__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9413);
/* harmony import */ var utils_externalLinkMixin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6646);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7697);








const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { size ="full" , children , className , isDisabled , type ="button" , mode =constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.primary */ .r.primary , iconPosition ="left" , iconSize ="xl" , icon , href , rel , shallow , iconFill , isWide =false , scroll , ...rest } = param;
    const classes = (0,tailwind_override__WEBPACK_IMPORTED_MODULE_3__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("btn relative", {
        "h-[56px] px-9": size === "full",
        "text-[13px] px-4 py-2 font-medium leading-5": size === "small",
        "h-[24px] px-4 min-w-0": size === "xsmall",
        "h-10 w-10 p-0 !min-w-0": size === "full-icon",
        "btn-flat": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.flat */ .r.flat,
        "btn-flat white": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.flatWhite */ .r.flatWhite,
        "btn-flat black": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.flatBlack */ .r.flatBlack,
        "btn-primary": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.primary */ .r.primary,
        "btn-secondary": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.secondary */ .r.secondary,
        "btn-secondary-black": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.secondaryBlack */ .r.secondaryBlack,
        "btn-secondary-white": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.secondaryWhite */ .r.secondaryWhite,
        "btn-secondary-beige": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.secondaryBeige */ .r.secondaryBeige,
        "btn-secondary btn-secondary-warmgray-2": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.secondaryWarmGray2 */ .r.secondaryWarmGray2,
        "btn-menu-link": mode === constants_ButtonModes__WEBPACK_IMPORTED_MODULE_4__/* .ButtonModes.menuLink */ .r.menuLink,
        "rounded-full": true,
        noDecorate: href,
        "w-auto w-[240px]": isWide,
        [className || ""]: className
    }));
    const buttonChildren = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            icon && iconPosition === "left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                icon: icon,
                fill: iconFill,
                size: iconSize
            }),
            children,
            icon && iconPosition === "right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                icon: icon,
                fill: iconFill,
                size: iconSize
            })
        ]
    });
    if (href && !isDisabled) {
        const { "aria-label": ariaLabel , onClick  } = rest;
        const handleClick = onClick !== undefined ? (event)=>{
            const proceed = onClick(event);
            if (proceed !== undefined) {
                return proceed;
            }
            return true;
        } : undefined;
        if (href.startsWith("#")) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                onClick: handleClick,
                className: classes,
                ref: ref,
                "aria-label": ariaLabel,
                href: href,
                children: buttonChildren
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            shallow: shallow,
            href: href,
            prefetch: false,
            scroll: scroll,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                onClick: handleClick,
                className: classes,
                ref: ref,
                "aria-label": ariaLabel,
                ...(0,utils_externalLinkMixin__WEBPACK_IMPORTED_MODULE_7__/* .externalLinkMixin */ .K)(href),
                children: buttonChildren
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: classes,
        ref: ref,
        type: type,
        disabled: isDisabled,
        ...rest,
        children: buttonChildren
    });
});
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 7697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1182);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_override__WEBPACK_IMPORTED_MODULE_1__);



const sizeMap = {
    fw: "fw",
    xxs: "10",
    xs: "12",
    sm: "14",
    "1x": "16",
    lg: "18",
    xl: "20",
    "2x": "22",
    "2.5x": "32",
    "3x": "48",
    "4x": "64",
    "5x": "80",
    "6x": "96",
    "7x": "112",
    "8x": "128",
    "9x": "144",
    "10x": "160",
    default: "24"
};
const Icon = (param)=>{
    let { className , fill , icon: IconWrapper , size ="xl" , ...rest } = param;
    if (typeof IconWrapper === "string") {
        const classes = (0,tailwind_override__WEBPACK_IMPORTED_MODULE_1__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex justify-center items-center fill-current", fill, IconWrapper, className, "ri-".concat(size)));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: classes
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center justify-center fill-current", fill, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
            height: sizeMap[size],
            ...rest
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 1051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1182);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_override__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var constants_ButtonModes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9413);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1280);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7697);







const IconButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { className , fill ="currentColor" , hasBorder =true , icon , iconClassName , isDark , isDisabled , mode =isDark ? constants_ButtonModes__WEBPACK_IMPORTED_MODULE_3__/* .ButtonModes.flatBlack */ .r.flatBlack : constants_ButtonModes__WEBPACK_IMPORTED_MODULE_3__/* .ButtonModes.flat */ .r.flat , size ="full" , ...rest } = param;
    const classes = (0,tailwind_override__WEBPACK_IMPORTED_MODULE_2__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("iconBtn rounded-full flex items-center justify-center max-h-10", mode, {
        [className || ""]: className,
        "w-10 h-10 px-0": size === "full",
        "w-8 h-8": size === "small",
        dark: isDark,
        hasBorder
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        ref: ref,
        className: classes,
        mode: constants_ButtonModes__WEBPACK_IMPORTED_MODULE_3__/* .ButtonModes.none */ .r.none,
        isDisabled: isDisabled,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: iconClassName,
            size: rest.iconSize,
            fill: fill,
            icon: icon
        })
    });
});
IconButton.displayName = "IconButton";
/* harmony default export */ __webpack_exports__["Z"] = (IconButton);


/***/ }),

/***/ 8925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./src/navigation/urls.ts
var urls = __webpack_require__(6633);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/img/logo-black.svg
var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogoBlack = function SvgLogoBlack(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    id: "logo-black_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    viewBox: "0 0 524.41 175.75",
    style: {
      enableBackground: "new 0 0 524.41 175.75"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".logo-black_svg__st1{fill:#fff}.logo-black_svg__st2{fill:#231f20}")), /*#__PURE__*/react.createElement("path", {
    d: "M132.4 87.87c0 25.25-20.47 45.72-45.72 45.72s-45.72-20.47-45.72-45.72 20.47-45.72 45.72-45.72 45.72 20.47 45.72 45.72",
    style: {
      fill: "#d40000"
    }
  }), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "logo-black_svg__st1",
    d: "M96.19 63.32h12.31v49.26H96.19zM64.85 113.21l30.92-30.86H77.16V63.33H64.85z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "logo-black_svg__st2",
    d: "M151.69 84.64h7.38V69.67h13.12v14.97h7.38V48.52h-7.38v13.99h-13.12V48.52h-7.38v36.12zm47.5.54h1.46c7.65 0 12.91-3.47 12.91-10.85V48.52h-7.37v24.67c0 3.41-1.41 5.15-5.64 5.15h-1.25c-4.17 0-5.58-1.74-5.58-5.15V48.52h-7.38v25.81c0 7.38 5.2 10.85 12.85 10.85m21.1-.54h7.37V70.81h9.82l-3.96-2.55 5.8 16.38h8.35l-7.7-18.17-1.14 3.69c4.44-1.41 8.03-4.66 8.03-10.09v-.76c0-6.73-4.61-10.79-11.82-10.79h-14.75v36.12zm7.37-20.34v-9.06h7.11c3.15 0 4.72 1.46 4.72 4.01v.98c0 2.6-1.52 4.07-4.5 4.07h-7.33zm31.83 20.34h7.37v-29.4h9.81v-6.73h-27.01v6.73h9.82v29.4zm22.29 0h7.37V48.52h-7.37v36.12zm24.13.54h1.36c3.9 0 6.99-1.9 8.4-5.53h.54l1.08 4.99h5.1l.05-20.33H308.4v6.07h7.21v2.77c0 3.36-1.9 5.42-5.37 5.42h-1.84c-3.58 0-5.48-1.95-5.48-5.64V59.91c0-3.36 1.63-5.31 5.64-5.31h1.46c3.63 0 5.1 1.85 5.1 4.83v.49h7.32v-.65c0-7-4.34-11.39-12.2-11.39h-1.68c-7.59 0-13.02 3.96-13.02 11.71V73.9c.02 7.43 4.57 11.28 10.37 11.28m23.7-.54h7.38V70.81h9.81l-3.96-2.55 5.8 16.38h8.35l-7.7-18.17-1.14 3.69c4.45-1.41 8.03-4.66 8.03-10.09v-.76c0-6.73-4.61-10.79-11.82-10.79h-14.75v36.12zm7.38-20.34v-9.06h7.1c3.15 0 4.72 1.46 4.72 4.01v.98c0 2.6-1.52 4.07-4.5 4.07h-7.32zm37.25 20.88h1.46c7.65 0 12.91-3.47 12.91-10.85V48.52h-7.38v24.67c0 3.41-1.41 5.15-5.64 5.15h-1.25c-4.18 0-5.59-1.74-5.59-5.15V48.52h-7.37v25.81c.01 7.38 5.21 10.85 12.86 10.85m28.74-.54h7.37v-29.4h9.81v-6.73h-27.01v6.73h9.82v29.4zm22.4 0h23.97V77.8h-16.6v-8.24h14.16v-6.83h-14.16v-7.37h16.11v-6.83h-23.48v36.11zm29.93 0h7.27v-9.55c0-6.94-.05-11.87-.43-18.6h.54c1.41 3.85 2.55 7.05 5.42 14.32l5.48 13.83h9.87V48.52h-7.27v8.78c0 6.83.16 11.6.87 19.03h-.54c-1.63-4.77-3.26-9.16-6.08-16.16l-4.72-11.66h-10.41v36.13zM162.37 127.8h.81c3.8 0 6.34-1.95 7.75-4.99h.54l1.19 4.44h3.36v-19.2H163.4v4.34h8.08v3.14c0 4.88-2.33 7.7-7.16 7.7h-.7c-4.77 0-6.89-2.71-6.89-7.86v-12.69c0-4.93 2.28-7.54 7.21-7.54h.76c4.55 0 6.34 2.39 6.34 6.62v.38h4.99v-.59c0-7.11-4.18-11.06-11.28-11.06H164c-7.27 0-12.36 4.23-12.36 12.09v13.12c-.01 8.14 4.55 12.1 10.73 12.1m21.04-.54h5.1v-14.37h10.47l-2.93-1.84 6.56 16.21h5.64l-7.65-17.25-.65 2.17c3.85-1.03 7.65-4.23 7.65-9.87v-.76c0-7-5.05-10.41-11.6-10.41h-12.58v36.12zm5.1-18.98V95.81H196c4.28 0 6.51 2.06 6.51 5.75v.98c0 3.69-2.17 5.75-6.29 5.75h-7.71zm37.41-17.79h-.98c-6.99 0-11.82 4.13-11.82 11.55v14.32c0 7.43 4.83 11.55 11.82 11.55h.98c6.94 0 11.82-4.12 11.82-11.55v-14.32c.01-7.42-4.87-11.55-11.82-11.55m6.73 11.72v13.99c0 4.23-1.9 6.83-6.73 6.83h-.98c-4.83 0-6.73-2.6-6.73-6.83v-13.99c0-4.23 1.9-6.83 6.73-6.83h.98c4.83-.01 6.73 2.6 6.73 6.83m23.75 25.7h.98c6.99 0 11.93-3.64 11.93-10.79V91.14h-5.1v25.6c0 3.9-1.9 6.29-6.83 6.29h-.98c-4.93 0-6.83-2.39-6.83-6.29v-25.6h-5.1v25.98c0 7.16 4.88 10.79 11.93 10.79m20.39-.65h5.1V95.91h7.43c4.29 0 6.51 2.17 6.51 5.97v.98c0 3.8-2.22 5.91-6.51 5.91h-8.29v4.66h8.24c6.4 0 11.66-3.47 11.66-10.41v-1.3c0-6.51-4.44-10.58-11.77-10.58H276.8v36.12z"
  })));
};
/* harmony default export */ var logo_black = (SvgLogoBlack);
;// CONCATENATED MODULE: ./public/img/logo-white.svg
var logo_white_style, logo_white_path, logo_white_path2;
function logo_white_extends() { logo_white_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_white_extends.apply(this, arguments); }

var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/react.createElement("svg", logo_white_extends({
    id: "logo-white_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    viewBox: "0 0 524.41 175.75",
    style: {
      enableBackground: "new 0 0 524.41 175.75"
    },
    xmlSpace: "preserve"
  }, props), logo_white_style || (logo_white_style = /*#__PURE__*/react.createElement("style", null, ".logo-white_svg__st1,.logo-white_svg__st2{fill:#fff}")), /*#__PURE__*/react.createElement("path", {
    d: "M132.4 87.87c0 25.25-20.47 45.72-45.72 45.72s-45.72-20.47-45.72-45.72 20.47-45.72 45.72-45.72 45.72 20.47 45.72 45.72",
    style: {
      fill: "#d40000"
    }
  }), logo_white_path || (logo_white_path = /*#__PURE__*/react.createElement("path", {
    className: "logo-white_svg__st1",
    d: "M96.19 63.32h12.31v49.26H96.19zM64.85 113.21l30.92-30.86H77.16V63.33H64.85z"
  })), logo_white_path2 || (logo_white_path2 = /*#__PURE__*/react.createElement("path", {
    className: "logo-white_svg__st2",
    d: "M151.69 84.64h7.38V69.67h13.12v14.97h7.38V48.52h-7.38v13.99h-13.12V48.52h-7.38v36.12zm47.5.54h1.46c7.65 0 12.91-3.47 12.91-10.85V48.52h-7.37v24.67c0 3.41-1.41 5.15-5.64 5.15h-1.25c-4.17 0-5.58-1.74-5.58-5.15V48.52h-7.38v25.81c0 7.38 5.2 10.85 12.85 10.85m21.1-.54h7.37V70.81h9.82l-3.96-2.55 5.8 16.38h8.35l-7.7-18.17-1.14 3.69c4.44-1.41 8.03-4.66 8.03-10.09v-.76c0-6.73-4.61-10.79-11.82-10.79h-14.75v36.12zm7.37-20.34v-9.06h7.11c3.15 0 4.72 1.46 4.72 4.01v.98c0 2.6-1.52 4.07-4.5 4.07h-7.33zm31.83 20.34h7.37v-29.4h9.81v-6.73h-27.01v6.73h9.82v29.4zm22.29 0h7.37V48.52h-7.37v36.12zm24.13.54h1.36c3.9 0 6.99-1.9 8.4-5.53h.54l1.08 4.99h5.1l.05-20.33H308.4v6.07h7.21v2.77c0 3.36-1.9 5.42-5.37 5.42h-1.84c-3.58 0-5.48-1.95-5.48-5.64V59.91c0-3.36 1.63-5.31 5.64-5.31h1.46c3.63 0 5.1 1.85 5.1 4.83v.49h7.32v-.65c0-7-4.34-11.39-12.2-11.39h-1.68c-7.59 0-13.02 3.96-13.02 11.71V73.9c.02 7.43 4.57 11.28 10.37 11.28m23.7-.54h7.38V70.81h9.81l-3.96-2.55 5.8 16.38h8.35l-7.7-18.17-1.14 3.69c4.45-1.41 8.03-4.66 8.03-10.09v-.76c0-6.73-4.61-10.79-11.82-10.79h-14.75v36.12zm7.38-20.34v-9.06h7.1c3.15 0 4.72 1.46 4.72 4.01v.98c0 2.6-1.52 4.07-4.5 4.07h-7.32zm37.25 20.88h1.46c7.65 0 12.91-3.47 12.91-10.85V48.52h-7.38v24.67c0 3.41-1.41 5.15-5.64 5.15h-1.25c-4.18 0-5.59-1.74-5.59-5.15V48.52h-7.37v25.81c.01 7.38 5.21 10.85 12.86 10.85m28.74-.54h7.37v-29.4h9.81v-6.73h-27.01v6.73h9.82v29.4zm22.4 0h23.97V77.8h-16.6v-8.24h14.16v-6.83h-14.16v-7.37h16.11v-6.83h-23.48v36.11zm29.93 0h7.27v-9.55c0-6.94-.05-11.87-.43-18.6h.54c1.41 3.85 2.55 7.05 5.42 14.32l5.48 13.83h9.87V48.52h-7.27v8.78c0 6.83.16 11.6.87 19.03h-.54c-1.63-4.77-3.26-9.16-6.08-16.16l-4.72-11.66h-10.41v36.13zM162.37 127.8h.81c3.8 0 6.34-1.95 7.75-4.99h.54l1.19 4.44h3.36v-19.2H163.4v4.34h8.08v3.14c0 4.88-2.33 7.7-7.16 7.7h-.7c-4.77 0-6.89-2.71-6.89-7.86v-12.69c0-4.93 2.28-7.54 7.21-7.54h.76c4.55 0 6.34 2.39 6.34 6.62v.38h4.99v-.59c0-7.11-4.18-11.06-11.28-11.06H164c-7.27 0-12.36 4.23-12.36 12.09v13.12c-.01 8.14 4.55 12.1 10.73 12.1m21.04-.54h5.1v-14.37h10.47l-2.93-1.84 6.56 16.21h5.64l-7.65-17.25-.65 2.17c3.85-1.03 7.65-4.23 7.65-9.87v-.76c0-7-5.05-10.41-11.6-10.41h-12.58v36.12zm5.1-18.98V95.81H196c4.28 0 6.51 2.06 6.51 5.75v.98c0 3.69-2.17 5.75-6.29 5.75h-7.71zm37.41-17.79h-.98c-6.99 0-11.82 4.13-11.82 11.55v14.32c0 7.43 4.83 11.55 11.82 11.55h.98c6.94 0 11.82-4.12 11.82-11.55v-14.32c.01-7.42-4.87-11.55-11.82-11.55m6.73 11.72v13.99c0 4.23-1.9 6.83-6.73 6.83h-.98c-4.83 0-6.73-2.6-6.73-6.83v-13.99c0-4.23 1.9-6.83 6.73-6.83h.98c4.83-.01 6.73 2.6 6.73 6.83m23.75 25.7h.98c6.99 0 11.93-3.64 11.93-10.79V91.14h-5.1v25.6c0 3.9-1.9 6.29-6.83 6.29h-.98c-4.93 0-6.83-2.39-6.83-6.29v-25.6h-5.1v25.98c0 7.16 4.88 10.79 11.93 10.79m20.39-.65h5.1V95.91h7.43c4.29 0 6.51 2.17 6.51 5.97v.98c0 3.8-2.22 5.91-6.51 5.91h-8.29v4.66h8.24c6.4 0 11.66-3.47 11.66-10.41v-1.3c0-6.51-4.44-10.58-11.77-10.58H276.8v36.12z"
  })));
};
/* harmony default export */ var logo_white = (SvgLogoWhite);
;// CONCATENATED MODULE: ./src/components/atoms/Logo.tsx






const Logo = (param)=>/*#__PURE__*/ {
    let { className , whiteText =false  } = param;
    return (0,jsx_runtime.jsx)((link_default()), {
        href: (0,urls/* getIndexUrl */.TY)(),
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (0,clsx_m/* default */.Z)(className, "flex w-[150px] h-[52px] tablet:w-[160px] tablet:h-[67px]"),
            "aria-label": "Frontpage",
            children: whiteText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_white, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_black, {})
        })
    });
};
/* harmony default export */ var atoms_Logo = (Logo);


/***/ }),

/***/ 7169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1182);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_override__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_externalLinkMixin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6646);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7697);







const StyledLink = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, ref)=>{
    let { link , shallow , prefetch , as , replace , scroll , passHref , locale , className , underline =true , iconPosition ="right" , icon , iconClassName , children , ...rest } = param;
    var _href;
    const href = (_href = rest.href) !== null && _href !== void 0 ? _href : link === null || link === void 0 ? void 0 : link.href;
    var ref1;
    const ariaLabel = (ref1 = rest["aria-label"]) !== null && ref1 !== void 0 ? ref1 : link === null || link === void 0 ? void 0 : link.ariaLabel;
    const classes = (0,tailwind_override__WEBPACK_IMPORTED_MODULE_3__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("hover:cursor-pointer inline-flex", {
        underline
    }, className));
    const childElements = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            iconPosition === "left" && icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                icon: icon,
                fill: "text-inherit",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(iconClassName, "mr-2")
            }),
            children !== null && children !== void 0 ? children : link === null || link === void 0 ? void 0 : link.text,
            iconPosition === "right" && icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                icon: icon,
                fill: "text-inherit",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(iconClassName, "ml-2")
            })
        ]
    });
    if (href === undefined || (href === null || href === void 0 ? void 0 : href.startsWith("#"))) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classes,
            ref: ref,
            "aria-label": ariaLabel,
            href: href,
            ...rest,
            children: childElements
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        shallow: shallow,
        href: href,
        prefetch: prefetch,
        as: as,
        replace: replace,
        scroll: scroll,
        passHref: passHref,
        locale: locale,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classes,
            ref: ref,
            "aria-label": ariaLabel,
            ...(0,utils_externalLinkMixin__WEBPACK_IMPORTED_MODULE_6__/* .externalLinkMixin */ .K)(href),
            ...rest,
            children: childElements
        })
    });
});
StyledLink.displayName = "StyledLink";


/***/ }),

/***/ 3857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MNc": function() { return /* reexport */ ArrowDownLine; },
  "CCt": function() { return /* reexport */ ArrowLeftLine; },
  "dT3": function() { return /* reexport */ ArrowRightLine; },
  "bXt": function() { return /* reexport */ CheckboxCircleLine; },
  "aBd": function() { return /* reexport */ CloseCircleLine; },
  "OhS": function() { return /* reexport */ CloseLine; },
  "nVL": function() { return /* reexport */ Menu2Line; }
});

// UNUSED EXPORTS: AddBoxFill, AddBoxLine, AddCircleFill, AddCircleLine, AddFill, AddLine, AlarmFill, AlarmLine, AlarmWarningFill, AlarmWarningLine, AlertFill, AlertLine, Apps2Fill, Apps2Line, AppsFill, AppsLine, ArrowDownCircleFill, ArrowDownCircleLine, ArrowDownFill, ArrowDownSFill, ArrowDownSLine, ArrowDropDownFill, ArrowDropDownLine, ArrowDropLeftFill, ArrowDropLeftLine, ArrowDropRightFill, ArrowDropRightLine, ArrowDropUpFill, ArrowDropUpLine, ArrowGoBackFill, ArrowGoBackLine, ArrowGoForwardFill, ArrowGoForwardLine, ArrowLeftCircleFill, ArrowLeftCircleLine, ArrowLeftDownFill, ArrowLeftDownLine, ArrowLeftFill, ArrowLeftRightFill, ArrowLeftRightLine, ArrowLeftSFill, ArrowLeftSLine, ArrowLeftUpFill, ArrowLeftUpLine, ArrowRightCircleFill, ArrowRightCircleLine, ArrowRightDownFill, ArrowRightDownLine, ArrowRightFill, ArrowRightSFill, ArrowRightSLine, ArrowRightUpFill, ArrowRightUpLine, ArrowUpCircleFill, ArrowUpCircleLine, ArrowUpDownFill, ArrowUpDownLine, ArrowUpFill, ArrowUpLine, ArrowUpSFill, ArrowUpSLine, CheckDoubleFill, CheckDoubleLine, CheckFill, CheckLine, CheckboxBlankCircleFill, CheckboxBlankCircleLine, CheckboxBlankFill, CheckboxBlankLine, CheckboxCircleFill, CheckboxFill, CheckboxIndeterminateFill, CheckboxIndeterminateLine, CheckboxLine, CheckboxMultipleBlankFill, CheckboxMultipleBlankLine, CheckboxMultipleFill, CheckboxMultipleLine, CloseCircleFill, CloseFill, DashboardFill, DashboardLine, DeleteBack2Fill, DeleteBack2Line, DeleteBackFill, DeleteBackLine, DeleteBin2Fill, DeleteBin2Line, DeleteBin3Fill, DeleteBin3Line, DeleteBin4Fill, DeleteBin4Line, DeleteBin5Fill, DeleteBin5Line, DeleteBin6Fill, DeleteBin6Line, DeleteBin7Fill, DeleteBin7Line, DeleteBinFill, DeleteBinLine, DivideFill, DivideLine, Download2Fill, Download2Line, DownloadCloud2Fill, DownloadCloud2Line, DownloadCloudFill, DownloadCloudLine, DownloadFill, DownloadLine, ErrorWarningFill, ErrorWarningLine, ExternalLinkFill, ExternalLinkLine, Eye2Fill, Eye2Line, EyeCloseFill, EyeCloseLine, EyeFill, EyeLine, EyeOffFill, EyeOffLine, Filter2Fill, Filter2Line, Filter3Fill, Filter3Line, FilterFill, FilterLine, FilterOffFill, FilterOffLine, FindReplaceFill, FindReplaceLine, Forbid2Fill, Forbid2Line, ForbidFill, ForbidLine, FunctionFill, FunctionLine, HistoryFill, HistoryLine, IndeterminateCircleFill, IndeterminateCircleLine, InformationFill, InformationLine, ListSettingsFill, ListSettingsLine, Loader2Fill, Loader2Line, Loader3Fill, Loader3Line, Loader4Fill, Loader4Line, Loader5Fill, Loader5Line, LoaderFill, LoaderLine, Lock2Fill, Lock2Line, LockFill, LockLine, LockPasswordFill, LockPasswordLine, LockUnlockFill, LockUnlockLine, LoginBoxFill, LoginBoxLine, LoginCircleFill, LoginCircleLine, LogoutBoxFill, LogoutBoxLine, LogoutBoxRFill, LogoutBoxRLine, LogoutCircleFill, LogoutCircleLine, LogoutCircleRFill, LogoutCircleRLine, Menu2Fill, Menu3Fill, Menu3Line, Menu4Fill, Menu4Line, Menu5Fill, Menu5Line, MenuAddFill, MenuAddLine, MenuFill, MenuFoldFill, MenuFoldLine, MenuLine, MenuUnfoldFill, MenuUnfoldLine, More2Fill, More2Line, MoreFill, MoreLine, NotificationBadgeFill, NotificationBadgeLine, QuestionFill, QuestionLine, RadioButtonFill, RadioButtonLine, RefreshFill, RefreshLine, Search2Fill, Search2Line, SearchEyeFill, SearchEyeLine, SearchFill, SearchLine, Settings2Fill, Settings2Line, Settings3Fill, Settings3Line, Settings4Fill, Settings4Line, Settings5Fill, Settings5Line, Settings6Fill, Settings6Line, SettingsFill, SettingsLine, ShareBoxFill, ShareBoxLine, ShareCircleFill, ShareCircleLine, ShareFill, ShareForward2Fill, ShareForward2Line, ShareForwardBoxFill, ShareForwardBoxLine, ShareForwardFill, ShareForwardLine, ShareLine, ShieldCheckFill, ShieldCheckLine, ShieldCrossFill, ShieldCrossLine, ShieldFill, ShieldFlashFill, ShieldFlashLine, ShieldKeyholeFill, ShieldKeyholeLine, ShieldLine, ShieldStarFill, ShieldStarLine, ShieldUserFill, ShieldUserLine, SideBarFill, SideBarLine, Spam2Fill, Spam2Line, Spam3Fill, Spam3Line, SpamFill, SpamLine, StarFill, StarHalfFill, StarHalfLine, StarHalfSFill, StarHalfSLine, StarLine, StarSFill, StarSLine, SubtractFill, SubtractLine, ThumbDownFill, ThumbDownLine, ThumbUpFill, ThumbUpLine, TimeFill, TimeLine, Timer2Fill, Timer2Line, TimerFill, TimerFlashFill, TimerFlashLine, TimerLine, ToggleFill, ToggleLine, Upload2Fill, Upload2Line, UploadCloud2Fill, UploadCloud2Line, UploadCloudFill, UploadCloudLine, UploadFill, UploadLine, ZoomInFill, ZoomInLine, ZoomOutFill, ZoomOutLine

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/icons/System/AddBoxFill.tsx

const SvgAddBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm7 8H7v2h4v4h2v-4h4v-2h-4V7h-2v4z"
            })
        ]
    });
/* harmony default export */ var AddBoxFill = ((/* unused pure expression or super */ null && (SvgAddBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AddBoxLine.tsx

const SvgAddBoxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5zm6 6V7h2v4h4v2h-4v4h-2v-4H7v-2h4z"
            })
        ]
    });
/* harmony default export */ var AddBoxLine = ((/* unused pure expression or super */ null && (SvgAddBoxLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/AddCircleFill.tsx

const SvgAddCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11H7v2h4v4h2v-4h4v-2h-4V7h-2v4z"
            })
        ]
    });
/* harmony default export */ var AddCircleFill = ((/* unused pure expression or super */ null && (SvgAddCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AddCircleLine.tsx

const SvgAddCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
            })
        ]
    });
/* harmony default export */ var AddCircleLine = ((/* unused pure expression or super */ null && (SvgAddCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/AddFill.tsx

const SvgAddFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"
            })
        ]
    });
/* harmony default export */ var AddFill = ((/* unused pure expression or super */ null && (SvgAddFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AddLine.tsx

const SvgAddLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"
            })
        ]
    });
/* harmony default export */ var AddLine = ((/* unused pure expression or super */ null && (SvgAddLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/AlarmFill.tsx

const SvgAlarmFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22a9 9 0 110-18 9 9 0 010 18zm1-9V8h-2v7h5v-2h-3zM1.747 6.282l3.535-3.535 1.415 1.414L3.16 7.697 1.747 6.282zm16.97-3.535l3.536 3.535-1.414 1.415-3.536-3.536 1.415-1.414z"
            })
        ]
    });
/* harmony default export */ var AlarmFill = ((/* unused pure expression or super */ null && (SvgAlarmFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AlarmLine.tsx

const SvgAlarmLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22a9 9 0 110-18 9 9 0 010 18zm0-2a7 7 0 100-14 7 7 0 000 14zm1-7h3v2h-5V8h2v5zM1.747 6.282l3.535-3.535 1.415 1.414L3.16 7.697 1.747 6.282zm16.97-3.535l3.536 3.535-1.414 1.415-3.536-3.536 1.415-1.414z"
            })
        ]
    });
/* harmony default export */ var AlarmLine = ((/* unused pure expression or super */ null && (SvgAlarmLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/AlarmWarningFill.tsx

const SvgAlarmWarningFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20v-6a8 8 0 1116 0v6h1v2H3v-2h1zm2-6h2a4 4 0 014-4V8a6 6 0 00-6 6zm5-12h2v3h-2V2zm8.778 2.808l1.414 1.414-2.12 2.121-1.415-1.414 2.121-2.121zM2.808 6.222l1.414-1.414 2.121 2.12L4.93 8.344 2.808 6.222z"
            })
        ]
    });
/* harmony default export */ var AlarmWarningFill = ((/* unused pure expression or super */ null && (SvgAlarmWarningFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AlarmWarningLine.tsx

const SvgAlarmWarningLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20v-6a8 8 0 1116 0v6h1v2H3v-2h1zm2 0h12v-6a6 6 0 10-12 0v6zm5-18h2v3h-2V2zm8.778 2.808l1.414 1.414-2.12 2.121-1.415-1.414 2.121-2.121zM2.808 6.222l1.414-1.414 2.121 2.12L4.93 8.344 2.808 6.222zM7 14a5 5 0 015-5v2a3 3 0 00-3 3H7z"
            })
        ]
    });
/* harmony default export */ var AlarmWarningLine = ((/* unused pure expression or super */ null && (SvgAlarmWarningLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/AlertFill.tsx

const SvgAlertFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.866 3l9.526 16.5a1 1 0 01-.866 1.5H2.474a1 1 0 01-.866-1.5L11.134 3a1 1 0 011.732 0zM11 16v2h2v-2h-2zm0-7v5h2V9h-2z"
            })
        ]
    });
/* harmony default export */ var AlertFill = ((/* unused pure expression or super */ null && (SvgAlertFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AlertLine.tsx

const SvgAlertLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.866 3l9.526 16.5a1 1 0 01-.866 1.5H2.474a1 1 0 01-.866-1.5L11.134 3a1 1 0 011.732 0zm-8.66 16h15.588L12 5.5 4.206 19zM11 16h2v2h-2v-2zm0-7h2v5h-2V9z"
            })
        ]
    });
/* harmony default export */ var AlertLine = ((/* unused pure expression or super */ null && (SvgAlertLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Apps2Fill.tsx

const SvgApps2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 11.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm10-10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"
            })
        ]
    });
/* harmony default export */ var Apps2Fill = ((/* unused pure expression or super */ null && (SvgApps2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Apps2Line.tsx

const SvgApps2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.5 11.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.5 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm10-10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zM6.5 9.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm.5 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm10-10a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
            })
        ]
    });
/* harmony default export */ var Apps2Line = ((/* unused pure expression or super */ null && (SvgApps2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/AppsFill.tsx

const SvgAppsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.75 2.5A4.25 4.25 0 0111 6.75V11H6.75a4.25 4.25 0 110-8.5zm0 10.5H11v4.25A4.25 4.25 0 116.75 13zm10.5-10.5a4.25 4.25 0 110 8.5H13V6.75a4.25 4.25 0 014.25-4.25zM13 13h4.25A4.25 4.25 0 1113 17.25V13z"
            })
        ]
    });
/* harmony default export */ var AppsFill = ((/* unused pure expression or super */ null && (SvgAppsFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/AppsLine.tsx

const SvgAppsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.75 2.5A4.25 4.25 0 0111 6.75V11H6.75a4.25 4.25 0 110-8.5zM9 9V6.75A2.25 2.25 0 106.75 9H9zm-2.25 4H11v4.25A4.25 4.25 0 116.75 13zm0 2A2.25 2.25 0 109 17.25V15H6.75zm10.5-12.5a4.25 4.25 0 110 8.5H13V6.75a4.25 4.25 0 014.25-4.25zm0 6.5A2.25 2.25 0 1015 6.75V9h2.25zM13 13h4.25A4.25 4.25 0 1113 17.25V13zm2 2v2.25A2.25 2.25 0 1017.25 15H15z"
            })
        ]
    });
/* harmony default export */ var AppsLine = ((/* unused pure expression or super */ null && (SvgAppsLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDownCircleFill.tsx

const SvgArrowDownCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm1 10V8h-2v4H8l4 4 4-4h-3z"
            })
        ]
    });
/* harmony default export */ var ArrowDownCircleFill = ((/* unused pure expression or super */ null && (SvgArrowDownCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDownCircleLine.tsx

const SvgArrowDownCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm1-8h3l-4 4-4-4h3V8h2v4z"
            })
        ]
    });
/* harmony default export */ var ArrowDownCircleLine = ((/* unused pure expression or super */ null && (SvgArrowDownCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDownFill.tsx

const SvgArrowDownFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 12h7l-8 8-8-8h7V4h2z"
            })
        ]
    });
/* harmony default export */ var ArrowDownFill = ((/* unused pure expression or super */ null && (SvgArrowDownFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDownLine.tsx

const SvgArrowDownLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 16.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172z"
            })
        ]
    });
/* harmony default export */ var ArrowDownLine = (SvgArrowDownLine);

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDownSFill.tsx

const SvgArrowDownSFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16l-6-6h12z"
            })
        ]
    });
/* harmony default export */ var ArrowDownSFill = ((/* unused pure expression or super */ null && (SvgArrowDownSFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDownSLine.tsx

const SvgArrowDownSLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
            })
        ]
    });
/* harmony default export */ var ArrowDownSLine = ((/* unused pure expression or super */ null && (SvgArrowDownSLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropDownFill.tsx

const SvgArrowDropDownFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14l-4-4h8z"
            })
        ]
    });
/* harmony default export */ var ArrowDropDownFill = ((/* unused pure expression or super */ null && (SvgArrowDropDownFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropDownLine.tsx

const SvgArrowDropDownLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15l-4.243-4.243 1.415-1.414L12 12.172l2.828-2.829 1.415 1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowDropDownLine = ((/* unused pure expression or super */ null && (SvgArrowDropDownLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropLeftFill.tsx

const SvgArrowDropLeftFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12l4-4v8z"
            })
        ]
    });
/* harmony default export */ var ArrowDropLeftFill = ((/* unused pure expression or super */ null && (SvgArrowDropLeftFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropLeftLine.tsx

const SvgArrowDropLeftLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.828 12l2.829 2.828-1.414 1.415L9 12l4.243-4.243 1.414 1.415L11.828 12z"
            })
        ]
    });
/* harmony default export */ var ArrowDropLeftLine = ((/* unused pure expression or super */ null && (SvgArrowDropLeftLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropRightFill.tsx

const SvgArrowDropRightFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12l-4 4V8z"
            })
        ]
    });
/* harmony default export */ var ArrowDropRightFill = ((/* unused pure expression or super */ null && (SvgArrowDropRightFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropRightLine.tsx

const SvgArrowDropRightLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z"
            })
        ]
    });
/* harmony default export */ var ArrowDropRightLine = ((/* unused pure expression or super */ null && (SvgArrowDropRightLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropUpFill.tsx

const SvgArrowDropUpFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10l4 4H8z"
            })
        ]
    });
/* harmony default export */ var ArrowDropUpFill = ((/* unused pure expression or super */ null && (SvgArrowDropUpFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowDropUpLine.tsx

const SvgArrowDropUpLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11.828l-2.828 2.829-1.415-1.414L12 9l4.243 4.243-1.415 1.414L12 11.828z"
            })
        ]
    });
/* harmony default export */ var ArrowDropUpLine = ((/* unused pure expression or super */ null && (SvgArrowDropUpLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowGoBackFill.tsx

const SvgArrowGoBackFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7v4L2 6l6-5v4h5a8 8 0 110 16H4v-2h9a6 6 0 100-12H8z"
            })
        ]
    });
/* harmony default export */ var ArrowGoBackFill = ((/* unused pure expression or super */ null && (SvgArrowGoBackFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowGoBackLine.tsx

const SvgArrowGoBackLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.828 7l2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 110 16H4v-2h9a6 6 0 100-12H5.828z"
            })
        ]
    });
/* harmony default export */ var ArrowGoBackLine = ((/* unused pure expression or super */ null && (SvgArrowGoBackLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowGoForwardFill.tsx

const SvgArrowGoForwardFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7h-5a6 6 0 100 12h9v2h-9a8 8 0 110-16h5V1l6 5-6 5V7z"
            })
        ]
    });
/* harmony default export */ var ArrowGoForwardFill = ((/* unused pure expression or super */ null && (SvgArrowGoForwardFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowGoForwardLine.tsx

const SvgArrowGoForwardLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.172 7H11a6 6 0 100 12h9v2h-9a8 8 0 110-16h7.172l-2.536-2.536L17.05 1.05 22 6l-4.95 4.95-1.414-1.414L18.172 7z"
            })
        ]
    });
/* harmony default export */ var ArrowGoForwardLine = ((/* unused pure expression or super */ null && (SvgArrowGoForwardLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftCircleFill.tsx

const SvgArrowLeftCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 9V8l-4 4 4 4v-3h4v-2h-4z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftCircleFill = ((/* unused pure expression or super */ null && (SvgArrowLeftCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftCircleLine.tsx

const SvgArrowLeftCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm0-9h4v2h-4v3l-4-4 4-4v3z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftCircleLine = ((/* unused pure expression or super */ null && (SvgArrowLeftCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftDownFill.tsx

const SvgArrowLeftDownFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.36 13.05L17.31 18H5.998V6.688l4.95 4.95 5.656-5.657 1.415 1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftDownFill = ((/* unused pure expression or super */ null && (SvgArrowLeftDownFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftDownLine.tsx

const SvgArrowLeftDownLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13.59l8.607-8.607 1.414 1.414-8.607 8.607H18v2H7v-11h2v7.585z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftDownLine = ((/* unused pure expression or super */ null && (SvgArrowLeftDownLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftFill.tsx

const SvgArrowLeftFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13v7l-8-8 8-8v7h8v2z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftFill = ((/* unused pure expression or super */ null && (SvgArrowLeftFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftLine.tsx

const SvgArrowLeftLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftLine = (SvgArrowLeftLine);

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftRightFill.tsx

const SvgArrowLeftRightFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16v-4l5 5-5 5v-4H4v-2h12zM8 2v3.999L20 6v2H8v4L3 7l5-5z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftRightFill = ((/* unused pure expression or super */ null && (SvgArrowLeftRightFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftRightLine.tsx

const SvgArrowLeftRightLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.05 12.05L21 17l-4.95 4.95-1.414-1.414 2.536-2.537L4 18v-2h13.172l-2.536-2.536 1.414-1.414zm-8.1-10l1.414 1.414L6.828 6H20v2H6.828l2.536 2.536L7.95 11.95 3 7l4.95-4.95z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftRightLine = ((/* unused pure expression or super */ null && (SvgArrowLeftRightLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftSFill.tsx

const SvgArrowLeftSFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12l6-6v12z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftSFill = ((/* unused pure expression or super */ null && (SvgArrowLeftSFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftSLine.tsx

const SvgArrowLeftSLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftSLine = ((/* unused pure expression or super */ null && (SvgArrowLeftSLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftUpFill.tsx

const SvgArrowLeftUpFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.36 10.947l5.658 5.656-1.415 1.415-5.656-5.657-4.95 4.95V5.997H17.31z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftUpFill = ((/* unused pure expression or super */ null && (SvgArrowLeftUpFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowLeftUpLine.tsx

const SvgArrowLeftUpLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.414 8l8.607 8.607-1.414 1.414L8 9.414V17H6V6h11v2z"
            })
        ]
    });
/* harmony default export */ var ArrowLeftUpLine = ((/* unused pure expression or super */ null && (SvgArrowLeftUpLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightCircleFill.tsx

const SvgArrowRightCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 9H8v2h4v3l4-4-4-4v3z"
            })
        ]
    });
/* harmony default export */ var ArrowRightCircleFill = ((/* unused pure expression or super */ null && (SvgArrowRightCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightCircleLine.tsx

const SvgArrowRightCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11V8l4 4-4 4v-3H8v-2h4zm0-9c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8z"
            })
        ]
    });
/* harmony default export */ var ArrowRightCircleLine = ((/* unused pure expression or super */ null && (SvgArrowRightCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightDownFill.tsx

const SvgArrowRightDownFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.637 13.05L5.98 7.395 7.394 5.98l5.657 5.657L18 6.687V18H6.687z"
            })
        ]
    });
/* harmony default export */ var ArrowRightDownFill = ((/* unused pure expression or super */ null && (SvgArrowRightDownFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightDownLine.tsx

const SvgArrowRightDownLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.59 16.004L5.982 7.397l1.414-1.414 8.607 8.606V7.004h2v11h-11v-2z"
            })
        ]
    });
/* harmony default export */ var ArrowRightDownLine = ((/* unused pure expression or super */ null && (SvgArrowRightDownLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightFill.tsx

const SvgArrowRightFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13H4v-2h8V4l8 8-8 8z"
            })
        ]
    });
/* harmony default export */ var ArrowRightFill = ((/* unused pure expression or super */ null && (SvgArrowRightFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightLine.tsx

const SvgArrowRightLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
            })
        ]
    });
/* harmony default export */ var ArrowRightLine = (SvgArrowRightLine);

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightSFill.tsx

const SvgArrowRightSFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12l-6 6V6z"
            })
        ]
    });
/* harmony default export */ var ArrowRightSFill = ((/* unused pure expression or super */ null && (SvgArrowRightSFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightSLine.tsx

const SvgArrowRightSLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowRightSLine = ((/* unused pure expression or super */ null && (SvgArrowRightSLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightUpFill.tsx

const SvgArrowRightUpFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.05 12.36l-5.656 5.658-1.414-1.415 5.657-5.656-4.95-4.95H18V17.31z"
            })
        ]
    });
/* harmony default export */ var ArrowRightUpFill = ((/* unused pure expression or super */ null && (SvgArrowRightUpFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowRightUpLine.tsx

const SvgArrowRightUpLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.004 9.414l-8.607 8.607-1.414-1.414L14.589 8H7.004V6h11v11h-2V9.414z"
            })
        ]
    });
/* harmony default export */ var ArrowRightUpLine = ((/* unused pure expression or super */ null && (SvgArrowRightUpLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpCircleFill.tsx

const SvgArrowUpCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm1 10h3l-4-4-4 4h3v4h2v-4z"
            })
        ]
    });
/* harmony default export */ var ArrowUpCircleFill = ((/* unused pure expression or super */ null && (SvgArrowUpCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpCircleLine.tsx

const SvgArrowUpCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm1-8v4h-2v-4H8l4-4 4 4h-3z"
            })
        ]
    });
/* harmony default export */ var ArrowUpCircleLine = ((/* unused pure expression or super */ null && (SvgArrowUpCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpDownFill.tsx

const SvgArrowUpDownFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8H8.001L8 20H6V8H2l5-5 5 5zm10 8l-5 5-5-5h4V4h2v12h4z"
            })
        ]
    });
/* harmony default export */ var ArrowUpDownFill = ((/* unused pure expression or super */ null && (SvgArrowUpDownFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpDownLine.tsx

const SvgArrowUpDownLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.95 7.95l-1.414 1.414L8 6.828V20H6V6.828L3.465 9.364 2.05 7.95 7 3l4.95 4.95zm10 8.1L17 21l-4.95-4.95 1.414-1.414 2.537 2.536L16 4h2v13.172l2.536-2.536 1.414 1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowUpDownLine = ((/* unused pure expression or super */ null && (SvgArrowUpDownLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpFill.tsx

const SvgArrowUpFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 12v8h-2v-8H4l8-8 8 8z"
            })
        ]
    });
/* harmony default export */ var ArrowUpFill = ((/* unused pure expression or super */ null && (SvgArrowUpFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpLine.tsx

const SvgArrowUpLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"
            })
        ]
    });
/* harmony default export */ var ArrowUpLine = ((/* unused pure expression or super */ null && (SvgArrowUpLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpSFill.tsx

const SvgArrowUpSFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8l6 6H6z"
            })
        ]
    });
/* harmony default export */ var ArrowUpSFill = ((/* unused pure expression or super */ null && (SvgArrowUpSFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ArrowUpSLine.tsx

const SvgArrowUpSLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"
            })
        ]
    });
/* harmony default export */ var ArrowUpSLine = ((/* unused pure expression or super */ null && (SvgArrowUpSLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckDoubleFill.tsx

const SvgCheckDoubleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.602 13.76l1.412 1.412 8.466-8.466 1.414 1.414-9.88 9.88-6.364-6.364 1.414-1.414 2.125 2.125 1.413 1.412zm.002-2.828l4.952-4.953 1.41 1.41-4.952 4.953-1.41-1.41zm-2.827 5.655L7.364 18 1 11.636l1.414-1.414 1.413 1.413-.001.001 4.951 4.951z"
            })
        ]
    });
/* harmony default export */ var CheckDoubleFill = ((/* unused pure expression or super */ null && (SvgCheckDoubleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckDoubleLine.tsx

const SvgCheckDoubleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.602 13.76l1.412 1.412 8.466-8.466 1.414 1.414-9.88 9.88-6.364-6.364 1.414-1.414 2.125 2.125 1.413 1.412zm.002-2.828l4.952-4.953 1.41 1.41-4.952 4.953-1.41-1.41zm-2.827 5.655L7.364 18 1 11.636l1.414-1.414 1.413 1.413-.001.001 4.951 4.951z"
            })
        ]
    });
/* harmony default export */ var CheckDoubleLine = ((/* unused pure expression or super */ null && (SvgCheckDoubleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckFill.tsx

const SvgCheckFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
            })
        ]
    });
/* harmony default export */ var CheckFill = ((/* unused pure expression or super */ null && (SvgCheckFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckLine.tsx

const SvgCheckLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
            })
        ]
    });
/* harmony default export */ var CheckLine = ((/* unused pure expression or super */ null && (SvgCheckLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxBlankCircleFill.tsx

const SvgCheckboxBlankCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: 12,
                cy: 12,
                r: 10
            })
        ]
    });
/* harmony default export */ var CheckboxBlankCircleFill = ((/* unused pure expression or super */ null && (SvgCheckboxBlankCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxBlankCircleLine.tsx

const SvgCheckboxBlankCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
            })
        ]
    });
/* harmony default export */ var CheckboxBlankCircleLine = ((/* unused pure expression or super */ null && (SvgCheckboxBlankCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxBlankFill.tsx

const SvgCheckboxBlankFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z"
            })
        ]
    });
/* harmony default export */ var CheckboxBlankFill = ((/* unused pure expression or super */ null && (SvgCheckboxBlankFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxBlankLine.tsx

const SvgCheckboxBlankLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5z"
            })
        ]
    });
/* harmony default export */ var CheckboxBlankLine = ((/* unused pure expression or super */ null && (SvgCheckboxBlankLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxCircleFill.tsx

const SvgCheckboxCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
            })
        ]
    });
/* harmony default export */ var CheckboxCircleFill = ((/* unused pure expression or super */ null && (SvgCheckboxCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxCircleLine.tsx

const SvgCheckboxCircleLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z"
            })
        ]
    });
/* harmony default export */ var CheckboxCircleLine = (SvgCheckboxCircleLine);

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxFill.tsx

const SvgCheckboxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm7.003 13l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
            })
        ]
    });
/* harmony default export */ var CheckboxFill = ((/* unused pure expression or super */ null && (SvgCheckboxFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxIndeterminateFill.tsx

const SvgCheckboxIndeterminateFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm3 8v2h10v-2H7z"
            })
        ]
    });
/* harmony default export */ var CheckboxIndeterminateFill = ((/* unused pure expression or super */ null && (SvgCheckboxIndeterminateFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxIndeterminateLine.tsx

const SvgCheckboxIndeterminateLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5zm2 6h10v2H7v-2z"
            })
        ]
    });
/* harmony default export */ var CheckboxIndeterminateLine = ((/* unused pure expression or super */ null && (SvgCheckboxIndeterminateLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxLine.tsx

const SvgCheckboxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5zm6.003 11L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z"
            })
        ]
    });
/* harmony default export */ var CheckboxLine = ((/* unused pure expression or super */ null && (SvgCheckboxLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxMultipleBlankFill.tsx

const SvgCheckboxMultipleBlankFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7V3a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 012 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3z"
            })
        ]
    });
/* harmony default export */ var CheckboxMultipleBlankFill = ((/* unused pure expression or super */ null && (SvgCheckboxMultipleBlankFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxMultipleBlankLine.tsx

const SvgCheckboxMultipleBlankLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7V3a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 012 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z"
            })
        ]
    });
/* harmony default export */ var CheckboxMultipleBlankLine = ((/* unused pure expression or super */ null && (SvgCheckboxMultipleBlankLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxMultipleFill.tsx

const SvgCheckboxMultipleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7V3a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 012 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zm-.497 11l5.656-5.657-1.414-1.414-4.242 4.243L6.38 13.05l-1.414 1.414L8.503 18z"
            })
        ]
    });
/* harmony default export */ var CheckboxMultipleFill = ((/* unused pure expression or super */ null && (SvgCheckboxMultipleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CheckboxMultipleLine.tsx

const SvgCheckboxMultipleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7V3a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 012 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zm6 2H4.003L4 20h11V9zm-6.497 9l-3.536-3.536 1.414-1.414 2.122 2.122 4.242-4.243 1.414 1.414L8.503 18z"
            })
        ]
    });
/* harmony default export */ var CheckboxMultipleLine = ((/* unused pure expression or super */ null && (SvgCheckboxMultipleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/CloseCircleFill.tsx

const SvgCloseCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"
            })
        ]
    });
/* harmony default export */ var CloseCircleFill = ((/* unused pure expression or super */ null && (SvgCloseCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CloseCircleLine.tsx

const SvgCloseCircleLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
            })
        ]
    });
/* harmony default export */ var CloseCircleLine = (SvgCloseCircleLine);

;// CONCATENATED MODULE: ./src/components/icons/System/CloseFill.tsx

const SvgCloseFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
            })
        ]
    });
/* harmony default export */ var CloseFill = ((/* unused pure expression or super */ null && (SvgCloseFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/CloseLine.tsx

const SvgCloseLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
            })
        ]
    });
/* harmony default export */ var CloseLine = (SvgCloseLine);

;// CONCATENATED MODULE: ./src/components/icons/System/DashboardFill.tsx

const SvgDashboardFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
            })
        ]
    });
/* harmony default export */ var DashboardFill = ((/* unused pure expression or super */ null && (SvgDashboardFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DashboardLine.tsx

const SvgDashboardLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 21V11h8v10h-8zM3 13V3h8v10H3zm6-2V5H5v6h4zM3 21v-6h8v6H3zm2-2h4v-2H5v2zm10 0h4v-6h-4v6zM13 3h8v6h-8V3zm2 2v2h4V5h-4z"
            })
        ]
    });
/* harmony default export */ var DashboardLine = ((/* unused pure expression or super */ null && (SvgDashboardLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBack2Fill.tsx

const SvgDeleteBack2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.535 3H21a1 1 0 011 1v16a1 1 0 01-1 1H6.535a1 1 0 01-.832-.445l-5.333-8a1 1 0 010-1.11l5.333-8A1 1 0 016.535 3zM13 10.586l-2.828-2.829-1.415 1.415L11.586 12l-2.829 2.828 1.415 1.415L13 13.414l2.828 2.829 1.415-1.415L14.414 12l2.829-2.828-1.415-1.415L13 10.586z"
            })
        ]
    });
/* harmony default export */ var DeleteBack2Fill = ((/* unused pure expression or super */ null && (SvgDeleteBack2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBack2Line.tsx

const SvgDeleteBack2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.535 3H21a1 1 0 011 1v16a1 1 0 01-1 1H6.535a1 1 0 01-.832-.445l-5.333-8a1 1 0 010-1.11l5.333-8A1 1 0 016.535 3zm.535 2l-4.666 7 4.666 7H20V5H7.07zM13 10.586l2.828-2.829 1.415 1.415L14.414 12l2.829 2.828-1.415 1.415L13 13.414l-2.828 2.829-1.415-1.415L11.586 12 8.757 9.172l1.415-1.415L13 10.586z"
            })
        ]
    });
/* harmony default export */ var DeleteBack2Line = ((/* unused pure expression or super */ null && (SvgDeleteBack2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBackFill.tsx

const SvgDeleteBackFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.535 3H21a1 1 0 011 1v16a1 1 0 01-1 1H6.535a1 1 0 01-.832-.445l-5.333-8a1 1 0 010-1.11l5.333-8A1 1 0 016.535 3zM16 11H9v2h7v-2z"
            })
        ]
    });
/* harmony default export */ var DeleteBackFill = ((/* unused pure expression or super */ null && (SvgDeleteBackFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBackLine.tsx

const SvgDeleteBackLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.535 3H21a1 1 0 011 1v16a1 1 0 01-1 1H6.535a1 1 0 01-.832-.445l-5.333-8a1 1 0 010-1.11l5.333-8A1 1 0 016.535 3zm.535 2l-4.666 7 4.666 7H20V5H7.07zM16 11v2H9v-2h7z"
            })
        ]
    });
/* harmony default export */ var DeleteBackLine = ((/* unused pure expression or super */ null && (SvgDeleteBackLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin2Fill.tsx

const SvgDeleteBin2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 6V3a1 1 0 011-1h8a1 1 0 011 1v3h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5zm6.414 8l1.768-1.768-1.414-1.414L12 12.586l-1.768-1.768-1.414 1.414L10.586 14l-1.768 1.768 1.414 1.414L12 15.414l1.768 1.768 1.414-1.414L13.414 14zM9 4v2h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBin2Fill = ((/* unused pure expression or super */ null && (SvgDeleteBin2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin2Line.tsx

const SvgDeleteBin2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5V3a1 1 0 011-1h8a1 1 0 011 1v3zm1 2H6v12h12V8zm-4.586 6l1.768 1.768-1.414 1.414L12 15.414l-1.768 1.768-1.414-1.414L10.586 14l-1.768-1.768 1.414-1.414L12 12.586l1.768-1.768 1.414 1.414L13.414 14zM9 4v2h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBin2Line = ((/* unused pure expression or super */ null && (SvgDeleteBin2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin3Fill.tsx

const SvgDeleteBin3Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7v14a1 1 0 01-1 1H5a1 1 0 01-1-1V7H2V5h20v2h-2zm-9 2v2h2V9h-2zm0 3v2h2v-2h-2zm0 3v2h2v-2h-2zM7 2h10v2H7V2z"
            })
        ]
    });
/* harmony default export */ var DeleteBin3Fill = ((/* unused pure expression or super */ null && (SvgDeleteBin3Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin3Line.tsx

const SvgDeleteBin3Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7v13a2 2 0 01-2 2H6a2 2 0 01-2-2V7H2V5h20v2h-2zM6 7v13h12V7H6zm5 2h2v2h-2V9zm0 3h2v2h-2v-2zm0 3h2v2h-2v-2zM7 2h10v2H7V2z"
            })
        ]
    });
/* harmony default export */ var DeleteBin3Line = ((/* unused pure expression or super */ null && (SvgDeleteBin3Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin4Fill.tsx

const SvgDeleteBin4Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7v14a1 1 0 01-1 1H5a1 1 0 01-1-1V7H2V5h20v2h-2zm-9 3v7h2v-7h-2zM7 2h10v2H7V2z"
            })
        ]
    });
/* harmony default export */ var DeleteBin4Fill = ((/* unused pure expression or super */ null && (SvgDeleteBin4Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin4Line.tsx

const SvgDeleteBin4Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7v14a1 1 0 01-1 1H5a1 1 0 01-1-1V7H2V5h20v2h-2zM6 7v13h12V7H6zm1-5h10v2H7V2zm4 8h2v7h-2v-7z"
            })
        ]
    });
/* harmony default export */ var DeleteBin4Line = ((/* unused pure expression or super */ null && (SvgDeleteBin4Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin5Fill.tsx

const SvgDeleteBin5Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8h16v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8zm3-3V3a1 1 0 011-1h8a1 1 0 011 1v2h5v2H2V5h5zm2-1v1h6V4H9zm0 8v6h2v-6H9zm4 0v6h2v-6h-2z"
            })
        ]
    });
/* harmony default export */ var DeleteBin5Fill = ((/* unused pure expression or super */ null && (SvgDeleteBin5Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin5Line.tsx

const SvgDeleteBin5Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8h16v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8zm2 2v10h12V10H6zm3 2h2v6H9v-6zm4 0h2v6h-2v-6zM7 5V3a1 1 0 011-1h8a1 1 0 011 1v2h5v2H2V5h5zm2-1v1h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBin5Line = ((/* unused pure expression or super */ null && (SvgDeleteBin5Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin6Fill.tsx

const SvgDeleteBin6Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 4h5v2h-2v15a1 1 0 01-1 1H5a1 1 0 01-1-1V6H2V4h5V2h10v2zM9 9v8h2V9H9zm4 0v8h2V9h-2z"
            })
        ]
    });
/* harmony default export */ var DeleteBin6Fill = ((/* unused pure expression or super */ null && (SvgDeleteBin6Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin6Line.tsx

const SvgDeleteBin6Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4V2h10v2h5v2h-2v15a1 1 0 01-1 1H5a1 1 0 01-1-1V6H2V4h5zM6 6v14h12V6H6zm3 3h2v8H9V9zm4 0h2v8h-2V9z"
            })
        ]
    });
/* harmony default export */ var DeleteBin6Line = ((/* unused pure expression or super */ null && (SvgDeleteBin6Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin7Fill.tsx

const SvgDeleteBin7Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 6V3a1 1 0 011-1h8a1 1 0 011 1v3h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5zm2-2v2h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBin7Fill = ((/* unused pure expression or super */ null && (SvgDeleteBin7Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBin7Line.tsx

const SvgDeleteBin7Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5V3a1 1 0 011-1h8a1 1 0 011 1v3zm1 2H6v12h12V8zM9 4v2h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBin7Line = ((/* unused pure expression or super */ null && (SvgDeleteBin7Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBinFill.tsx

const SvgDeleteBinFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5V3a1 1 0 011-1h8a1 1 0 011 1v3zm-8 5v6h2v-6H9zm4 0v6h2v-6h-2zM9 4v2h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBinFill = ((/* unused pure expression or super */ null && (SvgDeleteBinFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DeleteBinLine.tsx

const SvgDeleteBinLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5V3a1 1 0 011-1h8a1 1 0 011 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z"
            })
        ]
    });
/* harmony default export */ var DeleteBinLine = ((/* unused pure expression or super */ null && (SvgDeleteBinLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/DivideFill.tsx

const SvgDivideFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 11h14v2H5v-2zm7-3a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
            })
        ]
    });
/* harmony default export */ var DivideFill = ((/* unused pure expression or super */ null && (SvgDivideFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DivideLine.tsx

const SvgDivideLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 11h14v2H5v-2zm7-3a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
            })
        ]
    });
/* harmony default export */ var DivideLine = ((/* unused pure expression or super */ null && (SvgDivideLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Download2Fill.tsx

const SvgDownload2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19h16v-7h2v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8h2v7zM14 9h5l-7 7-7-7h5V3h4v6z"
            })
        ]
    });
/* harmony default export */ var Download2Fill = ((/* unused pure expression or super */ null && (SvgDownload2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Download2Line.tsx

const SvgDownload2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 10h5l-6 6-6-6h5V3h2v7zm-9 9h16v-7h2v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8h2v7z"
            })
        ]
    });
/* harmony default export */ var Download2Line = ((/* unused pure expression or super */ null && (SvgDownload2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DownloadCloud2Fill.tsx

const SvgDownloadCloud2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 13v5.585l1.828-1.828 1.415 1.415L12 22.414l-4.243-4.242 1.415-1.415L11 18.585V13h2zM12 2a7.001 7.001 0 016.954 6.194 5.5 5.5 0 01-.953 10.784L18 17a6 6 0 00-11.996-.225L6 17v1.978a5.5 5.5 0 01-.954-10.784A7 7 0 0112 2z"
            })
        ]
    });
/* harmony default export */ var DownloadCloud2Fill = ((/* unused pure expression or super */ null && (SvgDownloadCloud2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DownloadCloud2Line.tsx

const SvgDownloadCloud2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 13v5.585l1.828-1.828 1.415 1.415L12 22.414l-4.243-4.242 1.415-1.415L11 18.585V13h2zM12 2a7.001 7.001 0 016.954 6.194 5.5 5.5 0 01-.953 10.784v-2.014a3.5 3.5 0 10-1.112-6.91 5 5 0 10-9.777 0 3.5 3.5 0 00-1.292 6.88l.18.03v2.014a5.5 5.5 0 01-.954-10.784A7 7 0 0112 2z"
            })
        ]
    });
/* harmony default export */ var DownloadCloud2Line = ((/* unused pure expression or super */ null && (SvgDownloadCloud2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/DownloadCloudFill.tsx

const SvgDownloadCloudFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20.981a6.5 6.5 0 01-2.936-12 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12V21H7v-.019zM13 12V8h-2v4H8l4 5 4-5h-3z"
            })
        ]
    });
/* harmony default export */ var DownloadCloudFill = ((/* unused pure expression or super */ null && (SvgDownloadCloudFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DownloadCloudLine.tsx

const SvgDownloadCloudLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1 14.5a6.496 6.496 0 013.064-5.519 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 002.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 00-11.903 0l-.12.942-.805.503a4.5 4.5 0 002.029 8.309l.173.013h9.35l.173-.013zM13 12h3l-4 5-4-5h3V8h2v4z"
            })
        ]
    });
/* harmony default export */ var DownloadCloudLine = ((/* unused pure expression or super */ null && (SvgDownloadCloudLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/DownloadFill.tsx

const SvgDownloadFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 19h18v2H3v-2zM13 9h7l-8 8-8-8h7V1h2v8z"
            })
        ]
    });
/* harmony default export */ var DownloadFill = ((/* unused pure expression or super */ null && (SvgDownloadFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/DownloadLine.tsx

const SvgDownloadLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z"
            })
        ]
    });
/* harmony default export */ var DownloadLine = ((/* unused pure expression or super */ null && (SvgDownloadLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ErrorWarningFill.tsx

const SvgErrorWarningFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z"
            })
        ]
    });
/* harmony default export */ var ErrorWarningFill = ((/* unused pure expression or super */ null && (SvgErrorWarningFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ErrorWarningLine.tsx

const SvgErrorWarningLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z"
            })
        ]
    });
/* harmony default export */ var ErrorWarningLine = ((/* unused pure expression or super */ null && (SvgErrorWarningLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ExternalLinkFill.tsx

const SvgExternalLinkFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v9l-3.794-3.793-5.999 6-1.414-1.414 5.999-6L12 3h9z"
            })
        ]
    });
/* harmony default export */ var ExternalLinkFill = ((/* unused pure expression or super */ null && (SvgExternalLinkFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ExternalLinkLine.tsx

const SvgExternalLinkLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z"
            })
        ]
    });
/* harmony default export */ var ExternalLinkLine = ((/* unused pure expression or super */ null && (SvgExternalLinkLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Eye2Fill.tsx

const SvgEye2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 5a5.01 5.01 0 00-1.473.22 2.5 2.5 0 11-3.306 3.307A5 5 0 1012 7z"
            })
        ]
    });
/* harmony default export */ var Eye2Fill = ((/* unused pure expression or super */ null && (SvgEye2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Eye2Line.tsx

const SvgEye2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 3a5 5 0 11-4.78 3.527A2.499 2.499 0 0012 9.5a2.5 2.5 0 00-1.473-2.28A5.01 5.01 0 0112 7z"
            })
        ]
    });
/* harmony default export */ var Eye2Line = ((/* unused pure expression or super */ null && (SvgEye2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/EyeCloseFill.tsx

const SvgEyeCloseFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.13 15.842l-.788 2.94-1.931-.518.787-2.939a10.988 10.988 0 01-3.237-1.872l-2.153 2.154-1.415-1.415 2.154-2.153a10.957 10.957 0 01-2.371-5.07l.9-.165A16.923 16.923 0 0012 10c3.704 0 7.131-1.185 9.924-3.196l.9.164a10.957 10.957 0 01-2.37 5.071l2.153 2.153-1.415 1.415-2.153-2.154a10.988 10.988 0 01-3.237 1.872l.787 2.94-1.931.517-.788-2.94a11.072 11.072 0 01-3.74 0z"
            })
        ]
    });
/* harmony default export */ var EyeCloseFill = ((/* unused pure expression or super */ null && (SvgEyeCloseFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/EyeCloseLine.tsx

const SvgEyeCloseLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.342 18.782l-1.931-.518.787-2.939a10.988 10.988 0 01-3.237-1.872l-2.153 2.154-1.415-1.415 2.154-2.153a10.957 10.957 0 01-2.371-5.07l1.968-.359C3.903 10.812 7.579 14 12 14c4.42 0 8.097-3.188 8.856-7.39l1.968.358a10.957 10.957 0 01-2.37 5.071l2.153 2.153-1.415 1.415-2.153-2.154a10.988 10.988 0 01-3.237 1.872l.787 2.94-1.931.517-.788-2.94a11.072 11.072 0 01-3.74 0l-.788 2.94z"
            })
        ]
    });
/* harmony default export */ var EyeCloseLine = ((/* unused pure expression or super */ null && (SvgEyeCloseLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/EyeFill.tsx

const SvgEyeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.181 12C2.121 6.88 6.608 3 12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9zM12 17a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z"
            })
        ]
    });
/* harmony default export */ var EyeFill = ((/* unused pure expression or super */ null && (SvgEyeFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/EyeLine.tsx

const SvgEyeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16a9.005 9.005 0 008.777-7 9.005 9.005 0 00-17.554 0A9.005 9.005 0 0012 19zm0-2.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-2a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
            })
        ]
    });
/* harmony default export */ var EyeLine = ((/* unused pure expression or super */ null && (SvgEyeLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/EyeOffFill.tsx

const SvgEyeOffFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.52 5.934L1.393 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31A10.949 10.949 0 0112 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 013.34-6.066zm10.237 10.238l-1.464-1.464a3 3 0 01-4.001-4.001L7.828 9.243a5 5 0 006.929 6.929zM7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 01-2.012 4.592l-3.86-3.86a5 5 0 00-5.68-5.68L7.974 3.761z"
            })
        ]
    });
/* harmony default export */ var EyeOffFill = ((/* unused pure expression or super */ null && (SvgEyeOffFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/EyeOffLine.tsx

const SvgEyeOffLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.882 19.297A10.949 10.949 0 0112 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 013.34-6.066L1.392 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31zM5.935 7.35A8.965 8.965 0 003.223 12a9.005 9.005 0 0013.201 5.838l-2.028-2.028A4.5 4.5 0 018.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 003.241 3.241zm7.893 2.264l-1.431-1.43A8.935 8.935 0 0020.777 12 9.005 9.005 0 009.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 01-2.012 4.592zm-9.084-9.084a4.5 4.5 0 014.769 4.769l-4.77-4.769z"
            })
        ]
    });
/* harmony default export */ var EyeOffLine = ((/* unused pure expression or super */ null && (SvgEyeOffLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Filter2Fill.tsx

const SvgFilter2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14L4 5V3h16v2l-6 9v6l-4 2z"
            })
        ]
    });
/* harmony default export */ var Filter2Fill = ((/* unused pure expression or super */ null && (SvgFilter2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Filter2Line.tsx

const SvgFilter2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 14v6l-4 2v-8L4 5V3h16v2l-6 9zM6.404 5L12 13.394 17.596 5H6.404z"
            })
        ]
    });
/* harmony default export */ var Filter2Line = ((/* unused pure expression or super */ null && (SvgFilter2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Filter3Fill.tsx

const SvgFilter3Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
            })
        ]
    });
/* harmony default export */ var Filter3Fill = ((/* unused pure expression or super */ null && (SvgFilter3Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Filter3Line.tsx

const SvgFilter3Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
            })
        ]
    });
/* harmony default export */ var Filter3Line = ((/* unused pure expression or super */ null && (SvgFilter3Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/FilterFill.tsx

const SvgFilterFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 4v2h-1l-6 9v7h-4v-7L4 6H3V4z"
            })
        ]
    });
/* harmony default export */ var FilterFill = ((/* unused pure expression or super */ null && (SvgFilterFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/FilterLine.tsx

const SvgFilterLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 4v2h-1l-5 7.5V22H9v-8.5L4 6H3V4h18zM6.404 6L11 12.894V20h2v-7.106L17.596 6H6.404z"
            })
        ]
    });
/* harmony default export */ var FilterLine = ((/* unused pure expression or super */ null && (SvgFilterLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/FilterOffFill.tsx

const SvgFilterOffFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.929.515L21.07 14.657l-1.414 1.414-3.823-3.822L14 15v7h-4v-7L4 6H3V4h4.585l-2.07-2.071L6.929.515zM21 4v2h-1l-1.915 2.872L13.213 4H21z"
            })
        ]
    });
/* harmony default export */ var FilterOffFill = ((/* unused pure expression or super */ null && (SvgFilterOffFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/FilterOffLine.tsx

const SvgFilterOffLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.929.515L21.07 14.657l-1.414 1.414-3.823-3.822L15 13.5V22H9v-8.5L4 6H3V4h4.585l-2.07-2.071L6.929.515zM9.585 6H6.404L11 12.894V20h2v-7.106l1.392-2.087L9.585 6zM21 4v2h-1l-1.915 2.872-1.442-1.443L17.596 6h-2.383l-2-2H21z"
            })
        ]
    });
/* harmony default export */ var FilterOffLine = ((/* unused pure expression or super */ null && (SvgFilterOffLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/FindReplaceFill.tsx

const SvgFindReplaceFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zM16.659 9A6 6 0 0011 5c-3.315 0-6 2.685-6 6h2a4.001 4.001 0 015.91-3.515L12 9h4.659zM17 11h-2a4.001 4.001 0 01-5.91 3.515L10 13H5.341A6 6 0 0011 17c3.315 0 6-2.685 6-6z"
            })
        ]
    });
/* harmony default export */ var FindReplaceFill = ((/* unused pure expression or super */ null && (SvgFindReplaceFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/FindReplaceLine.tsx

const SvgFindReplaceLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.033 16.618l4.28 4.281-1.414 1.415-4.28-4.281A8.963 8.963 0 0111 20a8.998 8.998 0 01-8.065-5H9l-1.304 2.173A6.972 6.972 0 0011 18a6.977 6.977 0 004.875-1.975l.15-.15A6.977 6.977 0 0018 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.963 8.963 0 01-1.967 5.618zM19.065 7H13l1.304-2.173A6.972 6.972 0 0011 4c-3.868 0-7 3.132-7 7 0 .695.101 1.366.29 2H2.223A9.038 9.038 0 012 11c0-4.973 4.027-9 9-9a8.998 8.998 0 018.065 5z"
            })
        ]
    });
/* harmony default export */ var FindReplaceLine = ((/* unused pure expression or super */ null && (SvgFindReplaceLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Forbid2Fill.tsx

const SvgForbid2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.891-13.477a6.04 6.04 0 00-1.414-1.414l-8.368 8.368a6.04 6.04 0 001.414 1.414l8.368-8.368z"
            })
        ]
    });
/* harmony default export */ var Forbid2Fill = ((/* unused pure expression or super */ null && (SvgForbid2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Forbid2Line.tsx

const SvgForbid2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm4.891-11.477l-8.368 8.368a6.04 6.04 0 01-1.414-1.414l8.368-8.368a6.04 6.04 0 011.414 1.414z"
            })
        ]
    });
/* harmony default export */ var Forbid2Line = ((/* unused pure expression or super */ null && (SvgForbid2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/ForbidFill.tsx

const SvgForbidFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM8.523 7.109A6.04 6.04 0 007.11 8.523l8.368 8.368a6.04 6.04 0 001.414-1.414L8.523 7.109z"
            })
        ]
    });
/* harmony default export */ var ForbidFill = ((/* unused pure expression or super */ null && (SvgForbidFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ForbidLine.tsx

const SvgForbidLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zM8.523 7.109l8.368 8.368a6.04 6.04 0 01-1.414 1.414L7.109 8.523A6.04 6.04 0 018.523 7.11z"
            })
        ]
    });
/* harmony default export */ var ForbidLine = ((/* unused pure expression or super */ null && (SvgForbidLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/FunctionFill.tsx

const SvgFunctionFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8z"
            })
        ]
    });
/* harmony default export */ var FunctionFill = ((/* unused pure expression or super */ null && (SvgFunctionFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/FunctionLine.tsx

const SvgFunctionLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"
            })
        ]
    });
/* harmony default export */ var FunctionLine = ((/* unused pure expression or super */ null && (SvgFunctionLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/HistoryFill.tsx

const SvgHistoryFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 101.865-5.135L8 9H2V3l2.447 2.446A9.98 9.98 0 0112 2zm1 5v4.585l3.243 3.243-1.415 1.415L11 12.413V7h2z"
            })
        ]
    });
/* harmony default export */ var HistoryFill = ((/* unused pure expression or super */ null && (SvgHistoryFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/HistoryLine.tsx

const SvgHistoryLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 101.385-4.5H8v2H2v-6h2V6a9.98 9.98 0 018-4zm1 5v4.585l3.243 3.243-1.415 1.415L11 12.413V7h2z"
            })
        ]
    });
/* harmony default export */ var HistoryLine = ((/* unused pure expression or super */ null && (SvgHistoryLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/IndeterminateCircleFill.tsx

const SvgIndeterminateCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11v2h10v-2H7z"
            })
        ]
    });
/* harmony default export */ var IndeterminateCircleFill = ((/* unused pure expression or super */ null && (SvgIndeterminateCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/IndeterminateCircleLine.tsx

const SvgIndeterminateCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-5-9h10v2H7v-2z"
            })
        ]
    });
/* harmony default export */ var IndeterminateCircleLine = ((/* unused pure expression or super */ null && (SvgIndeterminateCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/InformationFill.tsx

const SvgInformationFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z"
            })
        ]
    });
/* harmony default export */ var InformationFill = ((/* unused pure expression or super */ null && (SvgInformationFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/InformationLine.tsx

const SvgInformationLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"
            })
        ]
    });
/* harmony default export */ var InformationLine = ((/* unused pure expression or super */ null && (SvgInformationLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ListSettingsFill.tsx

const SvgListSettingsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h7v2H2v-2zm0-7h9v2H2v-2zm0-7h20v2H2V4zm18.674 9.025l1.156-.391 1 1.732-.916.805a4.017 4.017 0 010 1.658l.916.805-1 1.732-1.156-.391c-.41.37-.898.655-1.435.83L19 21h-2l-.24-1.196a3.996 3.996 0 01-1.434-.83l-1.156.392-1-1.732.916-.805a4.017 4.017 0 010-1.658l-.916-.805 1-1.732 1.156.391c.41-.37.898-.655 1.435-.83L17 11h2l.24 1.196c.536.174 1.024.46 1.434.83zM18 17a1 1 0 100-2 1 1 0 000 2z"
            })
        ]
    });
/* harmony default export */ var ListSettingsFill = ((/* unused pure expression or super */ null && (SvgListSettingsFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ListSettingsLine.tsx

const SvgListSettingsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h7v2H2v-2zm0-7h9v2H2v-2zm0-7h20v2H2V4zm18.674 9.025l1.156-.391 1 1.732-.916.805a4.017 4.017 0 010 1.658l.916.805-1 1.732-1.156-.391c-.41.37-.898.655-1.435.83L19 21h-2l-.24-1.196a3.996 3.996 0 01-1.434-.83l-1.156.392-1-1.732.916-.805a4.017 4.017 0 010-1.658l-.916-.805 1-1.732 1.156.391c.41-.37.898-.655 1.435-.83L17 11h2l.24 1.196c.536.174 1.024.46 1.434.83zM18 18a2 2 0 100-4 2 2 0 000 4z"
            })
        ]
    });
/* harmony default export */ var ListSettingsLine = ((/* unused pure expression or super */ null && (SvgListSettingsLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader2Fill.tsx

const SvgLoader2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a1 1 0 011 1v3a1 1 0 01-2 0V3a1 1 0 011-1zm0 15a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm10-5a1 1 0 01-1 1h-3a1 1 0 010-2h3a1 1 0 011 1zM7 12a1 1 0 01-1 1H3a1 1 0 010-2h3a1 1 0 011 1zm12.071 7.071a1 1 0 01-1.414 0l-2.121-2.121a1 1 0 011.414-1.414l2.121 2.12a1 1 0 010 1.415zM8.464 8.464a1 1 0 01-1.414 0l-2.12-2.12a1 1 0 011.414-1.415l2.12 2.121a1 1 0 010 1.414zM4.93 19.071a1 1 0 010-1.414l2.121-2.121a1 1 0 111.414 1.414l-2.12 2.121a1 1 0 01-1.415 0zM15.536 8.464a1 1 0 010-1.414l2.12-2.121a1 1 0 011.415 1.414L16.95 8.464a1 1 0 01-1.414 0z"
            })
        ]
    });
/* harmony default export */ var Loader2Fill = ((/* unused pure expression or super */ null && (SvgLoader2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader2Line.tsx

const SvgLoader2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a1 1 0 011 1v3a1 1 0 01-2 0V3a1 1 0 011-1zm0 15a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm10-5a1 1 0 01-1 1h-3a1 1 0 010-2h3a1 1 0 011 1zM7 12a1 1 0 01-1 1H3a1 1 0 010-2h3a1 1 0 011 1zm12.071 7.071a1 1 0 01-1.414 0l-2.121-2.121a1 1 0 011.414-1.414l2.121 2.12a1 1 0 010 1.415zM8.464 8.464a1 1 0 01-1.414 0l-2.12-2.12a1 1 0 011.414-1.415l2.12 2.121a1 1 0 010 1.414zM4.93 19.071a1 1 0 010-1.414l2.121-2.121a1 1 0 111.414 1.414l-2.12 2.121a1 1 0 01-1.415 0zM15.536 8.464a1 1 0 010-1.414l2.12-2.121a1 1 0 011.415 1.414L16.95 8.464a1 1 0 01-1.414 0z"
            })
        ]
    });
/* harmony default export */ var Loader2Line = ((/* unused pure expression or super */ null && (SvgLoader2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader3Fill.tsx

const SvgLoader3Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.055 13H5.07a7.002 7.002 0 0013.858 0h2.016a9.001 9.001 0 01-17.89 0zm0-2a9.001 9.001 0 0117.89 0H18.93a7.002 7.002 0 00-13.858 0H3.055z"
            })
        ]
    });
/* harmony default export */ var Loader3Fill = ((/* unused pure expression or super */ null && (SvgLoader3Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader3Line.tsx

const SvgLoader3Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.055 13H5.07a7.002 7.002 0 0013.858 0h2.016a9.001 9.001 0 01-17.89 0zm0-2a9.001 9.001 0 0117.89 0H18.93a7.002 7.002 0 00-13.858 0H3.055z"
            })
        ]
    });
/* harmony default export */ var Loader3Line = ((/* unused pure expression or super */ null && (SvgLoader3Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader4Fill.tsx

const SvgLoader4Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.364 5.636L16.95 7.05A7 7 0 1019 12h2a9 9 0 11-2.636-6.364z"
            })
        ]
    });
/* harmony default export */ var Loader4Fill = ((/* unused pure expression or super */ null && (SvgLoader4Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader4Line.tsx

const SvgLoader4Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.364 5.636L16.95 7.05A7 7 0 1019 12h2a9 9 0 11-2.636-6.364z"
            })
        ]
    });
/* harmony default export */ var Loader4Line = ((/* unused pure expression or super */ null && (SvgLoader4Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader5Fill.tsx

const SvgLoader5Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3a9 9 0 019 9h-2a7 7 0 00-7-7V3z"
            })
        ]
    });
/* harmony default export */ var Loader5Fill = ((/* unused pure expression or super */ null && (SvgLoader5Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Loader5Line.tsx

const SvgLoader5Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3a9 9 0 019 9h-2a7 7 0 00-7-7V3z"
            })
        ]
    });
/* harmony default export */ var Loader5Line = ((/* unused pure expression or super */ null && (SvgLoader5Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/LoaderFill.tsx

const SvgLoaderFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a1 1 0 011 1v3a1 1 0 01-2 0V3a1 1 0 011-1zm0 15a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm8.66-10a1 1 0 01-.366 1.366l-2.598 1.5a1 1 0 11-1-1.732l2.598-1.5A1 1 0 0120.66 7zM7.67 14.5a1 1 0 01-.366 1.366l-2.598 1.5a1 1 0 11-1-1.732l2.598-1.5a1 1 0 011.366.366zM20.66 17a1 1 0 01-1.366.366l-2.598-1.5a1 1 0 011-1.732l2.598 1.5A1 1 0 0120.66 17zM7.67 9.5a1 1 0 01-1.366.366l-2.598-1.5a1 1 0 111-1.732l2.598 1.5A1 1 0 017.67 9.5z"
            })
        ]
    });
/* harmony default export */ var LoaderFill = ((/* unused pure expression or super */ null && (SvgLoaderFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LoaderLine.tsx

const SvgLoaderLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a1 1 0 011 1v3a1 1 0 01-2 0V3a1 1 0 011-1zm0 15a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm8.66-10a1 1 0 01-.366 1.366l-2.598 1.5a1 1 0 11-1-1.732l2.598-1.5A1 1 0 0120.66 7zM7.67 14.5a1 1 0 01-.366 1.366l-2.598 1.5a1 1 0 11-1-1.732l2.598-1.5a1 1 0 011.366.366zM20.66 17a1 1 0 01-1.366.366l-2.598-1.5a1 1 0 011-1.732l2.598 1.5A1 1 0 0120.66 17zM7.67 9.5a1 1 0 01-1.366.366l-2.598-1.5a1 1 0 111-1.732l2.598 1.5A1 1 0 017.67 9.5z"
            })
        ]
    });
/* harmony default export */ var LoaderLine = ((/* unused pure expression or super */ null && (SvgLoaderLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Lock2Fill.tsx

const SvgLock2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8h2a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h2V7a6 6 0 1112 0v1zm-7 7.732V18h2v-2.268a2 2 0 10-2 0zM16 8V7a4 4 0 10-8 0v1h8z"
            })
        ]
    });
/* harmony default export */ var Lock2Fill = ((/* unused pure expression or super */ null && (SvgLock2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Lock2Line.tsx

const SvgLock2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8V7a6 6 0 1112 0v1h2a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h2zm13 2H5v10h14V10zm-8 5.732a2 2 0 112 0V18h-2v-2.268zM8 8h8V7a4 4 0 10-8 0v1z"
            })
        ]
    });
/* harmony default export */ var Lock2Line = ((/* unused pure expression or super */ null && (SvgLock2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/LockFill.tsx

const SvgLockFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 10h1a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 1114 0v1zm-2 0V9A5 5 0 007 9v1h10zm-6 4v4h2v-4h-2z"
            })
        ]
    });
/* harmony default export */ var LockFill = ((/* unused pure expression or super */ null && (SvgLockFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LockLine.tsx

const SvgLockLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 10h1a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 1114 0v1zM5 12v8h14v-8H5zm6 2h2v4h-2v-4zm6-4V9A5 5 0 007 9v1h10z"
            })
        ]
    });
/* harmony default export */ var LockLine = ((/* unused pure expression or super */ null && (SvgLockLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LockPasswordFill.tsx

const SvgLockPasswordFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8h2a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h2V7a6 6 0 1112 0v1zm-2 0V7a4 4 0 10-8 0v1h8zm-5 6v2h2v-2h-2zm-4 0v2h2v-2H7zm8 0v2h2v-2h-2z"
            })
        ]
    });
/* harmony default export */ var LockPasswordFill = ((/* unused pure expression or super */ null && (SvgLockPasswordFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LockPasswordLine.tsx

const SvgLockPasswordLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8h2a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h2V7a6 6 0 1112 0v1zM5 10v10h14V10H5zm6 4h2v2h-2v-2zm-4 0h2v2H7v-2zm8 0h2v2h-2v-2zm1-6V7a4 4 0 10-8 0v1h8z"
            })
        ]
    });
/* harmony default export */ var LockPasswordLine = ((/* unused pure expression or super */ null && (SvgLockPasswordLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LockUnlockFill.tsx

const SvgLockUnlockFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10h13a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 0113.262-3.131l-1.789.894A5 5 0 007 9v1zm3 5v2h4v-2h-4z"
            })
        ]
    });
/* harmony default export */ var LockUnlockFill = ((/* unused pure expression or super */ null && (SvgLockUnlockFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LockUnlockLine.tsx

const SvgLockUnlockLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10h13a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 0113.262-3.131l-1.789.894A5 5 0 007 9v1zm-2 2v8h14v-8H5zm5 3h4v2h-4v-2z"
            })
        ]
    });
/* harmony default export */ var LockUnlockLine = ((/* unused pure expression or super */ null && (SvgLockUnlockLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LoginBoxFill.tsx

const SvgLoginBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 11H4V3a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1H5a1 1 0 01-1-1v-8h6v3l5-4-5-4v3z"
            })
        ]
    });
/* harmony default export */ var LoginBoxFill = ((/* unused pure expression or super */ null && (SvgLoginBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LoginBoxLine.tsx

const SvgLoginBoxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 15h2v5h12V4H6v5H4V3a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zm6-4V8l5 4-5 4v-3H2v-2h8z"
            })
        ]
    });
/* harmony default export */ var LoginBoxLine = ((/* unused pure expression or super */ null && (SvgLoginBoxLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LoginCircleFill.tsx

const SvgLoginCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 11H2.05c.5-5.053 4.764-9 9.95-9 5.523 0 10 4.477 10 10s-4.477 10-10 10c-5.185 0-9.449-3.947-9.95-9H10v3l5-4-5-4v3z"
            })
        ]
    });
/* harmony default export */ var LoginCircleFill = ((/* unused pure expression or super */ null && (SvgLoginCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LoginCircleLine.tsx

const SvgLoginCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 11V8l5 4-5 4v-3H1v-2h9zm-7.542 4h2.124A8.003 8.003 0 0020 12 8 8 0 004.582 9H2.458C3.732 4.943 7.522 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.478 0-8.268-2.943-9.542-7z"
            })
        ]
    });
/* harmony default export */ var LoginCircleLine = ((/* unused pure expression or super */ null && (SvgLoginCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutBoxFill.tsx

const SvgLogoutBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 2h14a1 1 0 011 1v18a1 1 0 01-1 1H5a1 1 0 01-1-1V3a1 1 0 011-1zm4 9V8l-5 4 5 4v-3h6v-2H9z"
            })
        ]
    });
/* harmony default export */ var LogoutBoxFill = ((/* unused pure expression or super */ null && (SvgLogoutBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutBoxLine.tsx

const SvgLogoutBoxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18h2v2h12V4H6v2H4V3a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1H5a1 1 0 01-1-1v-3zm2-7h7v2H6v3l-5-4 5-4v3z"
            })
        ]
    });
/* harmony default export */ var LogoutBoxLine = ((/* unused pure expression or super */ null && (SvgLogoutBoxLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutBoxRFill.tsx

const SvgLogoutBoxRFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 22a1 1 0 01-1-1V3a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1H5zm10-6l5-4-5-4v3H9v2h6v3z"
            })
        ]
    });
/* harmony default export */ var LogoutBoxRFill = ((/* unused pure expression or super */ null && (SvgLogoutBoxRFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutBoxRLine.tsx

const SvgLogoutBoxRLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 22a1 1 0 01-1-1V3a1 1 0 011-1h14a1 1 0 011 1v3h-2V4H6v16h12v-2h2v3a1 1 0 01-1 1H5zm13-6v-3h-7v-2h7V8l5 4-5 4z"
            })
        ]
    });
/* harmony default export */ var LogoutBoxRLine = ((/* unused pure expression or super */ null && (SvgLogoutBoxRLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutCircleFill.tsx

const SvgLogoutCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z"
            })
        ]
    });
/* harmony default export */ var LogoutCircleFill = ((/* unused pure expression or super */ null && (SvgLogoutCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutCircleLine.tsx

const SvgLogoutCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 11h8v2H5v3l-5-4 5-4v3zm-1 7h2.708a8 8 0 100-12H4a9.985 9.985 0 018-4c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.985 9.985 0 01-8-4z"
            })
        ]
    });
/* harmony default export */ var LogoutCircleLine = ((/* unused pure expression or super */ null && (SvgLogoutCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutCircleRFill.tsx

const SvgLogoutCircleRFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm5-6l5-4-5-4v3H9v2h8v3z"
            })
        ]
    });
/* harmony default export */ var LogoutCircleRFill = ((/* unused pure expression or super */ null && (SvgLogoutCircleRFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/LogoutCircleRLine.tsx

const SvgLogoutCircleRLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.985 9.985 0 018 4h-2.71a8 8 0 10.001 12h2.71A9.985 9.985 0 0112 22zm7-6v-3h-8v-2h8V8l5 4-5 4z"
            })
        ]
    });
/* harmony default export */ var LogoutCircleRLine = ((/* unused pure expression or super */ null && (SvgLogoutCircleRLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu2Fill.tsx

const SvgMenu2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h18v2H3V4zm0 7h12v2H3v-2zm0 7h18v2H3v-2z"
            })
        ]
    });
/* harmony default export */ var Menu2Fill = ((/* unused pure expression or super */ null && (SvgMenu2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu2Line.tsx

const SvgMenu2Line = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 4h18v2H3V4zm0 7h12v2H3v-2zm0 7h18v2H3v-2z"
            })
        ]
    });
/* harmony default export */ var Menu2Line = (SvgMenu2Line);

;// CONCATENATED MODULE: ./src/components/icons/System/Menu3Fill.tsx

const SvgMenu3Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h18v2H3V4zm6 7h12v2H9v-2zm-6 7h18v2H3v-2z"
            })
        ]
    });
/* harmony default export */ var Menu3Fill = ((/* unused pure expression or super */ null && (SvgMenu3Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu3Line.tsx

const SvgMenu3Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h18v2H3V4zm6 7h12v2H9v-2zm-6 7h18v2H3v-2z"
            })
        ]
    });
/* harmony default export */ var Menu3Line = ((/* unused pure expression or super */ null && (SvgMenu3Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu4Fill.tsx

const SvgMenu4Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18v2H5v-2h11zm5-7v2H3v-2h18zm-2-7v2H8V4h11z"
            })
        ]
    });
/* harmony default export */ var Menu4Fill = ((/* unused pure expression or super */ null && (SvgMenu4Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu4Line.tsx

const SvgMenu4Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18v2H5v-2h11zm5-7v2H3v-2h18zm-2-7v2H8V4h11z"
            })
        ]
    });
/* harmony default export */ var Menu4Line = ((/* unused pure expression or super */ null && (SvgMenu4Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu5Fill.tsx

const SvgMenu5Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z"
            })
        ]
    });
/* harmony default export */ var Menu5Fill = ((/* unused pure expression or super */ null && (SvgMenu5Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Menu5Line.tsx

const SvgMenu5Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z"
            })
        ]
    });
/* harmony default export */ var Menu5Line = ((/* unused pure expression or super */ null && (SvgMenu5Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuAddFill.tsx

const SvgMenuAddFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 15l-.001 3H21v2h-3.001L18 23h-2l-.001-3H13v-2h2.999L16 15h2zm-7 3v2H3v-2h8zm10-7v2H3v-2h18zm0-7v2H3V4h18z"
            })
        ]
    });
/* harmony default export */ var MenuAddFill = ((/* unused pure expression or super */ null && (SvgMenuAddFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuAddLine.tsx

const SvgMenuAddLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 15l-.001 3H21v2h-3.001L18 23h-2l-.001-3H13v-2h2.999L16 15h2zm-7 3v2H3v-2h8zm10-7v2H3v-2h18zm0-7v2H3V4h18z"
            })
        ]
    });
/* harmony default export */ var MenuAddLine = ((/* unused pure expression or super */ null && (SvgMenuAddLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuFill.tsx

const SvgMenuFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"
            })
        ]
    });
/* harmony default export */ var MenuFill = ((/* unused pure expression or super */ null && (SvgMenuFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuFoldFill.tsx

const SvgMenuFoldFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18v2H3v-2h18zM6.95 3.55v9.9L2 8.5l4.95-4.95zM21 11v2h-9v-2h9zm0-7v2h-9V4h9z"
            })
        ]
    });
/* harmony default export */ var MenuFoldFill = ((/* unused pure expression or super */ null && (SvgMenuFoldFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuFoldLine.tsx

const SvgMenuFoldLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18v2H3v-2h18zM6.596 3.904L8.01 5.318 4.828 8.5l3.182 3.182-1.414 1.414L2 8.5l4.596-4.596zM21 11v2h-9v-2h9zm0-7v2h-9V4h9z"
            })
        ]
    });
/* harmony default export */ var MenuFoldLine = ((/* unused pure expression or super */ null && (SvgMenuFoldLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuLine.tsx

const SvgMenuLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"
            })
        ]
    });
/* harmony default export */ var MenuLine = ((/* unused pure expression or super */ null && (SvgMenuLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuUnfoldFill.tsx

const SvgMenuUnfoldFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18v2H3v-2h18zM17.05 3.55L22 8.5l-4.95 4.95v-9.9zM12 11v2H3v-2h9zm0-7v2H3V4h9z"
            })
        ]
    });
/* harmony default export */ var MenuUnfoldFill = ((/* unused pure expression or super */ null && (SvgMenuUnfoldFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/MenuUnfoldLine.tsx

const SvgMenuUnfoldLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18v2H3v-2h18zM17.404 3.904L22 8.5l-4.596 4.596-1.414-1.414L19.172 8.5 15.99 5.318l1.414-1.414zM12 11v2H3v-2h9zm0-7v2H3V4h9z"
            })
        ]
    });
/* harmony default export */ var MenuUnfoldLine = ((/* unused pure expression or super */ null && (SvgMenuUnfoldLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/More2Fill.tsx

const SvgMore2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
            })
        ]
    });
/* harmony default export */ var More2Fill = ((/* unused pure expression or super */ null && (SvgMore2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/More2Line.tsx

const SvgMore2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3c-.825 0-1.5.675-1.5 1.5S11.175 6 12 6s1.5-.675 1.5-1.5S12.825 3 12 3zm0 15c-.825 0-1.5.675-1.5 1.5S11.175 21 12 21s1.5-.675 1.5-1.5S12.825 18 12 18zm0-7.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5z"
            })
        ]
    });
/* harmony default export */ var More2Line = ((/* unused pure expression or super */ null && (SvgMore2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/MoreFill.tsx

const SvgMoreFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm14 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
            })
        ]
    });
/* harmony default export */ var MoreFill = ((/* unused pure expression or super */ null && (SvgMoreFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/MoreLine.tsx

const SvgMoreLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 10.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S6 12.825 6 12s-.675-1.5-1.5-1.5zm15 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S21 12.825 21 12s-.675-1.5-1.5-1.5zm-7.5 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5z"
            })
        ]
    });
/* harmony default export */ var MoreLine = ((/* unused pure expression or super */ null && (SvgMoreLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/NotificationBadgeFill.tsx

const SvgNotificationBadgeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.341 4A6 6 0 0021 11.659V21a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1h9.341zM19 10a4 4 0 110-8 4 4 0 010 8z"
            })
        ]
    });
/* harmony default export */ var NotificationBadgeFill = ((/* unused pure expression or super */ null && (SvgNotificationBadgeFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/NotificationBadgeLine.tsx

const SvgNotificationBadgeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.341 4A5.99 5.99 0 0013 6H5v14h14v-8a5.99 5.99 0 002-.341V21a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1h9.341zM19 8a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 110-8 4 4 0 010 8z"
            })
        ]
    });
/* harmony default export */ var NotificationBadgeLine = ((/* unused pure expression or super */ null && (SvgNotificationBadgeLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/QuestionFill.tsx

const SvgQuestionFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm2-1.645A3.502 3.502 0 0012 6.5a3.501 3.501 0 00-3.433 2.813l1.962.393A1.5 1.5 0 1112 11.5a1 1 0 00-1 1V14h2v-.645z"
            })
        ]
    });
/* harmony default export */ var QuestionFill = ((/* unused pure expression or super */ null && (SvgQuestionFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/QuestionLine.tsx

const SvgQuestionLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 011-1 1.5 1.5 0 10-1.471-1.794l-1.962-.393A3.501 3.501 0 1113 13.355z"
            })
        ]
    });
/* harmony default export */ var QuestionLine = ((/* unused pure expression or super */ null && (SvgQuestionLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/RadioButtonFill.tsx

const SvgRadioButtonFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-6a4 4 0 100-8 4 4 0 000 8z"
            })
        ]
    });
/* harmony default export */ var RadioButtonFill = ((/* unused pure expression or super */ null && (SvgRadioButtonFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/RadioButtonLine.tsx

const SvgRadioButtonLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm0-3a5 5 0 110-10 5 5 0 010 10z"
            })
        ]
    });
/* harmony default export */ var RadioButtonLine = ((/* unused pure expression or super */ null && (SvgRadioButtonLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/RefreshFill.tsx

const SvgRefreshFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.82-4.924A7 7 0 009.032 5.658l.975 1.755A5 5 0 0117 12h-3l2.82 5.076zm-1.852 1.266l-.975-1.755A5 5 0 017 12h3L7.18 6.924a7 7 0 007.788 11.418z"
            })
        ]
    });
/* harmony default export */ var RefreshFill = ((/* unused pure expression or super */ null && (SvgRefreshFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/RefreshLine.tsx

const SvgRefreshLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.463 4.433A9.961 9.961 0 0112 2c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L17 12h3A8 8 0 006.46 6.228l-.997-1.795zm13.074 15.134A9.961 9.961 0 0112 22C6.477 22 2 17.523 2 12c0-2.136.67-4.116 1.81-5.74L7 12H4a8 8 0 0013.54 5.772l.997 1.795z"
            })
        ]
    });
/* harmony default export */ var RefreshLine = ((/* unused pure expression or super */ null && (SvgRefreshLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Search2Fill.tsx

const SvgSearch2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm8.485 16.071l2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414z"
            })
        ]
    });
/* harmony default export */ var Search2Fill = ((/* unused pure expression or super */ null && (SvgSearch2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Search2Line.tsx

const SvgSearch2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm0 16c3.867 0 7-3.133 7-7 0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7zm8.485.071l2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414z"
            })
        ]
    });
/* harmony default export */ var Search2Line = ((/* unused pure expression or super */ null && (SvgSearch2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/SearchEyeFill.tsx

const SvgSearchEyeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-5.853-9.44a4 4 0 102.646 2.646 2 2 0 11-2.646-2.647z"
            })
        ]
    });
/* harmony default export */ var SearchEyeFill = ((/* unused pure expression or super */ null && (SvgSearchEyeFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/SearchEyeLine.tsx

const SvgSearchEyeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0018 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15zm-3.847-8.699a2 2 0 102.646 2.646 4 4 0 11-2.646-2.646z"
            })
        ]
    });
/* harmony default export */ var SearchEyeLine = ((/* unused pure expression or super */ null && (SvgSearchEyeLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/SearchFill.tsx

const SvgSearchFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617z"
            })
        ]
    });
/* harmony default export */ var SearchFill = ((/* unused pure expression or super */ null && (SvgSearchFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/SearchLine.tsx

const SvgSearchLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0018 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15z"
            })
        ]
    });
/* harmony default export */ var SearchLine = ((/* unused pure expression or super */ null && (SvgSearchLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings2Fill.tsx

const SvgSettings2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.686 4l2.607-2.607a1 1 0 011.414 0L15.314 4H19a1 1 0 011 1v3.686l2.607 2.607a1 1 0 010 1.414L20 15.314V19a1 1 0 01-1 1h-3.686l-2.607 2.607a1 1 0 01-1.414 0L8.686 20H5a1 1 0 01-1-1v-3.686l-2.607-2.607a1 1 0 010-1.414L4 8.686V5a1 1 0 011-1h3.686zM12 15a3 3 0 100-6 3 3 0 000 6z"
            })
        ]
    });
/* harmony default export */ var Settings2Fill = ((/* unused pure expression or super */ null && (SvgSettings2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings2Line.tsx

const SvgSettings2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.686 4l2.607-2.607a1 1 0 011.414 0L15.314 4H19a1 1 0 011 1v3.686l2.607 2.607a1 1 0 010 1.414L20 15.314V19a1 1 0 01-1 1h-3.686l-2.607 2.607a1 1 0 01-1.414 0L8.686 20H5a1 1 0 01-1-1v-3.686l-2.607-2.607a1 1 0 010-1.414L4 8.686V5a1 1 0 011-1h3.686zM6 6v3.515L3.515 12 6 14.485V18h3.515L12 20.485 14.485 18H18v-3.515L20.485 12 18 9.515V6h-3.515L12 3.515 9.515 6H6zm6 10a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
            })
        ]
    });
/* harmony default export */ var Settings2Line = ((/* unused pure expression or super */ null && (SvgSettings2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings3Fill.tsx

const SvgSettings3Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.954 2.21a9.99 9.99 0 014.091-.002A3.993 3.993 0 0016 5.07a3.993 3.993 0 003.457.261A9.99 9.99 0 0121.5 8.876 3.993 3.993 0 0020 12a3.99 3.99 0 001.502 3.124 10.043 10.043 0 01-2.046 3.543 3.993 3.993 0 00-3.456.261 3.993 3.993 0 00-1.954 2.86 9.99 9.99 0 01-4.091.004A3.993 3.993 0 008 18.927a3.993 3.993 0 00-3.457-.26A9.99 9.99 0 012.5 15.121 3.993 3.993 0 004 11.999a3.993 3.993 0 00-1.502-3.124 10.043 10.043 0 012.046-3.543A3.993 3.993 0 008 5.071a3.993 3.993 0 001.954-2.86zM12 15a3 3 0 100-6 3 3 0 000 6z"
            })
        ]
    });
/* harmony default export */ var Settings3Fill = ((/* unused pure expression or super */ null && (SvgSettings3Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings3Line.tsx

const SvgSettings3Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.34 17a10.018 10.018 0 01-.978-2.326 3 3 0 00.002-5.347A9.99 9.99 0 014.865 4.99a3 3 0 004.631-2.674 9.99 9.99 0 015.007.002 3 3 0 004.632 2.672A9.99 9.99 0 0120.66 7c.433.749.757 1.53.978 2.326a3 3 0 00-.002 5.347 9.99 9.99 0 01-2.501 4.337 3 3 0 00-4.631 2.674 9.99 9.99 0 01-5.007-.002 3 3 0 00-4.632-2.672A10.018 10.018 0 013.34 17zm5.66.196a4.993 4.993 0 012.25 2.77c.499.047 1 .048 1.499.001A4.993 4.993 0 0115 17.197a4.993 4.993 0 013.525-.565c.29-.408.54-.843.748-1.298A4.993 4.993 0 0118 12c0-1.26.47-2.437 1.273-3.334a8.126 8.126 0 00-.75-1.298A4.993 4.993 0 0115 6.804a4.993 4.993 0 01-2.25-2.77c-.499-.047-1-.048-1.499-.001A4.993 4.993 0 019 6.803a4.993 4.993 0 01-3.525.565 7.99 7.99 0 00-.748 1.298A4.993 4.993 0 016 12a4.99 4.99 0 01-1.273 3.334 8.126 8.126 0 00.75 1.298A4.993 4.993 0 019 17.196zM12 15a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2z"
            })
        ]
    });
/* harmony default export */ var Settings3Line = ((/* unused pure expression or super */ null && (SvgSettings3Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings4Fill.tsx

const SvgSettings4Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.334 4.545a9.99 9.99 0 013.542-2.048A3.993 3.993 0 0012 3.999a3.993 3.993 0 003.124-1.502 9.99 9.99 0 013.542 2.048 3.993 3.993 0 00.262 3.454 3.993 3.993 0 002.863 1.955 10.043 10.043 0 010 4.09c-1.16.178-2.23.86-2.863 1.955a3.993 3.993 0 00-.262 3.455 9.99 9.99 0 01-3.542 2.047A3.993 3.993 0 0012 20a3.993 3.993 0 00-3.124 1.502 9.99 9.99 0 01-3.542-2.047A3.993 3.993 0 005.072 16a3.993 3.993 0 00-2.863-1.954 10.043 10.043 0 010-4.091A3.993 3.993 0 005.072 8a3.993 3.993 0 00.262-3.454zM13.5 14.597a3 3 0 10-3-5.196 3 3 0 003 5.196z"
            })
        ]
    });
/* harmony default export */ var Settings4Fill = ((/* unused pure expression or super */ null && (SvgSettings4Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings4Line.tsx

const SvgSettings4Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12c0-.865.11-1.703.316-2.504A3 3 0 004.99 4.867a9.99 9.99 0 014.335-2.505 3 3 0 005.348 0 9.99 9.99 0 014.335 2.505 3 3 0 002.675 4.63 10.036 10.036 0 010 5.007 3 3 0 00-2.675 4.629 9.99 9.99 0 01-4.335 2.505 3 3 0 00-5.348 0 9.99 9.99 0 01-4.335-2.505 3 3 0 00-2.675-4.63A10.056 10.056 0 012 12zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0112 18c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75A4.993 4.993 0 0117.196 15a4.993 4.993 0 012.77-2.25 8.126 8.126 0 000-1.5A4.993 4.993 0 0117.195 9a4.993 4.993 0 01-.564-3.524 7.989 7.989 0 00-1.297-.75A4.993 4.993 0 0112 6a4.993 4.993 0 01-3.335-1.274 7.99 7.99 0 00-1.297.75A4.993 4.993 0 016.804 9a4.993 4.993 0 01-2.77 2.25 8.126 8.126 0 000 1.5A4.993 4.993 0 016.805 15zM12 15a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2z"
            })
        ]
    });
/* harmony default export */ var Settings4Line = ((/* unused pure expression or super */ null && (SvgSettings4Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings5Fill.tsx

const SvgSettings5Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.132 13.63a9.942 9.942 0 010-3.26c1.102.026 2.092-.502 2.477-1.431.385-.93.058-2.004-.74-2.763a9.942 9.942 0 012.306-2.307c.76.798 1.834 1.125 2.764.74.93-.385 1.457-1.376 1.43-2.477a9.942 9.942 0 013.262 0c-.027 1.102.501 2.092 1.43 2.477.93.385 2.004.058 2.763-.74a9.942 9.942 0 012.307 2.306c-.798.76-1.125 1.834-.74 2.764.385.93 1.376 1.457 2.477 1.43a9.942 9.942 0 010 3.262c-1.102-.027-2.092.501-2.477 1.43-.385.93-.058 2.004.74 2.763a9.942 9.942 0 01-2.306 2.307c-.76-.798-1.834-1.125-2.764-.74-.93.385-1.457 1.376-1.43 2.477a9.942 9.942 0 01-3.262 0c.027-1.102-.501-2.092-1.43-2.477-.93-.385-2.004-.058-2.763.74a9.942 9.942 0 01-2.307-2.306c.798-.76 1.125-1.834.74-2.764-.385-.93-1.376-1.457-2.477-1.43zM12 15a3 3 0 100-6 3 3 0 000 6z"
            })
        ]
    });
/* harmony default export */ var Settings5Fill = ((/* unused pure expression or super */ null && (SvgSettings5Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings5Line.tsx

const SvgSettings5Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.213 14.06a9.945 9.945 0 010-4.12c1.11.13 2.08-.237 2.396-1.001.317-.765-.108-1.71-.986-2.403a9.945 9.945 0 012.913-2.913c.692.877 1.638 1.303 2.403.986.765-.317 1.132-1.286 1.001-2.396a9.945 9.945 0 014.12 0c-.13 1.11.237 2.08 1.001 2.396.765.317 1.71-.108 2.403-.986a9.945 9.945 0 012.913 2.913c-.877.692-1.303 1.638-.986 2.403.317.765 1.286 1.132 2.396 1.001a9.945 9.945 0 010 4.12c-1.11-.13-2.08.237-2.396 1.001-.317.765.108 1.71.986 2.403a9.945 9.945 0 01-2.913 2.913c-.692-.877-1.638-1.303-2.403-.986-.765.317-1.132 1.286-1.001 2.396a9.945 9.945 0 01-4.12 0c.13-1.11-.237-2.08-1.001-2.396-.765-.317-1.71.108-2.403.986a9.945 9.945 0 01-2.913-2.913c.877-.692 1.303-1.638.986-2.403-.317-.765-1.286-1.132-2.396-1.001zM4 12.21c1.1.305 2.007 1.002 2.457 2.086.449 1.085.3 2.22-.262 3.212.096.102.195.201.297.297.993-.562 2.127-.71 3.212-.262 1.084.45 1.781 1.357 2.086 2.457.14.004.28.004.42 0 .305-1.1 1.002-2.007 2.086-2.457 1.085-.449 2.22-.3 3.212.262.102-.096.201-.195.297-.297-.562-.993-.71-2.127-.262-3.212.45-1.084 1.357-1.781 2.457-2.086.004-.14.004-.28 0-.42-1.1-.305-2.007-1.002-2.457-2.086-.449-1.085-.3-2.22.262-3.212a7.935 7.935 0 00-.297-.297c-.993.562-2.127.71-3.212.262C13.212 6.007 12.515 5.1 12.21 4a7.935 7.935 0 00-.42 0c-.305 1.1-1.002 2.007-2.086 2.457-1.085.449-2.22.3-3.212-.262a6.932 6.932 0 00-.297.297c.562.993.71 2.127.262 3.212C6.007 10.788 5.1 11.485 4 11.79c-.004.14-.004.28 0 .42zM12 15a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2z"
            })
        ]
    });
/* harmony default export */ var Settings5Line = ((/* unused pure expression or super */ null && (SvgSettings5Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings6Fill.tsx

const SvgSettings6Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 2.474L23 12l-5.5 9.526h-11L1 12l5.5-9.526h11zM8.634 8.17l5 8.66 1.732-1-5-8.66-1.732 1z"
            })
        ]
    });
/* harmony default export */ var Settings6Fill = ((/* unused pure expression or super */ null && (SvgSettings6Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Settings6Line.tsx

const SvgSettings6Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 2.474L23 12l-5.5 9.526h-11L1 12l5.5-9.526h11zm-1.155 2h-8.69L3.309 12l4.346 7.526h8.69L20.691 12l-4.346-7.526zM8.634 8.17l1.732-1 5 8.66-1.732 1-5-8.66z"
            })
        ]
    });
/* harmony default export */ var Settings6Line = ((/* unused pure expression or super */ null && (SvgSettings6Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/SettingsFill.tsx

const SvgSettingsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 1l9.5 5.5v11L12 23l-9.5-5.5v-11L12 1zm0 14a3 3 0 100-6 3 3 0 000 6z"
            })
        ]
    });
/* harmony default export */ var SettingsFill = ((/* unused pure expression or super */ null && (SvgSettingsFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/SettingsLine.tsx

const SvgSettingsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 1l9.5 5.5v11L12 23l-9.5-5.5v-11L12 1zm0 2.311L4.5 7.653v8.694l7.5 4.342 7.5-4.342V7.653L12 3.311zM12 16a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
            })
        ]
    });
/* harmony default export */ var SettingsLine = ((/* unused pure expression or super */ null && (SvgSettingsLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareBoxFill.tsx

const SvgShareBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 3v2H5v14h14v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6zm7.707 4.707L12 13.414 10.586 12l5.707-5.707L13 3h8v8l-3.293-3.293z"
            })
        ]
    });
/* harmony default export */ var ShareBoxFill = ((/* unused pure expression or super */ null && (SvgShareBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareBoxLine.tsx

const SvgShareBoxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 3v2H5v14h14v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6zm7.586 2H13V3h8v8h-2V6.414l-7 7L10.586 12l7-7z"
            })
        ]
    });
/* harmony default export */ var ShareBoxLine = ((/* unused pure expression or super */ null && (SvgShareBoxLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareCircleFill.tsx

const SvgShareCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 2.05v2.012A8.001 8.001 0 0012 20a8.001 8.001 0 007.938-7h2.013c-.502 5.053-4.766 9-9.951 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95zm7.707 4.657L12 13.414 10.586 12l6.707-6.707L14 2h8v8l-3.293-3.293z"
            })
        ]
    });
/* harmony default export */ var ShareCircleFill = ((/* unused pure expression or super */ null && (SvgShareCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareCircleLine.tsx

const SvgShareCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 2.05v2.012A8.001 8.001 0 0012 20a8.001 8.001 0 007.938-7h2.013c-.502 5.053-4.766 9-9.951 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95zm9 3.364l-8 8L10.586 12l8-8H14V2h8v8h-2V5.414z"
            })
        ]
    });
/* harmony default export */ var ShareCircleLine = ((/* unused pure expression or super */ null && (SvgShareCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareFill.tsx

const SvgShareFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.576 17.271l-5.11-2.787a3.5 3.5 0 110-4.968l5.11-2.787a3.5 3.5 0 11.958 1.755l-5.11 2.787a3.514 3.514 0 010 1.458l5.11 2.787a3.5 3.5 0 11-.958 1.755z"
            })
        ]
    });
/* harmony default export */ var ShareFill = ((/* unused pure expression or super */ null && (SvgShareFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareForward2Fill.tsx

const SvgShareForward2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19h16v-5h2v6a1 1 0 01-1 1H3a1 1 0 01-1-1v-6h2v5zm8-9H9a5.992 5.992 0 00-4.854 2.473A8.003 8.003 0 0112 6V2l8 6-8 6v-4z"
            })
        ]
    });
/* harmony default export */ var ShareForward2Fill = ((/* unused pure expression or super */ null && (SvgShareForward2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareForward2Line.tsx

const SvgShareForward2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19h16v-5h2v6a1 1 0 01-1 1H3a1 1 0 01-1-1v-6h2v5zM16.172 7l-3.95-3.95 1.414-1.414L20 8l-6.364 6.364-1.414-1.414L16.172 9H5V7h11.172z"
            })
        ]
    });
/* harmony default export */ var ShareForward2Line = ((/* unused pure expression or super */ null && (SvgShareForward2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareForwardBoxFill.tsx

const SvgShareForwardBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v2H4v14h16v-9h2v10a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h6zm7 2V1l7 6h-9a2 2 0 00-2 2v6h-2V9a4 4 0 014-4h2z"
            })
        ]
    });
/* harmony default export */ var ShareForwardBoxFill = ((/* unused pure expression or super */ null && (SvgShareForwardBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareForwardBoxLine.tsx

const SvgShareForwardBoxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v2H4v14h16v-9h2v10a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h6zm9.95 2L16 2.05 17.414.636l5.34 5.34A.6.6 0 0122.33 7H14a2 2 0 00-2 2v6h-2V9a4 4 0 014-4h4.95z"
            })
        ]
    });
/* harmony default export */ var ShareForwardBoxLine = ((/* unused pure expression or super */ null && (SvgShareForwardBoxLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareForwardFill.tsx

const SvgShareForwardFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 14h-2a8.999 8.999 0 00-7.968 4.81A10.136 10.136 0 013 18C3 12.477 7.477 8 13 8V3l10 8-10 8v-5z"
            })
        ]
    });
/* harmony default export */ var ShareForwardFill = ((/* unused pure expression or super */ null && (SvgShareForwardFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareForwardLine.tsx

const SvgShareForwardLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 14h-2a8.999 8.999 0 00-7.968 4.81A10.136 10.136 0 013 18C3 12.477 7.477 8 13 8V2.5L23.5 11 13 19.5V14zm-2-2h4v3.308L20.321 11 15 6.692V10h-2a7.982 7.982 0 00-6.057 2.773A10.988 10.988 0 0111 12z"
            })
        ]
    });
/* harmony default export */ var ShareForwardLine = ((/* unused pure expression or super */ null && (SvgShareForwardLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShareLine.tsx

const SvgShareLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.12 17.023l-4.199-2.29a4 4 0 110-5.465l4.2-2.29a4 4 0 11.959 1.755l-4.2 2.29a4.008 4.008 0 010 1.954l4.199 2.29a4 4 0 11-.959 1.755zM6 14a2 2 0 100-4 2 2 0 000 4zm11-6a2 2 0 100-4 2 2 0 000 4zm0 12a2 2 0 100-4 2 2 0 000 4z"
            })
        ]
    });
/* harmony default export */ var ShareLine = ((/* unused pure expression or super */ null && (SvgShareLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldCheckFill.tsx

const SvgShieldCheckFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A5.998 5.998 0 013 13.79V3.802a1 1 0 01.783-.976L12 1zm4.452 7.222l-4.95 4.949-2.828-2.828-1.414 1.414L11.503 16l6.364-6.364-1.415-1.414z"
            })
        ]
    });
/* harmony default export */ var ShieldCheckFill = ((/* unused pure expression or super */ null && (SvgShieldCheckFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldCheckLine.tsx

const SvgShieldCheckLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A5.998 5.998 0 013 13.79V3.802a1 1 0 01.783-.976L12 1zm0 2.049L5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A3.998 3.998 0 0019 13.79V4.604L12 3.05zm4.452 5.173l1.415 1.414L11.503 16 7.26 11.757l1.414-1.414 2.828 2.828 4.95-4.95z"
            })
        ]
    });
/* harmony default export */ var ShieldCheckLine = ((/* unused pure expression or super */ null && (SvgShieldCheckLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldCrossFill.tsx

const SvgShieldCrossFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM11 10H8v2h3v3h2v-3h3v-2h-3V7h-2v3z"
            })
        ]
    });
/* harmony default export */ var ShieldCrossFill = ((/* unused pure expression or super */ null && (SvgShieldCrossFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldCrossLine.tsx

const SvgShieldCrossLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05 5 4.604zM11 10V7h2v3h3v2h-3v3h-2v-3H8v-2h3z"
            })
        ]
    });
/* harmony default export */ var ShieldCrossLine = ((/* unused pure expression or super */ null && (SvgShieldCrossLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldFill.tsx

const SvgShieldFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976z"
            })
        ]
    });
/* harmony default export */ var ShieldFill = ((/* unused pure expression or super */ null && (SvgShieldFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldFlashFill.tsx

const SvgShieldFlashFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM13 10V5l-5 7h3v5l5-7h-3z"
            })
        ]
    });
/* harmony default export */ var ShieldFlashFill = ((/* unused pure expression or super */ null && (SvgShieldFlashFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldFlashLine.tsx

const SvgShieldFlashLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05 5 4.604zM13 10h3l-5 7v-5H8l5-7v5z"
            })
        ]
    });
/* harmony default export */ var ShieldFlashLine = ((/* unused pure expression or super */ null && (SvgShieldFlashLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldKeyholeFill.tsx

const SvgShieldKeyholeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976L12 1zm0 6a2 2 0 00-1 3.732V15h2l.001-4.268A2 2 0 0012 7z"
            })
        ]
    });
/* harmony default export */ var ShieldKeyholeFill = ((/* unused pure expression or super */ null && (SvgShieldKeyholeFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldKeyholeLine.tsx

const SvgShieldKeyholeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976L12 1zm0 2.049L5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05zM12 7a2 2 0 011.001 3.732L13 15h-2v-4.268A2 2 0 0112 7z"
            })
        ]
    });
/* harmony default export */ var ShieldKeyholeLine = ((/* unused pure expression or super */ null && (SvgShieldKeyholeLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldLine.tsx

const SvgShieldLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05 5 4.604z"
            })
        ]
    });
/* harmony default export */ var ShieldLine = ((/* unused pure expression or super */ null && (SvgShieldLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldStarFill.tsx

const SvgShieldStarFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM12 13.5l2.939 1.545-.561-3.272 2.377-2.318-3.286-.478L12 6l-1.47 2.977-3.285.478 2.377 2.318-.56 3.272L12 13.5z"
            })
        ]
    });
/* harmony default export */ var ShieldStarFill = ((/* unused pure expression or super */ null && (SvgShieldStarFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldStarLine.tsx

const SvgShieldStarLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05 5 4.604zM3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM12 13.5l-2.939 1.545.561-3.272-2.377-2.318 3.286-.478L12 6l1.47 2.977 3.285.478-2.377 2.318.56 3.272L12 13.5z"
            })
        ]
    });
/* harmony default export */ var ShieldStarLine = ((/* unused pure expression or super */ null && (SvgShieldStarLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldUserFill.tsx

const SvgShieldUserFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM12 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-4.473 5h8.946a4.5 4.5 0 00-8.946 0z"
            })
        ]
    });
/* harmony default export */ var ShieldUserFill = ((/* unused pure expression or super */ null && (SvgShieldUserFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ShieldUserLine.tsx

const SvgShieldUserLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05 5 4.604zM12 11a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm-4.473 5a4.5 4.5 0 018.946 0H7.527z"
            })
        ]
    });
/* harmony default export */ var ShieldUserLine = ((/* unused pure expression or super */ null && (SvgShieldUserLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/SideBarFill.tsx

const SvgSideBarFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm6 2v14h11V5H9z"
            })
        ]
    });
/* harmony default export */ var SideBarFill = ((/* unused pure expression or super */ null && (SvgSideBarFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/SideBarLine.tsx

const SvgSideBarLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm5 2H4v14h4V5zm2 0v14h10V5H10z"
            })
        ]
    });
/* harmony default export */ var SideBarLine = ((/* unused pure expression or super */ null && (SvgSideBarLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Spam2Fill.tsx

const SvgSpam2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.218 2.5l5.683 5.682v8.036l-5.683 5.683H8.182l-5.683-5.683V8.182l5.683-5.683h8.036zM11 15v2h2v-2h-2zm0-8v6h2V7h-2z"
            })
        ]
    });
/* harmony default export */ var Spam2Fill = ((/* unused pure expression or super */ null && (SvgSpam2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Spam2Line.tsx

const SvgSpam2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.936 2.5L21.5 8.067v7.87L15.936 21.5h-7.87L2.5 15.936v-7.87L8.066 2.5h7.87zm-.829 2H8.894L4.501 8.895v6.213l4.393 4.394h6.213l4.394-4.394V8.894l-4.394-4.393zM11 15h2v2h-2v-2zm0-8h2v6h-2V7z"
            })
        ]
    });
/* harmony default export */ var Spam2Line = ((/* unused pure expression or super */ null && (SvgSpam2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/Spam3Fill.tsx

const SvgSpam3Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.936 2.5L21.5 8.067v7.87L15.936 21.5h-7.87L2.5 15.936v-7.87L8.066 2.5h7.87zM8 11v2h8v-2H8z"
            })
        ]
    });
/* harmony default export */ var Spam3Fill = ((/* unused pure expression or super */ null && (SvgSpam3Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Spam3Line.tsx

const SvgSpam3Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.936 2.5L21.5 8.067v7.87L15.936 21.5h-7.87L2.5 15.936v-7.87L8.066 2.5h7.87zm-.829 2H8.894L4.501 8.895v6.213l4.393 4.394h6.213l4.394-4.394V8.894l-4.394-4.393zM8 11h8v2H8v-2z"
            })
        ]
    });
/* harmony default export */ var Spam3Line = ((/* unused pure expression or super */ null && (SvgSpam3Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/SpamFill.tsx

const SvgSpamFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 2.5L23 12l-5.5 9.5h-11L1 12l5.5-9.5h11zM11 15v2h2v-2h-2zm0-8v6h2V7h-2z"
            })
        ]
    });
/* harmony default export */ var SpamFill = ((/* unused pure expression or super */ null && (SvgSpamFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/SpamLine.tsx

const SvgSpamLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 2.5L23 12l-5.5 9.5h-11L1 12l5.5-9.5h11zm-1.153 2H7.653L3.311 12l4.342 7.5h8.694l4.342-7.5-4.342-7.5zM11 15h2v2h-2v-2zm0-8h2v6h-2V7z"
            })
        ]
    });
/* harmony default export */ var SpamLine = ((/* unused pure expression or super */ null && (SvgSpamLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarFill.tsx

const SvgStarFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928z"
            })
        ]
    });
/* harmony default export */ var StarFill = ((/* unused pure expression or super */ null && (SvgStarFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarHalfFill.tsx

const SvgStarHalfFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15.968l4.247 2.377-.949-4.773 3.573-3.305-4.833-.573L12 5.275v10.693zm0 2.292l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26z"
            })
        ]
    });
/* harmony default export */ var StarHalfFill = ((/* unused pure expression or super */ null && (SvgStarHalfFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarHalfLine.tsx

const SvgStarHalfLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15.968l4.247 2.377-.949-4.773 3.573-3.305-4.833-.573L12 5.275v10.693zm0 2.292l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26z"
            })
        ]
    });
/* harmony default export */ var StarHalfLine = ((/* unused pure expression or super */ null && (SvgStarHalfLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarHalfSFill.tsx

const SvgStarHalfSFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14.656l2.817 1.72-.766-3.21 2.507-2.147-3.29-.264L12 7.708v6.948zM12 17l-5.878 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.866.55-5.231 4.48 1.598 6.7L12 17z"
            })
        ]
    });
/* harmony default export */ var StarHalfSFill = ((/* unused pure expression or super */ null && (SvgStarHalfSFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarHalfSLine.tsx

const SvgStarHalfSLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14.656l2.817 1.72-.766-3.21 2.507-2.147-3.29-.264L12 7.708v6.948zM12 17l-5.878 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.866.55-5.231 4.48 1.598 6.7L12 17z"
            })
        ]
    });
/* harmony default export */ var StarHalfSLine = ((/* unused pure expression or super */ null && (SvgStarHalfSLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarLine.tsx

const SvgStarLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26zm0-2.292l4.247 2.377-.949-4.773 3.573-3.305-4.833-.573L12 5.275l-2.038 4.42-4.833.572 3.573 3.305-.949 4.773L12 15.968z"
            })
        ]
    });
/* harmony default export */ var StarLine = ((/* unused pure expression or super */ null && (SvgStarLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarSFill.tsx

const SvgStarSFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17l-5.878 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.866.55-5.231 4.48 1.598 6.7z"
            })
        ]
    });
/* harmony default export */ var StarSFill = ((/* unused pure expression or super */ null && (SvgStarSFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/StarSLine.tsx

const SvgStarSLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17l-5.878 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.866.55-5.231 4.48 1.598 6.7L12 17zm0-2.344l2.817 1.72-.766-3.21 2.507-2.147-3.29-.264L12 7.708l-1.268 3.047-3.29.264 2.507 2.147-.766 3.21L12 14.657z"
            })
        ]
    });
/* harmony default export */ var StarSLine = ((/* unused pure expression or super */ null && (SvgStarSLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/SubtractFill.tsx

const SvgSubtractFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 11h14v2H5z"
            })
        ]
    });
/* harmony default export */ var SubtractFill = ((/* unused pure expression or super */ null && (SvgSubtractFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/SubtractLine.tsx

const SvgSubtractLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 11h14v2H5z"
            })
        ]
    });
/* harmony default export */ var SubtractLine = ((/* unused pure expression or super */ null && (SvgSubtractLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ThumbDownFill.tsx

const SvgThumbDownFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 15h-3V3h3a1 1 0 011 1v10a1 1 0 01-1 1zm-5.293 1.293l-6.4 6.4a.5.5 0 01-.654.047L8.8 22.1a1.5 1.5 0 01-.553-1.57L9.4 16H3a2 2 0 01-2-2v-2.104a2 2 0 01.15-.762L4.246 3.62A1 1 0 015.17 3H16a1 1 0 011 1v11.586a1 1 0 01-.293.707z"
            })
        ]
    });
/* harmony default export */ var ThumbDownFill = ((/* unused pure expression or super */ null && (SvgThumbDownFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ThumbDownLine.tsx

const SvgThumbDownLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.4 16H3a2 2 0 01-2-2v-2.104a2 2 0 01.15-.762L4.246 3.62A1 1 0 015.17 3H22a1 1 0 011 1v10a1 1 0 01-1 1h-3.482a1 1 0 00-.817.423l-5.453 7.726a.5.5 0 01-.632.159L9.802 22.4a2.5 2.5 0 01-1.305-2.853L9.4 16zm7.6-2.588V5H5.84L3 11.896V14h6.4a2 2 0 011.938 2.493l-.903 3.548a.5.5 0 00.261.571l.661.33 4.71-6.672c.25-.354.57-.644.933-.858zM19 13h2V5h-2v8z"
            })
        ]
    });
/* harmony default export */ var ThumbDownLine = ((/* unused pure expression or super */ null && (SvgThumbDownLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ThumbUpFill.tsx

const SvgThumbUpFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9h3v12H2a1 1 0 01-1-1V10a1 1 0 011-1zm5.293-1.293l6.4-6.4a.5.5 0 01.654-.047l.853.64a1.5 1.5 0 01.553 1.57L14.6 8H21a2 2 0 012 2v2.104a2 2 0 01-.15.762l-3.095 7.515a1 1 0 01-.925.619H8a1 1 0 01-1-1V8.414a1 1 0 01.293-.707z"
            })
        ]
    });
/* harmony default export */ var ThumbUpFill = ((/* unused pure expression or super */ null && (SvgThumbUpFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ThumbUpLine.tsx

const SvgThumbUpLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.6 8H21a2 2 0 012 2v2.104a2 2 0 01-.15.762l-3.095 7.515a1 1 0 01-.925.619H2a1 1 0 01-1-1V10a1 1 0 011-1h3.482a1 1 0 00.817-.423L11.752.85a.5.5 0 01.632-.159l1.814.907a2.5 2.5 0 011.305 2.853L14.6 8zM7 10.588V19h11.16L21 12.104V10h-6.4a2 2 0 01-1.938-2.493l.903-3.548a.5.5 0 00-.261-.571l-.661-.33-4.71 6.672c-.25.354-.57.644-.933.858zM5 11H3v8h2v-8z"
            })
        ]
    });
/* harmony default export */ var ThumbUpLine = ((/* unused pure expression or super */ null && (SvgThumbUpLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/TimeFill.tsx

const SvgTimeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-10V7h-2v7h6v-2h-4z"
            })
        ]
    });
/* harmony default export */ var TimeFill = ((/* unused pure expression or super */ null && (SvgTimeFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/TimeLine.tsx

const SvgTimeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-8h4v2h-6V7h2v5z"
            })
        ]
    });
/* harmony default export */ var TimeLine = ((/* unused pure expression or super */ null && (SvgTimeLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Timer2Fill.tsx

const SvgTimer2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm3.536 5.05L10.586 12 12 13.414l4.95-4.95-1.414-1.414z"
            })
        ]
    });
/* harmony default export */ var Timer2Fill = ((/* unused pure expression or super */ null && (SvgTimer2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Timer2Line.tsx

const SvgTimer2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm3.536-12.95l1.414 1.414-4.95 4.95L10.586 12l4.95-4.95z"
            })
        ]
    });
/* harmony default export */ var Timer2Line = ((/* unused pure expression or super */ null && (SvgTimer2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/TimerFill.tsx

const SvgTimerFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.618 5.968l1.453-1.453 1.414 1.414-1.453 1.453a9 9 0 11-1.414-1.414zM11 8v6h2V8h-2zM8 1h8v2H8V1z"
            })
        ]
    });
/* harmony default export */ var TimerFill = ((/* unused pure expression or super */ null && (SvgTimerFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/TimerFlashFill.tsx

const SvgTimerFlashFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.382 5.968A8.962 8.962 0 0112 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453a9 9 0 11-14.064 0L3.515 5.93l1.414-1.414 1.453 1.453zM13 12V7.495L8 14h3v4.5l5-6.5h-3zM8 1h8v2H8V1z"
            })
        ]
    });
/* harmony default export */ var TimerFlashFill = ((/* unused pure expression or super */ null && (SvgTimerFlashFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/TimerFlashLine.tsx

const SvgTimerFlashLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.382 5.968A8.962 8.962 0 0112 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453a9 9 0 11-14.064 0L3.515 5.93l1.414-1.414 1.453 1.453zM12 20a7 7 0 100-14 7 7 0 000 14zm1-8h3l-5 6.5V14H8l5-6.505V12zM8 1h8v2H8V1z"
            })
        ]
    });
/* harmony default export */ var TimerFlashLine = ((/* unused pure expression or super */ null && (SvgTimerFlashLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/TimerLine.tsx

const SvgTimerLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.618 5.968l1.453-1.453 1.414 1.414-1.453 1.453a9 9 0 11-1.414-1.414zM12 20a7 7 0 100-14 7 7 0 000 14zM11 8h2v6h-2V8zM8 1h8v2H8V1z"
            })
        ]
    });
/* harmony default export */ var TimerLine = ((/* unused pure expression or super */ null && (SvgTimerLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ToggleFill.tsx

const SvgToggleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 5h8a7 7 0 010 14H8A7 7 0 018 5zm8 10a3 3 0 100-6 3 3 0 000 6z"
            })
        ]
    });
/* harmony default export */ var ToggleFill = ((/* unused pure expression or super */ null && (SvgToggleFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ToggleLine.tsx

const SvgToggleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7a5 5 0 100 10h8a5 5 0 000-10H8zm0-2h8a7 7 0 010 14H8A7 7 0 018 5zm0 10a3 3 0 110-6 3 3 0 010 6z"
            })
        ]
    });
/* harmony default export */ var ToggleLine = ((/* unused pure expression or super */ null && (SvgToggleLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/Upload2Fill.tsx

const SvgUpload2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19h16v-7h2v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8h2v7zM14 9v6h-4V9H5l7-7 7 7h-5z"
            })
        ]
    });
/* harmony default export */ var Upload2Fill = ((/* unused pure expression or super */ null && (SvgUpload2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/Upload2Line.tsx

const SvgUpload2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19h16v-7h2v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8h2v7zm9-10v7h-2V9H6l6-6 6 6h-5z"
            })
        ]
    });
/* harmony default export */ var Upload2Line = ((/* unused pure expression or super */ null && (SvgUpload2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/UploadCloud2Fill.tsx

const SvgUploadCloud2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12.586l4.243 4.242-1.415 1.415L13 16.415V22h-2v-5.587l-1.828 1.83-1.415-1.415L12 12.586zM12 2a7.001 7.001 0 016.954 6.194 5.5 5.5 0 01-.953 10.784L18 17a6 6 0 00-11.996-.225L6 17v1.978a5.5 5.5 0 01-.954-10.784A7 7 0 0112 2z"
            })
        ]
    });
/* harmony default export */ var UploadCloud2Fill = ((/* unused pure expression or super */ null && (SvgUploadCloud2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/System/UploadCloud2Line.tsx

const SvgUploadCloud2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12.586l4.243 4.242-1.415 1.415L13 16.415V22h-2v-5.587l-1.828 1.83-1.415-1.415L12 12.586zM12 2a7.001 7.001 0 016.954 6.194 5.5 5.5 0 01-.953 10.784v-2.014a3.5 3.5 0 10-1.112-6.91 5 5 0 10-9.777 0 3.5 3.5 0 00-1.292 6.88l.18.03v2.014a5.5 5.5 0 01-.954-10.784A7 7 0 0112 2z"
            })
        ]
    });
/* harmony default export */ var UploadCloud2Line = ((/* unused pure expression or super */ null && (SvgUploadCloud2Line)));

;// CONCATENATED MODULE: ./src/components/icons/System/UploadCloudFill.tsx

const SvgUploadCloudFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20.981a6.5 6.5 0 01-2.936-12 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12V21H7v-.019zM13 13h3l-4-5-4 5h3v4h2v-4z"
            })
        ]
    });
/* harmony default export */ var UploadCloudFill = ((/* unused pure expression or super */ null && (SvgUploadCloudFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/UploadCloudLine.tsx

const SvgUploadCloudLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1 14.5a6.496 6.496 0 013.064-5.519 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 002.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 00-11.903 0l-.12.942-.805.503a4.5 4.5 0 002.029 8.309l.173.013h9.35l.173-.013zM13 13v4h-2v-4H8l4-5 4 5h-3z"
            })
        ]
    });
/* harmony default export */ var UploadCloudLine = ((/* unused pure expression or super */ null && (SvgUploadCloudLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/UploadFill.tsx

const SvgUploadFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 19h18v2H3v-2zm10-9v8h-2v-8H4l8-8 8 8h-7z"
            })
        ]
    });
/* harmony default export */ var UploadFill = ((/* unused pure expression or super */ null && (SvgUploadFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/UploadLine.tsx

const SvgUploadLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 19h18v2H3v-2zM13 5.828V17h-2V5.828L4.929 11.9l-1.414-1.414L12 2l8.485 8.485-1.414 1.414L13 5.83z"
            })
        ]
    });
/* harmony default export */ var UploadLine = ((/* unused pure expression or super */ null && (SvgUploadLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ZoomInFill.tsx

const SvgZoomInFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zM10 10H7v2h3v3h2v-3h3v-2h-3V7h-2v3z"
            })
        ]
    });
/* harmony default export */ var ZoomInFill = ((/* unused pure expression or super */ null && (SvgZoomInFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ZoomInLine.tsx

const SvgZoomInLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0018 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15zM10 10V7h2v3h3v2h-3v3h-2v-3H7v-2h3z"
            })
        ]
    });
/* harmony default export */ var ZoomInLine = ((/* unused pure expression or super */ null && (SvgZoomInLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/ZoomOutFill.tsx

const SvgZoomOutFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zM7 10v2h8v-2H7z"
            })
        ]
    });
/* harmony default export */ var ZoomOutFill = ((/* unused pure expression or super */ null && (SvgZoomOutFill)));

;// CONCATENATED MODULE: ./src/components/icons/System/ZoomOutLine.tsx

const SvgZoomOutLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0018 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15zM7 10h8v2H7v-2z"
            })
        ]
    });
/* harmony default export */ var ZoomOutLine = ((/* unused pure expression or super */ null && (SvgZoomOutLine)));

;// CONCATENATED MODULE: ./src/components/icons/System/index.tsx












































































































































































































































































































/***/ }),

/***/ 9230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/icons/Logos/AlipayFill.tsx

const SvgAlipayFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.422 15.358c-3.83-1.153-6.055-1.84-6.678-2.062a12.41 12.41 0 001.32-3.32H12.8V8.872h4v-.68h-4V6.344h-1.536c-.28 0-.312.248-.312.248v1.592H7.2v.68h3.752v1.104H7.88v.616h6.224a10.972 10.972 0 01-.888 2.176c-1.408-.464-2.192-.784-3.912-.944-3.256-.312-4.008 1.48-4.128 2.576C5 16.064 6.48 17.424 8.688 17.424s3.68-1.024 5.08-2.72c1.167.558 3.338 1.525 6.514 2.902A9.99 9.99 0 0112 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.983 9.983 0 01-.578 3.358zm-12.99 1.01c-2.336 0-2.704-1.48-2.584-2.096.12-.616.8-1.416 2.104-1.416 1.496 0 2.832.384 4.44 1.16-1.136 1.48-2.52 2.352-3.96 2.352z"
            })
        ]
    });
/* harmony default export */ var AlipayFill = ((/* unused pure expression or super */ null && (SvgAlipayFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AlipayLine.tsx

const SvgAlipayLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.408 16.79c-2.173-.95-3.72-1.646-4.64-2.086-1.4 1.696-2.872 2.72-5.08 2.72S5 16.064 5.176 14.392c.12-1.096.872-2.888 4.128-2.576 1.72.16 2.504.48 3.912.944.36-.664.664-1.4.888-2.176H7.88v-.616h3.072V8.864H7.2v-.68h3.752V6.592s.032-.248.312-.248H12.8v1.848h4v.68h-4v1.104h3.264a12.41 12.41 0 01-1.32 3.32c.51.182 2.097.676 4.76 1.483a8 8 0 10-1.096 2.012zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-3.568-5.632c1.44 0 2.824-.872 3.96-2.352-1.608-.776-2.944-1.16-4.44-1.16-1.304 0-1.984.8-2.104 1.416-.12.616.248 2.096 2.584 2.096z"
            })
        ]
    });
/* harmony default export */ var AlipayLine = ((/* unused pure expression or super */ null && (SvgAlipayLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AmazonFill.tsx

const SvgAmazonFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.996 18.23c0 .727-.405 2.127-1.314 2.896-.182.14-.365.061-.285-.143.265-.648.872-2.147.587-2.492-.2-.262-1.03-.243-1.738-.182-.324.041-.607.06-.828.105-.203.017-.245-.163-.041-.303.262-.185.545-.325.87-.428 1.15-.344 2.48-.137 2.67.083.036.042.08.16.08.463zm-1.921 1.294a7.426 7.426 0 01-.83.55c-2.122 1.275-4.87 1.943-7.258 1.943-3.843 0-7.28-1.417-9.888-3.788-.223-.182-.038-.446.223-.303 2.81 1.64 6.288 2.632 9.889 2.632a19.48 19.48 0 007.035-1.336c.162-.061.344-.144.503-.202.367-.165.69.243.326.504zm-6.17-11.03c0-1.041.041-1.654-.304-2.18-.306-.433-.833-.693-1.568-.652-.798.044-1.655.567-1.874 1.526-.042.22-.171.436-.436.483l-2.436-.31c-.174-.04-.438-.173-.352-.521C7.458 4.088 9.81 3.129 12.033 3h.523c1.22 0 2.787.349 3.79 1.264 1.217 1.136 1.088 2.662 1.088 4.32v3.927c0 1.178.477 1.7.958 2.314.13.219.174.477-.045.655a76.07 76.07 0 01-1.917 1.654c-.174.133-.488.147-.61.045-.77-.645-.958-1.003-1.435-1.658-.83.871-1.526 1.352-2.355 1.613a7.035 7.035 0 01-1.784.216c-2.09 0-3.746-1.303-3.746-3.88 0-2.049 1.09-3.442 2.7-4.101 1.61-.66 3.95-.87 4.704-.874zm-.478 5.192c.52-.872.477-1.586.477-3.185-.651 0-1.306.045-1.871.178-1.045.303-1.874.961-1.874 2.355 0 1.09.567 1.832 1.525 1.832.132 0 .248-.016.349-.045.67-.186 1.088-.522 1.394-1.135z"
            })
        ]
    });
/* harmony default export */ var AmazonFill = ((/* unused pure expression or super */ null && (SvgAmazonFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AmazonLine.tsx

const SvgAmazonLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.625 14.62c-1.107 1.619-2.728 2.384-4.625 2.384-2.304 0-4.276-1.773-3.993-4.124.315-2.608 2.34-3.73 5.708-4.143.601-.073.85-.094 2.147-.19l.138-.01v-.215C15 6.526 13.932 5.3 12.5 5.3c-1.437 0-2.44.747-3.055 2.526l-1.89-.652C8.442 4.604 10.193 3.3 12.5 3.3c2.603 0 4.5 2.178 4.5 5.022 0 2.649.163 4.756.483 5.557.356.892.486 1.117.884 1.613l-1.56 1.251c-.523-.652-.753-1.049-1.181-2.122v-.001zm5.632 5.925c-.271.2-.742.081-.529-.44.265-.648.547-1.408.262-1.752-.21-.255-.467-.382-1.027-.382-.46 0-.69.06-.995.08-.204.013-.293-.297-.091-.44a2.96 2.96 0 01.87-.428c1.15-.344 2.505-.155 2.67.083.365.53-.199 2.569-1.16 3.28zm-1.182-1.084a7.555 7.555 0 01-.83.695c-2.122 1.616-4.87 2.46-7.258 2.46-3.843 0-7.28-1.793-9.888-4.795-.223-.23-.038-.566.223-.384 2.81 2.077 6.288 3.333 9.889 3.333 2.265 0 4.708-.537 7.035-1.693.162-.076.344-.18.503-.254.367-.21.69.306.326.638zm-5.065-8.92c-1.258.094-1.496.113-2.052.181-2.552.313-3.797 1.003-3.965 2.398-.126 1.043.81 1.884 2.007 1.884 2.039 0 3.517-1.228 4.022-4.463h-.012z"
            })
        ]
    });
/* harmony default export */ var AmazonLine = ((/* unused pure expression or super */ null && (SvgAmazonLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AndroidFill.tsx

const SvgAndroidFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.382 3.968A8.962 8.962 0 0112 2c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453A8.962 8.962 0 0121 11v1H3v-1c0-2.125.736-4.078 1.968-5.618L3.515 3.93l1.414-1.414 1.453 1.453zM3 14h18v7a1 1 0 01-1 1H4a1 1 0 01-1-1v-7zm6-5a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z"
            })
        ]
    });
/* harmony default export */ var AndroidFill = ((/* unused pure expression or super */ null && (SvgAndroidFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AndroidLine.tsx

const SvgAndroidLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 13H5v7h14v-7zm0-2a7 7 0 00-14 0h14zM6.382 3.968A8.962 8.962 0 0112 2c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453A8.962 8.962 0 0121 11v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11c0-2.125.736-4.078 1.968-5.618L3.515 3.93l1.414-1.414 1.453 1.453zM9 9a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z"
            })
        ]
    });
/* harmony default export */ var AndroidLine = ((/* unused pure expression or super */ null && (SvgAndroidLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AngularjsFill.tsx

const SvgAngularjsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2l9.3 3.32-1.418 12.31L12 22l-7.882-4.37L2.7 5.32 12 2zm0 2.21L6.186 17.26h2.168l1.169-2.92h4.934l1.17 2.92h2.167L12 4.21zm1.698 8.33h-3.396L12 8.45l1.698 4.09z"
            })
        ]
    });
/* harmony default export */ var AngularjsFill = ((/* unused pure expression or super */ null && (SvgAngularjsFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AngularjsLine.tsx

const SvgAngularjsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.523 16.65l.49-.27 1.118-9.71L12 4.123 4.869 6.669l1.119 9.71.473.263L12 4.21l5.523 12.44zm-1.099.61h-.798l-1.169-2.92H9.523l-1.17 2.92h-.777L12 19.713l4.424-2.453zM12 2l9.3 3.32-1.418 12.31L12 22l-7.882-4.37L2.7 5.32 12 2zm1.698 10.54L12 8.45l-1.698 4.09h3.396z"
            })
        ]
    });
/* harmony default export */ var AngularjsLine = ((/* unused pure expression or super */ null && (SvgAngularjsLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AppStoreFill.tsx

const SvgAppStoreFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM8.823 15.343c-.395-.477-.886-.647-1.479-.509l-.15.041-.59 1.016a.823.823 0 001.366.916l.062-.093.79-1.371zM13.21 8.66c-.488.404-.98 1.597-.29 2.787l3.04 5.266a.824.824 0 001.476-.722l-.049-.1-.802-1.392h1.19a.82.82 0 00.822-.823.82.82 0 00-.72-.816l-.103-.006h-2.14L13.44 9.057l-.23-.396zm.278-3.044a.825.825 0 00-1.063.21l-.062.092-.367.633-.359-.633a.824.824 0 00-1.476.722l.049.1.838 1.457-2.685 4.653H6.266a.82.82 0 00-.822.822c0 .421.312.766.719.817l.103.006h7.48c.34-.64-.06-1.549-.81-1.638l-.121-.007h-2.553l3.528-6.11a.823.823 0 00-.302-1.124z"
            })
        ]
    });
/* harmony default export */ var AppStoreFill = ((/* unused pure expression or super */ null && (SvgAppStoreFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AppStoreLine.tsx

const SvgAppStoreLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zM8.823 15.343l-.79 1.37a.823.823 0 11-1.428-.822l.589-1.016c.66-.206 1.201-.048 1.629.468zM13.21 8.66l2.423 4.194h2.141a.82.82 0 01.823.822.82.82 0 01-.823.823h-1.19l.803 1.391a.824.824 0 01-1.427.823l-3.04-5.266c-.69-1.19-.198-2.383.29-2.787zm.278-3.044c.395.226.528.73.302 1.125l-3.528 6.109h2.553c.826 0 1.29.972.931 1.645h-7.48a.82.82 0 01-.822-.823.82.82 0 01.822-.822h2.097l2.685-4.653-.838-1.456a.824.824 0 011.427-.823l.359.633.367-.633a.823.823 0 011.125-.302z"
            })
        ]
    });
/* harmony default export */ var AppStoreLine = ((/* unused pure expression or super */ null && (SvgAppStoreLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AppleFill.tsx

const SvgAppleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.624 7.222c-.876 0-2.232-.996-3.66-.96-1.884.024-3.612 1.092-4.584 2.784-1.956 3.396-.504 8.412 1.404 11.172.936 1.344 2.04 2.856 3.504 2.808 1.404-.06 1.932-.912 3.636-.912 1.692 0 2.172.912 3.66.876 1.512-.024 2.472-1.368 3.396-2.724 1.068-1.56 1.512-3.072 1.536-3.156-.036-.012-2.94-1.128-2.976-4.488-.024-2.808 2.292-4.152 2.4-4.212-1.32-1.932-3.348-2.148-4.056-2.196-1.848-.144-3.396 1.008-4.26 1.008zm3.12-2.832c.78-.936 1.296-2.244 1.152-3.54-1.116.048-2.46.744-3.264 1.68-.72.828-1.344 2.16-1.176 3.432 1.236.096 2.508-.636 3.288-1.572z"
            })
        ]
    });
/* harmony default export */ var AppleFill = ((/* unused pure expression or super */ null && (SvgAppleFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/AppleLine.tsx

const SvgAppleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.729 8.208c-.473-.037-.981.076-1.759.373.066-.025-.742.29-.968.37-.502.175-.915.271-1.378.271-.458 0-.88-.092-1.366-.255a11.87 11.87 0 01-.505-.186c-.082-.032-.382-.152-.448-.177-.648-.254-1.013-.35-1.316-.342-1.152.015-2.243.68-2.876 1.782-1.292 2.244-.577 6.299 1.312 9.031 1.006 1.444 1.556 1.96 1.778 1.953.222-.01.385-.057.783-.225l.167-.071c1.005-.429 1.71-.618 2.771-.618 1.021 0 1.703.186 2.668.602l.168.072c.398.17.542.208.792.202.358-.005.799-.417 1.778-1.854.268-.391.505-.803.71-1.22a7.354 7.354 0 01-.392-.347c-1.289-1.228-2.086-2.884-2.108-4.93a6.625 6.625 0 011.41-4.181 4.124 4.124 0 00-1.221-.25zm.155-1.994c.708.048 2.736.264 4.056 2.196-.108.06-2.424 1.404-2.4 4.212.036 3.36 2.94 4.476 2.976 4.488-.024.084-.468 1.596-1.536 3.156-.924 1.356-1.884 2.7-3.396 2.724-1.488.036-1.968-.876-3.66-.876-1.704 0-2.232.852-3.636.912-1.464.048-2.568-1.464-3.504-2.808-1.908-2.76-3.36-7.776-1.404-11.172.972-1.692 2.7-2.76 4.584-2.784 1.428-.036 2.784.96 3.66.96.864 0 2.412-1.152 4.26-1.008zm-1.14-1.824c-.78.936-2.052 1.668-3.288 1.572-.168-1.272.456-2.604 1.176-3.432.804-.936 2.148-1.632 3.264-1.68.144 1.296-.372 2.604-1.152 3.54z"
            })
        ]
    });
/* harmony default export */ var AppleLine = ((/* unused pure expression or super */ null && (SvgAppleLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/BaiduFill.tsx

const SvgBaiduFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.927 12.497c2.063-.443 1.782-2.909 1.72-3.448-.101-.83-1.078-2.282-2.405-2.167-1.67.15-1.913 2.561-1.913 2.561-.226 1.115.54 3.497 2.598 3.054zm2.19 4.288c-.06.173-.195.616-.078 1.002.23.866.982.905.982.905h1.08v-2.64H8.944c-.52.154-.77.559-.827.733zm1.638-8.422c1.14 0 2.06-1.312 2.06-2.933 0-1.62-.92-2.93-2.06-2.93-1.137 0-2.06 1.31-2.06 2.93 0 1.621.923 2.933 2.06 2.933zm4.908.193c1.522.198 2.501-1.427 2.696-2.659.199-1.23-.784-2.658-1.862-2.904-1.08-.248-2.429 1.483-2.552 2.61-.147 1.38.197 2.758 1.718 2.953zm0 3.448c-1.865-2.905-4.513-1.723-5.4-.245-.881 1.477-2.256 2.41-2.451 2.658-.198.244-2.846 1.673-2.258 4.284.587 2.609 2.652 2.56 2.652 2.56s1.521.15 3.286-.246c1.766-.391 3.286.098 3.286.098s4.125 1.38 5.253-1.278c1.128-2.66-.637-4.038-.637-4.038s-2.356-1.823-3.732-3.793zm-6.008 7.75c-1.158-.231-1.619-1.021-1.677-1.156-.057-.137-.386-.772-.212-1.853.5-1.619 1.927-1.735 1.927-1.735h1.428v-1.755l1.215.02v6.479h-2.68zm4.59-.019c-1.196-.308-1.251-1.158-1.251-1.158v-3.412l1.251-.02v3.066c.077.328.483.387.483.387h1.271v-3.433h1.332v4.57h-3.086zm7.454-9.11c0-.59-.49-2.364-2.305-2.364-1.819 0-2.062 1.675-2.062 2.859 0 1.13.095 2.707 2.354 2.657 2.26-.05 2.013-2.56 2.013-3.152z"
            })
        ]
    });
/* harmony default export */ var BaiduFill = ((/* unused pure expression or super */ null && (SvgBaiduFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/BaiduLine.tsx

const SvgBaiduLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.564 19.28a9.69 9.69 0 002.496-.217 8.8 8.8 0 012.98-.131c.547.067.985.165 1.288.257 1.078.275 2.61.223 3.005-.41.291-.468.253-.787-.026-1.199a1.886 1.886 0 00-.212-.26 25.006 25.006 0 01-.743-.618 25.618 25.618 0 01-1.753-1.66 16.151 16.151 0 01-1.577-1.893l-.036-.053c-.742-1.139-1.558-1.067-2.002-.317a9.604 9.604 0 01-.955 1.331c-.41.482-.83.89-1.305 1.297-.123.105-.503.42-.412.344-.004.003-.017.015.051-.071-.098.12-.95.877-1.2 1.162-.515.583-.723 1.08-.645 1.48.072.376.219.587.45.745a1.432 1.432 0 00.48.206l.116.007zm7.098-7.276c1.376 1.97 3.732 3.793 3.732 3.793s2.063 1.748.637 4.038c-1.426 2.29-5.253 1.278-5.253 1.278s-1.52-.49-3.286-.098c-1.765.395-3.286.245-3.286.245S5 21.015 4.554 18.701c-.446-2.314 2.06-4.04 2.258-4.284.195-.247 1.512-1.073 2.452-2.658.94-1.586 3.583-2.54 5.398.245zm5.539-1.42c0 .458.19 2.393-1.553 2.432-1.742.038-1.816-1.178-1.816-2.05 0-.913.188-2.205 1.59-2.205 1.4 0 1.779 1.369 1.779 1.824zm-5.43-2.777c-1.18-.152-1.447-1.222-1.333-2.293.096-.875 1.143-2.219 1.981-2.026.837.19 1.6 1.3 1.446 2.254-.151.957-.911 2.218-2.094 2.065zM9.755 7.44c-.86 0-1.56-.993-1.56-2.22 0-1.227.699-2.22 1.56-2.22.863 0 1.56.993 1.56 2.22 0 1.227-.697 2.22-1.56 2.22zm-3.793 4.566c-1.695.365-2.326-1.597-2.14-2.515 0 0 .2-1.987 1.576-2.11 1.093-.095 1.898 1.101 1.981 1.785.051.444.283 2.475-1.417 2.84z"
            })
        ]
    });
/* harmony default export */ var BaiduLine = ((/* unused pure expression or super */ null && (SvgBaiduLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/BehanceFill.tsx

const SvgBehanceFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.443 5.35c.639 0 1.23.05 1.77.198a3.83 3.83 0 011.377.544c.394.247.689.594.885 1.039.197.445.295.99.295 1.583 0 .693-.147 1.286-.491 1.731-.295.446-.787.841-1.377 1.138.836.248 1.475.693 1.868 1.286.394.594.64 1.336.64 2.177 0 .693-.148 1.286-.394 1.781-.246.495-.639.94-1.082 1.237a5.078 5.078 0 01-1.573.692c-.59.149-1.18.248-1.77.248H1V5.35h6.443zm-.394 5.54c.541 0 .984-.148 1.328-.395.344-.247.492-.693.492-1.237 0-.297-.05-.594-.148-.791-.098-.198-.246-.347-.442-.495-.197-.099-.394-.198-.64-.247-.246-.05-.491-.05-.787-.05H4v3.216h3.05zm.148 5.838c.295 0 .59-.05.836-.099a1.72 1.72 0 00.688-.297 1.76 1.76 0 00.492-.544c.098-.247.197-.544.197-.89 0-.693-.197-1.188-.59-1.534-.394-.297-.935-.445-1.574-.445H4v3.81h3.197zm9.492-.05c.393.396.983.594 1.77.594.541 0 1.033-.148 1.426-.395.394-.297.64-.594.738-.891h2.41c-.394 1.187-.984 2.028-1.77 2.572-.788.495-1.722.792-2.853.792a5.753 5.753 0 01-2.115-.396 3.93 3.93 0 01-1.574-1.088 3.93 3.93 0 01-.983-1.633c-.246-.643-.345-1.335-.345-2.127 0-.742.099-1.434.345-2.078a5.34 5.34 0 011.032-1.682c.443-.445.984-.84 1.574-1.088a5.49 5.49 0 012.066-.396c.836 0 1.574.149 2.213.495.64.346 1.131.742 1.525 1.336a6.01 6.01 0 01.885 1.88c.098.692.147 1.385.098 2.176H16c0 .792.295 1.534.689 1.93zm3.098-5.194c-.344-.346-.885-.544-1.525-.544a2.34 2.34 0 00-1.082.247c-.295.149-.491.347-.688.545a1.322 1.322 0 00-.344.692c-.05.248-.099.445-.099.643h4.426c-.098-.742-.344-1.236-.688-1.583zM15.459 6.29h5.508v1.336H15.46V6.29z"
            })
        ]
    });
/* harmony default export */ var BehanceFill = ((/* unused pure expression or super */ null && (SvgBehanceFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/BehanceLine.tsx

const SvgBehanceLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 11a2 2 0 100-4H3v4h4.5zm1 2H3v4h5.5a2 2 0 100-4zm2.063-1.428A4 4 0 018.5 19H1V5h6.5a4 4 0 013.063 6.572zM15.5 6H21v1.5h-5.5V6zm7.5 8.5h-7.5v.25A2.75 2.75 0 0020.7 16h2.134a4.752 4.752 0 01-9.334-1.25v-1.5a4.75 4.75 0 119.5 0v1.25zm-2.104-2a2.751 2.751 0 00-5.292 0h5.292z"
            })
        ]
    });
/* harmony default export */ var BehanceLine = ((/* unused pure expression or super */ null && (SvgBehanceLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/BilibiliFill.tsx

const SvgBilibiliFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.223 3.086a1.25 1.25 0 010 1.768L17.08 5.996h1.17A3.75 3.75 0 0122 9.747v7.5a3.75 3.75 0 01-3.75 3.75H5.75A3.75 3.75 0 012 17.247v-7.5a3.75 3.75 0 013.75-3.75h1.166L5.775 4.855a1.25 1.25 0 111.767-1.768l2.652 2.652c.079.079.145.165.198.257h3.213c.053-.092.12-.18.199-.258l2.651-2.652a1.25 1.25 0 011.768 0zm.027 5.42H5.75a1.25 1.25 0 00-1.247 1.157l-.003.094v7.5c0 .659.51 1.199 1.157 1.246l.093.004h12.5a1.25 1.25 0 001.247-1.157l.003-.093v-7.5c0-.69-.56-1.25-1.25-1.25zm-10 2.5c.69 0 1.25.56 1.25 1.25v1.25a1.25 1.25 0 11-2.5 0v-1.25c0-.69.56-1.25 1.25-1.25zm7.5 0c.69 0 1.25.56 1.25 1.25v1.25a1.25 1.25 0 11-2.5 0v-1.25c0-.69.56-1.25 1.25-1.25z"
            })
        ]
    });
/* harmony default export */ var BilibiliFill = ((/* unused pure expression or super */ null && (SvgBilibiliFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/BilibiliLine.tsx

const SvgBilibiliLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.172 2.757L10.414 6h3.171l3.243-3.242a1 1 0 011.415 1.415L16.414 6H18.5A3.5 3.5 0 0122 9.5v8a3.5 3.5 0 01-3.5 3.5h-13A3.5 3.5 0 012 17.5v-8A3.5 3.5 0 015.5 6h2.085L5.757 4.171a1 1 0 011.415-1.415zM18.5 8h-13a1.5 1.5 0 00-1.493 1.356L4 9.5v8a1.5 1.5 0 001.356 1.493L5.5 19h13a1.5 1.5 0 001.493-1.356L20 17.5v-8A1.5 1.5 0 0018.5 8zM8 11a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"
            })
        ]
    });
/* harmony default export */ var BilibiliLine = ((/* unused pure expression or super */ null && (SvgBilibiliLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/CentosFill.tsx

const SvgCentosFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.06l4.47 4.471L12 22l-4.47-4.47L12 13.06zm-8 3.06L7.879 20H4v-3.88zm16 0V20h-3.88L20 16.12zm-2.47-8.59L22 12l-4.469 4.47-4.47-4.47 4.469-4.47zm-11.06 0L10.94 12l-4.471 4.469L2 12l4.47-4.47zM12 2l4.469 4.469L12 10.939 7.53 6.47 12 2zM7.879 4l-3.88 3.879L4 4h3.879zM20 4v3.879l-3.88-3.88L20 4z"
            })
        ]
    });
/* harmony default export */ var CentosFill = ((/* unused pure expression or super */ null && (SvgCentosFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/CentosLine.tsx

const SvgCentosLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2l4.292 4.292 1.061-1.06L16.121 4H20v3.879l-1.233-1.233-1.06 1.061L22 12l-4.292 4.293 1.059 1.059L20 16.121V20h-3.88l1.232-1.233-1.059-1.06L12 22l-4.293-4.293-1.061 1.06L7.879 20H4v-3.88l1.231 1.232 1.061-1.06L2 12l4.293-4.293-1.062-1.061L4 7.879V4h3.879L6.646 5.23l1.062 1.062L12 2zm0 11.413l-2.88 2.879 2.88 2.88 2.879-2.88L12 13.412zM7.707 9.12L4.828 12l2.878 2.878 2.88-2.88-2.879-2.877zm8.585 0l-2.877 2.878 2.878 2.879L19.172 12l-2.88-2.879zM12 4.828L9.122 7.707l2.879 2.878 2.877-2.879L12 4.828z"
            })
        ]
    });
/* harmony default export */ var CentosLine = ((/* unused pure expression or super */ null && (SvgCentosLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ChromeFill.tsx

const SvgChromeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.827 21.763C5.35 20.771 2 16.777 2 12c0-1.822.487-3.53 1.339-5.002l4.283 7.419a4.999 4.999 0 004.976 2.548l-2.77 4.798zM12 22l4.287-7.425A4.977 4.977 0 0017 12a4.978 4.978 0 00-1-3h5.542A9.98 9.98 0 0122 12c0 5.523-4.477 10-10 10zm2.572-8.455a2.999 2.999 0 01-5.17-.045l-.029-.05a3 3 0 115.225.05l-.026.045zm-9.94-8.306A9.974 9.974 0 0112 2a9.996 9.996 0 018.662 5H12a5.001 5.001 0 00-4.599 3.035L4.632 5.239z"
            })
        ]
    });
/* harmony default export */ var ChromeFill = ((/* unused pure expression or super */ null && (SvgChromeFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ChromeLine.tsx

const SvgChromeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.365 19.833l1.93-3.342a4.499 4.499 0 01-4.234-2.315L4.794 8.52a8.003 8.003 0 005.57 11.313zm2.225.146A8 8 0 0019.602 9.5h-3.86A4.48 4.48 0 0116.5 12a4.48 4.48 0 01-.642 2.318l-3.268 5.66zm1.553-6.691l.022-.038a2.5 2.5 0 10-4.354-.042l.024.042a2.499 2.499 0 004.308.038zm-8.108-6.62l1.929 3.34A4.5 4.5 0 0112 7.5h6.615A7.992 7.992 0 0012 4a7.98 7.98 0 00-5.965 2.669zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
            })
        ]
    });
/* harmony default export */ var ChromeLine = ((/* unused pure expression or super */ null && (SvgChromeLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/CodepenFill.tsx

const SvgCodepenFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10.202L9.303 12 12 13.798 14.697 12 12 10.202zm4.5.596L19.197 9 13 4.869v3.596l3.5 2.333zm3.5.07L18.303 12 20 13.131V10.87zm-3.5 2.334L13 15.535v3.596L19.197 15 16.5 13.202zM11 8.465V4.869L4.803 9 7.5 10.798 11 8.465zM4.803 15L11 19.131v-3.596l-3.5-2.333L4.803 15zm.894-3L4 10.869v2.262L5.697 12zM2 9a1 1 0 01.445-.832l9-6a1 1 0 011.11 0l9 6A1 1 0 0122 9v6a1 1 0 01-.445.832l-9 6a1 1 0 01-1.11 0l-9-6A1 1 0 012 15V9z"
            })
        ]
    });
/* harmony default export */ var CodepenFill = ((/* unused pure expression or super */ null && (SvgCodepenFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/CodepenLine.tsx

const SvgCodepenLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 13.202L13 15.535v3.596L19.197 15 16.5 13.202zM14.697 12L12 10.202 9.303 12 12 13.798 14.697 12zM20 10.869L18.303 12 20 13.131V10.87zM19.197 9L13 4.869v3.596l3.5 2.333L19.197 9zM7.5 10.798L11 8.465V4.869L4.803 9 7.5 10.798zM4.803 15L11 19.131v-3.596l-3.5-2.333L4.803 15zM4 13.131L5.697 12 4 10.869v2.262zM2 9a1 1 0 01.445-.832l9-6a1 1 0 011.11 0l9 6A1 1 0 0122 9v6a1 1 0 01-.445.832l-9 6a1 1 0 01-1.11 0l-9-6A1 1 0 012 15V9z"
            })
        ]
    });
/* harmony default export */ var CodepenLine = ((/* unused pure expression or super */ null && (SvgCodepenLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/CoreosFill.tsx

const SvgCoreosFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-3.671-9.696c-.04.85.037 1.697.118 2.544.005.06.027.074.08.08.406.054.813.102 1.222.127.964.061 1.928.139 2.896.085.55-.03 1.1-.048 1.648-.095a20.59 20.59 0 002.33-.312c.958-.194 1.907-.425 2.8-.845.406-.19.79-.415 1.114-.736.238-.235.408-.507.41-.86a8.92 8.92 0 00-.045-.94 9.022 9.022 0 00-.481-2.18c-.584-1.618-1.51-2.989-2.826-4.07a8.87 8.87 0 00-3.851-1.863c-.5-.105-1.006-.144-1.514-.18-.573-.041-1.064.12-1.488.514-.495.457-.837 1.024-1.122 1.633-.667 1.427-.973 2.954-1.166 4.508a15.215 15.215 0 00-.125 2.59zm3.57-5.03c.959.03 1.77.324 2.494.856a4.326 4.326 0 011.714 2.612c.068.304.097.612.103.922.005.209-.11.362-.262.49-.307.258-.67.401-1.05.508-.74.207-1.496.326-2.265.366-.5.026-1 .035-1.5.01-.192-.01-.385-.024-.577-.032-.06-.002-.08-.02-.084-.081-.023-.434-.057-.868-.05-1.302.016-1.026.094-2.045.397-3.034.1-.329.223-.65.42-.936.173-.25.378-.437.66-.38z"
            })
        ]
    });
/* harmony default export */ var CoreosFill = ((/* unused pure expression or super */ null && (SvgCoreosFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/CoreosLine.tsx

const SvgCoreosLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.42 4.4a8 8 0 1010.202 9.91c-3.4 1.46-7.248 1.98-11.545 1.565-.711-4.126-.264-7.95 1.343-11.475zm2.448-.414a16.805 16.805 0 00-1.542 3.769 5.98 5.98 0 014.115 1.756 5.977 5.977 0 011.745 3.861c1.33-.341 2.589-.82 3.78-1.433a7.994 7.994 0 00-8.098-7.953zM4.895 19.057C.99 15.152.99 8.82 4.895 4.915c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0zm5.02-9.293a17.885 17.885 0 00-.076 4.229 23.144 23.144 0 004.36-.22 3.988 3.988 0 00-1.172-2.848 3.99 3.99 0 00-3.112-1.161z"
            })
        ]
    });
/* harmony default export */ var CoreosLine = ((/* unused pure expression or super */ null && (SvgCoreosLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DingdingFill.tsx

const SvgDingdingFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.49 9.04l-.006.014c-.42.898-1.516 2.66-1.516 2.66l-.005-.012-.32.558h1.543l-2.948 3.919.67-2.666h-1.215l.422-1.763a16.91 16.91 0 00-1.223.349s-.646.378-1.862-.729c0 0-.82-.722-.344-.902.202-.077.981-.175 1.594-.257.83-.112 1.339-.172 1.339-.172s-2.555.038-3.161-.057c-.606-.095-1.375-1.107-1.539-1.996 0 0-.253-.488.545-.257.798.231 4.101.9 4.101.9S8.27 9.312 7.983 8.99c-.286-.32-.841-1.754-.769-2.634 0 0 .031-.22.257-.16 0 0 3.176 1.45 5.347 2.245 2.172.795 4.06 1.199 3.816 2.228-.02.087-.072.216-.144.37z"
            })
        ]
    });
/* harmony default export */ var DingdingFill = ((/* unused pure expression or super */ null && (SvgDingdingFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DingdingLine.tsx

const SvgDingdingLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4a8 8 0 100 16 8 8 0 000-16zm0-2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4.49 9.04l-.006.014c-.42.898-1.516 2.66-1.516 2.66l-.005-.012-.32.558h1.543l-2.948 3.919.67-2.666h-1.215l.422-1.763a16.91 16.91 0 00-1.223.349s-.646.378-1.862-.729c0 0-.82-.722-.344-.902.202-.077.981-.175 1.594-.257.83-.112 1.339-.172 1.339-.172s-2.555.038-3.161-.057c-.606-.095-1.375-1.107-1.539-1.996 0 0-.253-.488.545-.257.798.231 4.101.9 4.101.9S8.27 9.312 7.983 8.99c-.286-.32-.841-1.754-.769-2.634 0 0 .031-.22.257-.16 0 0 3.176 1.45 5.347 2.245 2.172.795 4.06 1.199 3.816 2.228-.02.087-.072.216-.144.37z"
            })
        ]
    });
/* harmony default export */ var DingdingLine = ((/* unused pure expression or super */ null && (SvgDingdingLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DiscordFill.tsx

const SvgDiscordFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.076 11c.6 0 1.086.45 1.075 1 0 .55-.474 1-1.075 1C9.486 13 9 12.55 9 12s.475-1 1.076-1zm3.848 0c.601 0 1.076.45 1.076 1s-.475 1-1.076 1c-.59 0-1.075-.45-1.075-1s.474-1 1.075-1zm4.967-9C20.054 2 21 2.966 21 4.163V23l-2.211-1.995-1.245-1.176-1.317-1.25.546 1.943H5.109C3.946 20.522 3 19.556 3 18.359V4.163C3 2.966 3.946 2 5.109 2H18.89zm-3.97 13.713c2.273-.073 3.148-1.596 3.148-1.596 0-3.381-1.482-6.122-1.482-6.122-1.48-1.133-2.89-1.102-2.89-1.102l-.144.168c1.749.546 2.561 1.334 2.561 1.334a8.263 8.263 0 00-3.096-1.008 8.527 8.527 0 00-2.077.02c-.062 0-.114.011-.175.021-.36.032-1.235.168-2.335.662-.38.178-.607.305-.607.305s.854-.83 2.705-1.376l-.103-.126s-1.409-.031-2.89 1.103c0 0-1.481 2.74-1.481 6.121 0 0 .864 1.522 3.137 1.596 0 0 .38-.472.69-.871-1.307-.4-1.8-1.24-1.8-1.24s.102.074.287.179c.01.01.02.021.041.031.031.022.062.032.093.053.257.147.514.262.75.357.422.168.926.336 1.513.452a7.06 7.06 0 002.664.01 6.666 6.666 0 001.491-.451c.36-.137.761-.337 1.183-.62 0 0-.514.861-1.862 1.25.309.399.68.85.68.85z"
            })
        ]
    });
/* harmony default export */ var DiscordFill = ((/* unused pure expression or super */ null && (SvgDiscordFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DiscordLine.tsx

const SvgDiscordLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.914 14.58a8.998 8.998 0 01-.484.104 7.06 7.06 0 01-2.664-.01c-.154-.03-.372-.083-.653-.158l-.921 1.197c-2.273-.073-3.137-1.596-3.137-1.596 0-3.381 1.481-6.122 1.481-6.122 1.481-1.133 2.89-1.102 2.89-1.102l.403.525a1.12 1.12 0 01.112-.01 8.527 8.527 0 012.314.01l.442-.525s1.41-.031 2.89 1.103c0 0 1.482 2.74 1.482 6.121 0 0-.875 1.522-3.148 1.596l-1.007-1.134zM10.076 11C9.475 11 9 11.45 9 12s.485 1 1.076 1c.6 0 1.075-.45 1.075-1 .01-.55-.474-1-1.075-1zm3.848 0c-.6 0-1.075.45-1.075 1s.485 1 1.075 1c.601 0 1.076-.45 1.076-1s-.475-1-1.076-1zM21 23l-4.99-5H19V4H5v14h11.003l.57 2H5a2 2 0 01-2-2V4a2 2 0 012-2h14a2 2 0 012 2v19z"
            })
        ]
    });
/* harmony default export */ var DiscordLine = ((/* unused pure expression or super */ null && (SvgDiscordLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DisqusFill.tsx

const SvgDisqusFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-2.53 0-4.84-.94-6.601-2.488L1.5 20l1.424-3.797A9.945 9.945 0 012 12C2 6.477 6.477 2 12 2zM8 7v10h3.733l.263-.004c3.375-.103 5.337-2.211 5.337-5.025v-.027l-.003-.215C17.23 8.956 15.21 7 11.79 7H8zm3.831 2.458c1.628 0 2.709.928 2.709 2.529v.028l-.005.183c-.079 1.5-1.138 2.345-2.704 2.345h-1.108V9.458h1.108z"
            })
        ]
    });
/* harmony default export */ var DisqusFill = ((/* unused pure expression or super */ null && (SvgDisqusFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DisqusLine.tsx

const SvgDisqusLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.95 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.962 9.962 0 01-6.249-2.192l-4.718.59 1.72-4.586A9.944 9.944 0 011.95 12c0-5.523 4.477-10 10-10zm0 2a8 8 0 00-8 8c0 1.178.254 2.318.738 3.362l.176.38-.847 2.26 2.315-.289.338.297A7.96 7.96 0 0011.95 20a8 8 0 000-16zM8 7h3.79c3.42 0 5.44 1.956 5.54 4.729l.003.215v.027c0 2.814-1.962 4.922-5.337 5.025l-.263.004H8V7h3.79H8zm3.831 2.458h-1.108v5.085h1.108c1.566 0 2.625-.845 2.704-2.345l.005-.183v-.028c0-1.6-1.08-2.53-2.709-2.53z"
            })
        ]
    });
/* harmony default export */ var DisqusLine = ((/* unused pure expression or super */ null && (SvgDisqusLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DoubanFill.tsx

const SvgDoubanFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.314 19.138h4.065a.62.62 0 01.621.62v.621a.62.62 0 01-.62.621H3.62a.62.62 0 01-.62-.62v-.621a.62.62 0 01.62-.621h3.754l-.96-3.104h2.19a.62.62 0 01.59.425l.892 2.679H13.6l1.225-4.035H5.172a.62.62 0 01-.62-.62V7.345a.62.62 0 01.62-.62h13.656a.62.62 0 01.62.62v7.138a.62.62 0 01-.62.62h-1.289l-1.225 4.035zM3.931 3h16.138a.62.62 0 01.62.62v.621a.62.62 0 01-.62.621H3.931a.62.62 0 01-.62-.62V3.62A.62.62 0 013.93 3zM7.19 8.586a.155.155 0 00-.156.155v4.035c0 .086.07.155.156.155h9.62c.086 0 .156-.07.156-.155V8.74a.155.155 0 00-.156-.155H7.19z"
            })
        ]
    });
/* harmony default export */ var DoubanFill = ((/* unused pure expression or super */ null && (SvgDoubanFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DoubanLine.tsx

const SvgDoubanLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.273 15H5V7h14v8h-1.624l-1.3 4H21v2H3v-2h4.612L6.8 16.5l1.902-.618L9.715 19h4.259l1.3-4zM3.5 3h17v2h-17V3zM7 9v4h10V9H7z"
            })
        ]
    });
/* harmony default export */ var DoubanLine = ((/* unused pure expression or super */ null && (SvgDoubanLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DribbbleFill.tsx

const SvgDribbbleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2zm6.605 4.61a8.502 8.502 0 011.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.424 25.424 0 00-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362zM12 3.475c2.17 0 4.154.814 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.686 8.686 0 0112 3.475zm-3.633.803a53.903 53.903 0 013.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 014.729-5.975zM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.522 8.522 0 01-2.19-5.705zM12 20.547a8.482 8.482 0 01-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.309 35.309 0 011.823 6.475 8.4 8.4 0 01-3.341.684zm4.761-1.465c-.086-.52-.542-3.015-1.66-6.084 2.68-.423 5.023.271 5.315.369a8.468 8.468 0 01-3.655 5.715z"
            })
        ]
    });
/* harmony default export */ var DribbbleFill = ((/* unused pure expression or super */ null && (SvgDribbbleFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DribbbleLine.tsx

const SvgDribbbleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.989 11.572a7.96 7.96 0 00-1.573-4.351 9.749 9.749 0 01-.92.87 13.157 13.157 0 01-3.313 2.01c.167.35.32.689.455 1.009v.003a9.186 9.186 0 01.11.27c1.514-.17 3.11-.108 4.657.101.206.028.4.058.584.088zm-9.385-7.45a46.164 46.164 0 012.692 4.27c1.223-.482 2.234-1.09 3.048-1.767a7.88 7.88 0 00.796-.755A7.968 7.968 0 0012 4a8.05 8.05 0 00-1.396.121zM4.253 9.997a29.21 29.21 0 002.04-.123 31.53 31.53 0 004.862-.822 54.365 54.365 0 00-2.7-4.227 8.018 8.018 0 00-4.202 5.172zm1.53 7.038c.388-.567.898-1.205 1.575-1.899 1.454-1.49 3.17-2.65 5.156-3.29l.062-.018c-.165-.364-.32-.689-.476-.995-1.836.535-3.77.869-5.697 1.042-.94.085-1.783.122-2.403.128a7.967 7.967 0 001.784 5.032zm9.222 2.38a35.947 35.947 0 00-1.632-5.709c-2.002.727-3.597 1.79-4.83 3.058a9.77 9.77 0 00-1.317 1.655A7.964 7.964 0 0012 20a7.977 7.977 0 003.005-.583zm1.873-1.075a7.998 7.998 0 002.987-4.87c-.34-.085-.771-.17-1.245-.236a12.023 12.023 0 00-3.18-.033 39.368 39.368 0 011.438 5.14zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
            })
        ]
    });
/* harmony default export */ var DribbbleLine = ((/* unused pure expression or super */ null && (SvgDribbbleLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DriveFill.tsx

const SvgDriveFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.94 4.146l3.482 6.03-5.94 10.293L2 14.44 7.94 4.146zm2.176 10.294H22l-3.482 6.029H6.635l3.481-6.029zm4.343-1L8.518 3.145h6.964l5.94 10.295H14.46z"
            })
        ]
    });
/* harmony default export */ var DriveFill = ((/* unused pure expression or super */ null && (SvgDriveFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DriveLine.tsx

const SvgDriveLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.097 6.15L4.31 14.443l1.755 3.032 4.785-8.29L9.097 6.15zm-1.3 12.324h9.568l1.751-3.034H9.55l-1.752 3.034zm11.314-5.034l-4.786-8.29H10.83l4.787 8.29h3.495zM8.52 3.15h6.96L22 14.444l-3.48 6.03H5.49L2 14.444 8.52 3.15zm3.485 8.036l-1.302 2.254h2.603l-1.301-2.254z"
            })
        ]
    });
/* harmony default export */ var DriveLine = ((/* unused pure expression or super */ null && (SvgDriveLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DropboxFill.tsx

const SvgDropboxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.285 10.668l5.215 3.323-5.252 3.346L12 13.993l-5.248 3.344L1.5 13.99l5.215-3.323L1.5 7.346 6.752 4 12 7.343 17.248 4 22.5 7.346l-5.215 3.322zm-.074 0L12 7.348l-5.211 3.32L12 13.988l5.211-3.32zM6.786 18.446l5.252-3.346 5.252 3.346-5.252 3.346-5.252-3.346z"
            })
        ]
    });
/* harmony default export */ var DropboxFill = ((/* unused pure expression or super */ null && (SvgDropboxFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/DropboxLine.tsx

const SvgDropboxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.646 17.26l3.392 2.162 3.392-2.161 1.86 1.185-5.252 3.346-5.252-3.346 1.86-1.185zm-.877-8.28l2.393-1.553-2.425-1.574L5.28 7.37l2.49 1.61zm1.84 1.19L12 11.719l2.39-1.547L12 8.619l-2.391 1.552zm4.231 2.74l2.424 1.568 2.45-1.502-2.485-1.612-2.389 1.545zM12 6.234l4.237-2.748L22.46 7.33l-4.392 2.843 4.393 2.85-6.226 3.819L12 14.1l-4.235 2.74-6.23-3.817 4.396-2.851L1.539 7.33l6.224-3.843L12 6.235zm1.837 1.192L16.23 8.98l2.489-1.61-2.456-1.517-2.426 1.574zM10.16 12.91l-2.39-1.546-2.486 1.613 2.451 1.502 2.425-1.569z"
            })
        ]
    });
/* harmony default export */ var DropboxLine = ((/* unused pure expression or super */ null && (SvgDropboxLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/EdgeFill.tsx

const SvgEdgeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.644 8.586c-.17-.711-.441-1.448-.774-2.021-.771-1.329-1.464-2.237-3.177-3.32C14.98 2.162 13.076 2 12.17 2c-2.415 0-4.211.86-5.525 1.887C3.344 6.47 3 11 3 11s1.221-2.045 3.54-3.526C7.943 6.579 9.941 6 11.568 6 15.885 6 16 10 16 10H9c0-2 1-3 1-3s-5 2-5 7.044c0 .487-.003 1.372.248 2.283.232.843.7 1.705 1.132 2.353 1.221 1.832 3.045 2.614 3.916 2.904.996.332 2.029.416 3.01.416 2.72 0 4.877-.886 5.694-1.275v-4.172c-.758.454-2.679 1.447-5 1.447-5 0-5-4-5-4h12v-2.49s-.039-1.593-.356-2.924z"
            })
        ]
    });
/* harmony default export */ var EdgeFill = ((/* unused pure expression or super */ null && (SvgEdgeFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/EdgeLine.tsx

const SvgEdgeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.007 14.001A4.559 4.559 0 008 14.25C8 16.632 9.753 19 13 19c2.373 0 4.528-.655 6-1.553v3.35C17.211 21.564 15.113 22 13 22c-5.502 0-8-3.47-8-7.75 0-3.231 2.041-6 4.943-7.164C8.539 8.663 8 10.341 8 10.996L18 11c0-3.406-2.548-6-6-6-5 0-8.001 3.988-9 5.999C3.29 6.237 7.01 2 12 2c5.2 0 9 4.03 9 9v3H8l.007.001z"
            })
        ]
    });
/* harmony default export */ var EdgeLine = ((/* unused pure expression or super */ null && (SvgEdgeLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/EvernoteFill.tsx

const SvgEvernoteFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.63 7.754c-.216.201-.546.217-.743.217h-2.11c-.61 0-.974 0-1.22.033-.134.017-.298.084-.381.117-.033.016-.033 0-.017-.016l4.816-4.94c.017-.017.033-.017.017.017a1.734 1.734 0 00-.116.382c-.033.249-.033.615-.033 1.23v2.212c0 .2-.017.533-.214.748zm4.682 14.184c-.56-.366-.857-.848-.973-1.147a2.443 2.443 0 01-.181-.915 2.513 2.513 0 012.507-2.51c.412 0 .742.332.742.748a.735.735 0 01-.38.648.946.946 0 01-.28.1c-.082.017-.396.05-.543.183a.776.776 0 00-.298.582.92.92 0 00.264.649c.297.299.693.465 1.122.465a2.036 2.036 0 002.028-2.045c0-1.014-.676-1.913-1.567-2.311-.132-.067-.346-.117-.544-.167a6.719 6.719 0 00-.495-.083c-.693-.084-2.424-.632-2.54-2.178 0 0-.51 2.328-1.534 2.96-.098.05-.23.1-.379.133-.148.033-.312.05-.363.05-1.665.1-3.43-.433-4.65-1.696 0 0-.825-.682-1.253-2.594-.099-.466-.297-1.298-.412-2.08-.05-.281-.067-.498-.083-.698 0-.814.495-1.363 1.121-1.445h3.365c.576 0 .907-.15 1.121-.35.28-.266.347-.649.347-1.098V3.631c.08-.615.627-1.131 1.434-1.131h.396c.165 0 .363.017.544.033.132.017.247.05.445.1 1.006.25 1.22 1.28 1.22 1.28l2.854.5c.907.166 3.15.316 3.578 2.594 1.006 5.42.396 10.675.347 10.675-.71 5.121-4.931 4.871-4.931 4.871a3.426 3.426 0 01-2.029-.615zm2.622-10.309c-.033.084-.066.183-.05.233.018.05.051.066.084.083.198.1.527.15 1.006.2.478.05.808.083 1.022.05.033 0 .067-.017.1-.067s.016-.15.016-.233c-.05-.449-.462-.781-1.006-.848-.545-.05-1.006.167-1.172.582z"
            })
        ]
    });
/* harmony default export */ var EvernoteFill = ((/* unused pure expression or super */ null && (SvgEvernoteFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/EvernoteLine.tsx

const SvgEvernoteLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5 8.5a1 1 0 01-1 1H6.001c-.336 0-.501.261-.501.532 0 1.32.254 2.372.664 3.193.216.433.399.67.523.79.735.76 1.886 1.16 3.092 1.089.095-.006.199-.064.332-.208a1.51 1.51 0 00.214-.293 2 2 0 012.531-1.073c.693.258 1.277.434 1.813.56.196.046.375.083.586.122-.077-.014.402.074.518.098.34.07.598.146.883.29a5.087 5.087 0 011.775 1.475 32.42 32.42 0 00.087-2.026 34.182 34.182 0 00-.559-6.673c-.074-.398-.236-.562-.663-.718a3.847 3.847 0 00-.587-.155c-.147-.028-.65-.11-.693-.118a1273 1273 0 01-2.34-.409l-.528-.092a2 2 0 01-1.524-1.26 11.467 11.467 0 00-.034-.088 5.595 5.595 0 00-.702-.036c-.271 0-.388.124-.388.463V8.5zm6.23 11.639c.352-.356.56-.829.587-1.327.054-1.036-.824-2.48-2.317-2.634-.617-.063-1.586-.306-2.842-.774 0 0-.7 1.603-2.26 1.696-1.665.1-3.43-.433-4.65-1.696 0 0-1.748-1.64-1.748-5.372 0-.814.29-1.422.648-1.904.96-1.292 2.505-2.78 4.133-4.304C9 3.15 9.701 2.5 10.888 2.5c2.04 0 2.32.664 2.605 1.414l2.854.499c.907.166 3.15.316 3.578 2.594 1.006 5.42.458 9.87.347 10.675-.71 5.121-4.772 4.871-4.931 4.871-2.059 0-3.178-1.373-3.183-2.677a2.494 2.494 0 011.038-2.034 2.586 2.586 0 011.527-.478c.305 0 .687.318.687.753a.74.74 0 01-.382.645c-.223.124-1.122.174-1.122.865 0 .317.35 1.114 1.386 1.114a2.03 2.03 0 001.437-.602zm-1.796-9.51c.166-.415.627-.632 1.172-.582.544.067.956.4 1.006.848 0 .083.017.183-.017.233-.032.05-.066.067-.1.067-.213.033-.543 0-1.021-.05-.48-.05-.808-.1-1.006-.2-.033-.017-.066-.033-.083-.083s.016-.15.05-.233z"
            })
        ]
    });
/* harmony default export */ var EvernoteLine = ((/* unused pure expression or super */ null && (SvgEvernoteLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FacebookBoxFill.tsx

const SvgFacebookBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.402 21v-6.966h2.333l.349-2.708h-2.682V9.598c0-.784.218-1.319 1.342-1.319h1.434V5.857a19.19 19.19 0 00-2.09-.107c-2.067 0-3.482 1.262-3.482 3.58v1.996h-2.338v2.708h2.338V21H4a1 1 0 01-1-1V4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1h-4.598z"
            })
        ]
    });
/* harmony default export */ var FacebookBoxFill = ((/* unused pure expression or super */ null && (SvgFacebookBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FacebookBoxLine.tsx

const SvgFacebookBoxLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 19h5V5H5v14h7v-5h-2v-2h2v-1.654c0-1.337.14-1.822.4-2.311A2.726 2.726 0 0113.536 6.9c.382-.205.857-.328 1.687-.381.329-.021.755.005 1.278.08v1.9H16c-.917 0-1.296.043-1.522.164a.727.727 0 00-.314.314c-.12.226-.164.45-.164 1.368V12h2.5l-.5 2h-2v5zM4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z"
            })
        ]
    });
/* harmony default export */ var FacebookBoxLine = (SvgFacebookBoxLine);

;// CONCATENATED MODULE: ./src/components/icons/Logos/FacebookCircleFill.tsx

const SvgFacebookCircleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"
            })
        ]
    });
/* harmony default export */ var FacebookCircleFill = ((/* unused pure expression or super */ null && (SvgFacebookCircleFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FacebookCircleLine.tsx

const SvgFacebookCircleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 19.938A8.001 8.001 0 0012 4a8 8 0 00-1 15.938V14H9v-2h2v-1.654c0-1.337.14-1.822.4-2.311A2.726 2.726 0 0112.536 6.9c.382-.205.857-.328 1.687-.381.329-.021.755.005 1.278.08v1.9H15c-.917 0-1.296.043-1.522.164a.727.727 0 00-.314.314c-.12.226-.164.45-.164 1.368V12h2.5l-.5 2h-2v5.938zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
            })
        ]
    });
/* harmony default export */ var FacebookCircleLine = ((/* unused pure expression or super */ null && (SvgFacebookCircleLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FacebookFill.tsx

const SvgFacebookFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"
            })
        ]
    });
/* harmony default export */ var FacebookFill = ((/* unused pure expression or super */ null && (SvgFacebookFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FacebookLine.tsx

const SvgFacebookLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 9h4.5l-.5 2h-4v9h-2v-9H7V9h4V7.128c0-1.783.186-2.43.534-3.082a3.635 3.635 0 011.512-1.512C13.698 2.186 14.345 2 16.128 2c.522 0 .98.05 1.372.15V4h-1.372c-1.324 0-1.727.078-2.138.298-.304.162-.53.388-.692.692-.22.411-.298.814-.298 2.138V9z"
            })
        ]
    });
/* harmony default export */ var FacebookLine = ((/* unused pure expression or super */ null && (SvgFacebookLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FinderFill.tsx

const SvgFinderFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zm-1 2h-8.465c-.69 1.977-1.035 4.644-1.035 8h3c-.115.92-.15 1.878-.107 2.877 1.226-.211 2.704-.777 4.027-1.71l1.135 1.665c-1.642 1.095-3.303 1.779-4.976 2.043.052.37.113.745.184 1.125H20V5zM6.555 14.168l-1.11 1.664C7.602 17.27 9.792 18 12 18v-2c-1.792 0-3.602-.603-5.445-1.832zM17 7a1 1 0 011 1v1a1 1 0 01-2 0V8a1 1 0 011-1zM7 7c-.552 0-1 .452-1 1v1a1 1 0 002 0V8a1 1 0 00-1-1z"
            })
        ]
    });
/* harmony default export */ var FinderFill = ((/* unused pure expression or super */ null && (SvgFinderFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FinderLine.tsx

const SvgFinderLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zM10.48 4.999L4 5v14h8.746a26.25 26.25 0 01-.163-1.02c-.297.013-.491.02-.583.02-2.208 0-4.398-.73-6.555-2.168l1.11-1.664C8.398 15.397 10.208 16 12 16c.133 0 .265-.003.398-.01-.024-.497-.024-1.41.007-1.99H9.5v-1c0-3.275.32-5.94.98-8.001zm2.12 0C11.935 6.582 11.556 9.41 11.51 12h3.123l-.14 1.124a15.979 15.979 0 00-.108 2.52c1.013-.3 2.031-.79 3.06-1.476l1.11 1.664c-1.32.88-2.652 1.495-3.993 1.84.057.433.13.876.219 1.327L20 19V5l-7.4-.001zM7 7a1 1 0 011 1v1a1 1 0 01-2 0V8a1 1 0 011-1zm10 0a1 1 0 011 1v1a1 1 0 01-2 0V8a1 1 0 011-1z"
            })
        ]
    });
/* harmony default export */ var FinderLine = ((/* unused pure expression or super */ null && (SvgFinderLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FirefoxFill.tsx

const SvgFirefoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.464.314-2.854.88-4.106.466-.939 1.233-1.874 1.85-2.194-.653 1.283-.973 2.54-1.04 3.383.454-1.5 1.315-2.757 2.52-3.644 2.066-1.519 4.848-1.587 5.956-.62-2.056.707-4.296 3.548-3.803 6.876.08.55.245 1.084.489 1.582-.384-1.01-.418-2.433.202-3.358.692-1.03 1.678-1.248 2.206-1.136-.208-.044-.668.836-.736.991a2.97 2.97 0 00-.251 1.25 3.395 3.395 0 001.03 2.38c1.922 1.871 5.023 1.135 6.412-1.002.953-1.471 1.069-3.968-.155-5.952a6.915 6.915 0 00-1.084-1.32c-1.85-1.766-4.48-2.57-6.982-2.205-1.106.177-2.047.496-2.824.956C7.755 2.798 9.91 2 12 2z"
            })
        ]
    });
/* harmony default export */ var FirefoxFill = ((/* unused pure expression or super */ null && (SvgFirefoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FirefoxLine.tsx

const SvgFirefoxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.464.314-2.854.88-4.106.466-.939 1.233-1.874 1.85-2.194-.653 1.283-.973 2.54-1.04 3.383.454-1.5 1.315-2.757 2.52-3.644 2.066-1.519 4.848-1.587 5.956-.62-2.056.707-4.296 3.548-3.803 6.876.08.55.245 1.084.489 1.582-.384-1.01-.418-2.433.202-3.358.692-1.03 1.678-1.248 2.206-1.136-.208-.044-.668.836-.736.991a2.97 2.97 0 00-.251 1.25 3.395 3.395 0 001.03 2.38c1.922 1.871 5.023 1.135 6.412-1.002.953-1.471 1.069-3.968-.155-5.952a6.915 6.915 0 00-1.084-1.32c-1.85-1.766-4.48-2.57-6.982-2.205-1.106.177-2.047.496-2.824.956C7.755 2.798 9.91 2 12 2zM6.875 7.705c-2.253.781-3.501 3.17-2.579 6.46a8.004 8.004 0 007.455 5.831L12 20a8 8 0 007.985-7.504l.009-.212a6.17 6.17 0 01-.463.98l-.14.227c-2.104 3.239-6.681 4.075-9.48 1.348a5.392 5.392 0 01-.962-1.257l-.106-.201c-1.736-.387-2.584-1.326-2.543-2.817.027-.991.23-1.96.575-2.86z"
            })
        ]
    });
/* harmony default export */ var FirefoxLine = ((/* unused pure expression or super */ null && (SvgFirefoxLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FlutterFill.tsx

const SvgFlutterFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.503 2.001l-10 10 3.083 3.083 13.08-13.083h-6.163zm-.006 9.198L8.122 16.62 13.494 22h6.189l-5.387-5.4 5.389-5.4h-6.188z"
            })
        ]
    });
/* harmony default export */ var FlutterFill = ((/* unused pure expression or super */ null && (SvgFlutterFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/FlutterLine.tsx

const SvgFlutterLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.597 10.684h2.828l-5.657 5.658 5.657 5.656h-2.828L8.94 16.34l5.657-5.657zm-.194-8.68h2.829L5.918 13.318l-1.414-1.414 9.9-9.9z"
            })
        ]
    });
/* harmony default export */ var FlutterLine = ((/* unused pure expression or super */ null && (SvgFlutterLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GatsbyFill.tsx

const SvgGatsbyFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM6.429 17.571c-1.5-1.5-2.286-3.5-2.286-5.428l7.786 7.714c-2-.071-4-.786-5.5-2.286zm7.285 2.072l-9.357-9.357c.786-3.5 3.929-6.143 7.643-6.143 2.643 0 4.929 1.286 6.357 3.214l-1.071.929C16.07 6.643 14.143 5.57 12 5.57c-2.786 0-5.143 1.786-6.071 4.286l8.214 8.214c2.071-.714 3.643-2.5 4.143-4.642h-3.429V12h5c0 3.714-2.643 6.857-6.143 7.643z"
            })
        ]
    });
/* harmony default export */ var GatsbyFill = ((/* unused pure expression or super */ null && (SvgGatsbyFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GatsbyLine.tsx

const SvgGatsbyLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.751 21.997c-5.221-.128-9.45-4.257-9.736-9.438l-.012-.313 9.748 9.751zM12 2a9.988 9.988 0 018.193 4.265l-1.638 1.148A8.003 8.003 0 004.534 9.12L14.88 19.466A8.018 8.018 0 0019.748 14H15.5v-2H22c0 4.726-3.279 8.686-7.685 9.73L2.269 9.686C3.314 5.28 7.274 2 12 2z"
            })
        ]
    });
/* harmony default export */ var GatsbyLine = ((/* unused pure expression or super */ null && (SvgGatsbyLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GithubFill.tsx

const SvgGithubFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.475 2 2 6.475 2 12a9.994 9.994 0 006.838 9.488c.5.087.687-.213.687-.476 0-.237-.013-1.024-.013-1.862-2.512.463-3.162-.612-3.362-1.175-.113-.288-.6-1.175-1.025-1.413-.35-.187-.85-.65-.013-.662.788-.013 1.35.725 1.538 1.025.9 1.512 2.338 1.087 2.912.825.088-.65.35-1.087.638-1.337-2.225-.25-4.55-1.113-4.55-4.938 0-1.088.387-1.987 1.025-2.688-.1-.25-.45-1.275.1-2.65 0 0 .837-.262 2.75 1.026a9.28 9.28 0 012.5-.338c.85 0 1.7.112 2.5.337 1.912-1.3 2.75-1.024 2.75-1.024.55 1.375.2 2.4.1 2.65.637.7 1.025 1.587 1.025 2.687 0 3.838-2.337 4.688-4.562 4.938.362.312.675.912.675 1.85 0 1.337-.013 2.412-.013 2.75 0 .262.188.574.688.474A10.016 10.016 0 0022 12c0-5.525-4.475-10-10-10z"
            })
        ]
    });
/* harmony default export */ var GithubFill = ((/* unused pure expression or super */ null && (SvgGithubFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GithubLine.tsx

const SvgGithubLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.883 18.653c-.3-.2-.558-.455-.86-.816a50.32 50.32 0 01-.466-.579c-.463-.575-.755-.84-1.057-.949a1 1 0 01.676-1.883c.752.27 1.261.735 1.947 1.588-.094-.117.34.427.433.539.19.227.33.365.44.438.204.137.587.196 1.15.14.023-.382.094-.753.202-1.095C5.38 15.31 3.7 13.396 3.7 9.64c0-1.24.37-2.356 1.058-3.292-.218-.894-.185-1.975.302-3.192a1 1 0 01.63-.582c.081-.024.127-.035.208-.047.803-.123 1.937.17 3.415 1.096A11.731 11.731 0 0112 3.315c.912 0 1.818.104 2.684.308 1.477-.933 2.613-1.226 3.422-1.096.085.013.157.03.218.05a1 1 0 01.616.58c.487 1.216.52 2.297.302 3.19.691.936 1.058 2.045 1.058 3.293 0 3.757-1.674 5.665-4.642 6.392.125.415.19.879.19 1.38a300.492 300.492 0 01-.012 2.716 1 1 0 01-.019 1.958c-1.139.228-1.983-.532-1.983-1.525l.002-.446.005-.705c.005-.708.007-1.338.007-1.998 0-.697-.183-1.152-.425-1.36-.661-.57-.326-1.655.54-1.752 2.967-.333 4.337-1.482 4.337-4.66 0-.955-.312-1.744-.913-2.404a1 1 0 01-.19-1.045c.166-.414.237-.957.096-1.614l-.01.003c-.491.139-1.11.44-1.858.949a1 1 0 01-.833.135A9.626 9.626 0 0012 5.315c-.89 0-1.772.119-2.592.35a1 1 0 01-.83-.134c-.752-.507-1.374-.807-1.868-.947-.144.653-.073 1.194.092 1.607a1 1 0 01-.189 1.045C6.016 7.89 5.7 8.694 5.7 9.64c0 3.172 1.371 4.328 4.322 4.66.865.097 1.201 1.177.544 1.748-.192.168-.429.732-.429 1.364v3.15c0 .986-.835 1.725-1.96 1.528a1 1 0 01-.04-1.962v-.99c-.91.061-1.662-.088-2.254-.485z"
            })
        ]
    });
/* harmony default export */ var GithubLine = ((/* unused pure expression or super */ null && (SvgGithubLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GitlabFill.tsx

const SvgGitlabFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.868 2.75L8 10h8l2.132-7.25a.4.4 0 01.765-.01l3.495 10.924a.5.5 0 01-.173.55L12 22 1.78 14.214a.5.5 0 01-.172-.55L5.103 2.74a.4.4 0 01.765.009z"
            })
        ]
    });
/* harmony default export */ var GitlabFill = ((/* unused pure expression or super */ null && (SvgGitlabFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GitlabLine.tsx

const SvgGitlabLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.68 7.314l-1.82 5.914L12 19.442l8.14-6.214-1.82-5.914L16.643 11H7.356L5.681 7.314zM15.357 9l2.888-6.354a.4.4 0 01.747.048l3.367 10.945a.5.5 0 01-.174.544L12 21.958 1.816 14.183a.5.5 0 01-.174-.544L5.009 2.694a.4.4 0 01.747-.048L8.644 9h6.712z"
            })
        ]
    });
/* harmony default export */ var GitlabLine = ((/* unused pure expression or super */ null && (SvgGitlabLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GoogleFill.tsx

const SvgGoogleFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.064 7.51A9.996 9.996 0 0112 2c2.695 0 4.959.99 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123-.2.6-.314 1.24-.314 1.9 0 .66.114 1.3.314 1.9.786 2.364 2.99 4.123 5.595 4.123 1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 001.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045 0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 012 12c0-1.614.386-3.14 1.064-4.49z"
            })
        ]
    });
/* harmony default export */ var GoogleFill = ((/* unused pure expression or super */ null && (SvgGoogleFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GoogleLine.tsx

const SvgGoogleLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11h8.533c.044.385.067.78.067 1.184 0 2.734-.98 5.036-2.678 6.6-1.485 1.371-3.518 2.175-5.942 2.175A8.976 8.976 0 013 11.98 8.976 8.976 0 0111.98 3c2.42 0 4.453.89 6.008 2.339L16.526 6.8C15.368 5.681 13.803 5 12 5a7 7 0 100 14c3.526 0 6.144-2.608 6.577-6H12v-2z"
            })
        ]
    });
/* harmony default export */ var GoogleLine = ((/* unused pure expression or super */ null && (SvgGoogleLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GooglePlayFill.tsx

const SvgGooglePlayFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z"
            })
        ]
    });
/* harmony default export */ var GooglePlayFill = ((/* unused pure expression or super */ null && (SvgGooglePlayFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/GooglePlayLine.tsx

const SvgGooglePlayLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 1.734a1 1 0 01.501.135l16.004 9.266a1 1 0 010 1.73L4.501 22.131A1 1 0 013 21.266V2.734a1 1 0 011-1zm8.292 11.68l-4.498 4.498 5.699-3.299-1.2-1.2zM5 6.118v11.76l5.88-5.88L5 6.118zm10.284 4.302L13.706 12l1.578 1.577L18.008 12l-2.725-1.579zm-7.49-4.336l4.5 4.5 1.199-1.2-5.699-3.3z"
            })
        ]
    });
/* harmony default export */ var GooglePlayLine = ((/* unused pure expression or super */ null && (SvgGooglePlayLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/HonorOfKingsFill.tsx

const SvgHonorOfKingsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.158 4.258c.034 3.5.591 4.811.788 6.701a9.98 9.98 0 01-2.875 8.112c-3.666 3.666-9.471 3.89-13.4.673l2.852-2.853a6.002 6.002 0 008.368-8.368l4.267-4.265zm-2.83-.002l-2.851 2.853a6.002 6.002 0 00-8.368 8.368l-4.267 4.265c-.034-3.5-.591-4.811-.788-6.701a9.98 9.98 0 012.875-8.112c3.666-3.666 9.471-3.89 13.4-.673zM12 8c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 2.5a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0012 10.5z"
            })
        ]
    });
/* harmony default export */ var HonorOfKingsFill = ((/* unused pure expression or super */ null && (SvgHonorOfKingsFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/HonorOfKingsLine.tsx

const SvgHonorOfKingsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.328 4.256l-1.423 1.423a8.002 8.002 0 00-12.272 9.444l2.417-2.417a5.002 5.002 0 017.707-4.878l-1.464 1.464a3 3 0 00-4.001 4.001l-6.45 6.45c-.034-3.5-.591-4.812-.788-6.702a9.98 9.98 0 012.875-8.112c3.666-3.666 9.471-3.89 13.4-.673zm2.83.002c.034 3.5.591 4.811.788 6.701a9.98 9.98 0 01-2.875 8.112c-3.666 3.666-9.471 3.89-13.4.673l1.424-1.423a8.002 8.002 0 0012.272-9.444l-2.417 2.417a5.002 5.002 0 01-7.707 4.878l1.464-1.464a3 3 0 004.001-4.001l6.45-6.45z"
            })
        ]
    });
/* harmony default export */ var HonorOfKingsLine = ((/* unused pure expression or super */ null && (SvgHonorOfKingsLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/IeFill.tsx

const SvgIeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.612 20.12c-2.744 1.49-5.113 1.799-6.422.49-1.344-1.34-.628-4.851 1.313-8.373A23.204 23.204 0 017.127 7.32c.187-.187 1.125-1.124 1.187-1.124 0 0-.5.313-.562.313-1.95 1.095-3.663 3.08-4.037 3.525a9.004 9.004 0 019.468-7.009c3.095-1.402 5.974-1.726 7.192-.51 1.125 1.123 1.062 2.995.125 5.242-.01.021-.018.043-.027.064A8.96 8.96 0 0121.5 12c0 .38-.023.753-.069 1.12h-.804a4.104 4.104 0 01-.142.003H8.689v.187c.062 1.997 1.812 3.744 3.937 3.744 1.5 0 2.937-.811 3.562-1.997h4.78A9.003 9.003 0 018.612 20.12zm-.607-.321a9.03 9.03 0 01-3.972-4.742c-1.161 2.282-1.46 4.19-.469 5.18.813.812 2.438.624 4.438-.436l.003-.002zM20.172 7.292a8.19 8.19 0 01.015-.034c.75-1.622.813-2.994.125-3.806-.869-.868-2.54-.75-4.522.168a9.032 9.032 0 014.382 3.672zm-3.609 3.46v-.061c-.125-2.06-1.75-3.62-3.75-3.62-2.125 0-3.936 1.685-4.061 3.62v.062h7.811z"
            })
        ]
    });
/* harmony default export */ var IeFill = ((/* unused pure expression or super */ null && (SvgIeFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/IeLine.tsx

const SvgIeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.159 10A6.002 6.002 0 006.84 10h11.32zM6.583 13a6.002 6.002 0 0011.08 2.057h3.304A9.003 9.003 0 018.612 20.12c-2.744 1.491-5.113 1.8-6.422.491-1.344-1.34-.628-4.851 1.313-8.373a23.624 23.624 0 012.499-3.665c.359-.433.735-.852 1.125-1.252-.275.055-1.88.851-3.412 2.714a9.004 9.004 0 019.468-7.009c3.095-1.402 5.974-1.726 7.192-.51 1.125 1.123 1.062 2.995.125 5.242-.01.021-.018.043-.027.064A8.96 8.96 0 0121.5 12c0 .338-.019.672-.055 1H6.583zm1.422 6.799a9.03 9.03 0 01-3.972-4.742c-1.161 2.282-1.46 4.19-.469 5.18.813.812 2.438.624 4.438-.436l.003-.002zM20.172 7.292a8.19 8.19 0 01.015-.034c.75-1.622.813-2.994.125-3.806-.869-.868-2.54-.75-4.522.168a9.032 9.032 0 014.382 3.672z"
            })
        ]
    });
/* harmony default export */ var IeLine = ((/* unused pure expression or super */ null && (SvgIeLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/InstagramFill.tsx

const SvgInstagramFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 011.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772 4.915 4.915 0 01-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 100 10 5 5 0 000-10zm6.5-.25a1.25 1.25 0 00-2.5 0 1.25 1.25 0 002.5 0zM12 9a3 3 0 110 6 3 3 0 010-6z"
            })
        ]
    });
/* harmony default export */ var InstagramFill = ((/* unused pure expression or super */ null && (SvgInstagramFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/InstagramLine.tsx

const SvgInstagramLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9a3 3 0 100 6 3 3 0 000-6zm0-2a5 5 0 110 10 5 5 0 010-10zm6.5-.25a1.25 1.25 0 01-2.5 0 1.25 1.25 0 012.5 0zM12 4c-2.474 0-2.878.007-4.029.058-.784.037-1.31.142-1.798.332a2.886 2.886 0 00-1.08.703 2.89 2.89 0 00-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.006 9.075 4 9.461 4 12c0 2.474.007 2.878.058 4.029.037.783.142 1.31.331 1.797.17.435.37.748.702 1.08.337.336.65.537 1.08.703.494.191 1.02.297 1.8.333C9.075 19.994 9.461 20 12 20c2.474 0 2.878-.007 4.029-.058.782-.037 1.309-.142 1.797-.331a2.92 2.92 0 001.08-.702c.337-.337.538-.65.704-1.08.19-.493.296-1.02.332-1.8.052-1.104.058-1.49.058-4.029 0-2.474-.007-2.878-.058-4.029-.037-.782-.142-1.31-.332-1.798a2.911 2.911 0 00-.703-1.08 2.884 2.884 0 00-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.925 4.006 14.539 4 12 4zm0-2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 011.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772 4.915 4.915 0 01-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2z"
            })
        ]
    });
/* harmony default export */ var InstagramLine = ((/* unused pure expression or super */ null && (SvgInstagramLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/InvisionFill.tsx

const SvgInvisionFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm2.988 11.065a3.77 3.77 0 00-.09.79c0 .927.482 1.542 1.508 1.542.851 0 1.541-.526 2.038-1.375l-.303 1.267h1.69l.966-4.031c.241-1.02.71-1.55 1.419-1.55.558 0 .905.36.905.957 0 .173-.015.361-.075.565l-.498 1.853a2.89 2.89 0 00-.106.785c0 .88.498 1.523 1.54 1.523.89 0 1.6-.596 1.992-2.025l-.664-.267c-.332.958-.62 1.13-.846 1.13-.226 0-.347-.156-.347-.47 0-.141.03-.298.076-.487l.483-1.805c.12-.424.166-.8.166-1.145 0-1.35-.785-2.055-1.736-2.055-.89 0-1.796.835-2.248 1.715l.331-1.579h-2.58l-.363 1.39h1.208l-.744 3.098c-.583 1.35-1.656 1.372-1.79 1.34-.222-.051-.363-.139-.363-.438 0-.172.03-.42.106-.718l1.132-4.672H6.927l-.362 1.39h1.192l-.77 3.272zm1.637-5.44a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
            })
        ]
    });
/* harmony default export */ var InvisionFill = ((/* unused pure expression or super */ null && (SvgInvisionFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/InvisionLine.tsx

const SvgInvisionLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5zm1.988 9.065l.77-3.271H6.564l.362-1.39h2.868l-1.132 4.67a3.071 3.071 0 00-.106.72c0 .298.141.386.362.437.135.032 1.208.01 1.791-1.34l.744-3.097h-1.208l.363-1.39h2.58l-.331 1.578c.452-.88 1.358-1.715 2.248-1.715.95 0 1.736.704 1.736 2.055 0 .345-.046.721-.166 1.145l-.483 1.805a2.159 2.159 0 00-.076.487c0 .314.121.47.347.47.227 0 .514-.172.846-1.13l.664.267c-.393 1.429-1.102 2.025-1.993 2.025-1.041 0-1.539-.643-1.539-1.523 0-.25.03-.518.106-.785l.498-1.853a1.96 1.96 0 00.075-.565c0-.596-.347-.958-.905-.958-.71 0-1.178.53-1.419 1.55l-.966 4.032h-1.69l.303-1.267c-.497.85-1.187 1.375-2.038 1.375-1.026 0-1.509-.615-1.509-1.542 0-.235.03-.523.09-.79zm1.637-5.44a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25z"
            })
        ]
    });
/* harmony default export */ var InvisionLine = ((/* unused pure expression or super */ null && (SvgInvisionLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/KakaoTalkFill.tsx

const SvgKakaoTalkFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3c5.799 0 10.5 3.664 10.5 8.185 0 4.52-4.701 8.184-10.5 8.184a13.5 13.5 0 01-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866C1.5 6.665 6.201 3 12 3zm5.907 8.06l1.47-1.424a.472.472 0 00-.656-.678l-1.928 1.866V9.282a.472.472 0 00-.944 0v2.557a.471.471 0 000 .222V13.5a.472.472 0 00.944 0v-1.363l.427-.413 1.428 2.033a.472.472 0 10.773-.543l-1.514-2.155zm-2.958 1.924h-1.46V9.297a.472.472 0 00-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 100-.944zm-5.857-1.092l.696-1.707.638 1.707H9.092zm2.523.488l.002-.016a.469.469 0 00-.127-.32l-1.046-2.8a.69.69 0 00-.627-.474.696.696 0 00-.653.447l-1.661 4.075a.472.472 0 00.874.357l.33-.813h2.07l.299.8a.472.472 0 10.884-.33l-.345-.926zM8.293 9.302a.472.472 0 00-.471-.472H4.577a.472.472 0 100 .944h1.16v3.736a.472.472 0 00.944 0V9.774h1.14a.472.472 0 00.472-.472z"
            })
        ]
    });
/* harmony default export */ var KakaoTalkFill = ((/* unused pure expression or super */ null && (SvgKakaoTalkFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/KakaoTalkLine.tsx

const SvgKakaoTalkLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.678 18.123C3.092 16.566 1.5 14.112 1.5 11.405 1.5 6.701 6.248 3 12 3s10.5 3.701 10.5 8.405c0 4.704-4.748 8.405-10.5 8.405-.442 0-.882-.022-1.318-.065l-3.765 2.458c-.615.326-.957.425-1.485.066-.62-.424-.596-.892-.381-1.56l.627-2.586zM3.5 11.405c0 2.132 1.418 4.123 3.781 5.32l.706.359-.186.77-.401 1.648 2.8-1.83.366.046c.473.061.952.092 1.434.092 4.741 0 8.5-2.93 8.5-6.405S16.741 5 12 5s-8.5 2.93-8.5 6.405zm14.407-.346l1.514 2.155a.472.472 0 11-.773.543l-1.428-2.033-.427.413V13.5a.472.472 0 01-.944 0v-1.439a.471.471 0 010-.222V9.282a.472.472 0 01.944 0v1.542l1.928-1.866a.472.472 0 01.656.678l-1.47 1.423zm-2.958 1.925a.472.472 0 010 .944h-1.932a.472.472 0 01-.471-.472V9.297a.472.472 0 11.943 0v3.687h1.46zm-5.857-1.092h1.334l-.638-1.707-.696 1.707zm2.523.488l.345.925a.472.472 0 11-.884.33l-.298-.799h-2.07l-.331.813a.472.472 0 11-.874-.357l1.66-4.075a.696.696 0 01.654-.447.69.69 0 01.627.474l1.046 2.8a.469.469 0 01.127.32l-.002.016zM8.293 9.302c0 .26-.21.472-.471.472h-1.14v3.736a.472.472 0 01-.945 0V9.774h-1.16a.472.472 0 110-.944h3.245c.26 0 .471.211.471.472z"
            })
        ]
    });
/* harmony default export */ var KakaoTalkLine = ((/* unused pure expression or super */ null && (SvgKakaoTalkLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/LineFill.tsx

const SvgLineFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.663 10.84a.526.526 0 01-.526.525h-1.462v.938h1.462a.525.525 0 110 1.049H16.15a.526.526 0 01-.522-.524V8.852c0-.287.235-.525.525-.525h1.988a.525.525 0 01-.003 1.05h-1.462v.938h1.462c.291 0 .526.237.526.525zm-4.098 2.485a.538.538 0 01-.166.025.515.515 0 01-.425-.208l-2.036-2.764v2.45a.525.525 0 01-1.047 0V8.852a.522.522 0 01.52-.523c.162 0 .312.086.412.211l2.052 2.775V8.852c0-.287.235-.525.525-.525.287 0 .525.238.525.525v3.976a.524.524 0 01-.36.497zm-4.95.027a.526.526 0 01-.523-.524V8.852c0-.287.236-.525.525-.525.289 0 .524.238.524.525v3.976a.527.527 0 01-.526.524zm-1.53 0H6.098a.528.528 0 01-.525-.524V8.852a.527.527 0 011.05 0v3.45h1.464a.525.525 0 010 1.05zM12 2.572c-5.513 0-10 3.643-10 8.118 0 4.01 3.558 7.369 8.363 8.007.325.068.769.215.881.492.1.25.066.638.032.9l-.137.85c-.037.25-.2.988.874.537 1.076-.449 5.764-3.398 7.864-5.812C21.313 14.089 22 12.477 22 10.69c0-4.475-4.488-8.118-10-8.118z"
            })
        ]
    });
/* harmony default export */ var LineFill = ((/* unused pure expression or super */ null && (SvgLineFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/LineLine.tsx

const SvgLineLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10.69c0 1.787-.687 3.4-2.123 4.974-2.1 2.414-6.788 5.363-7.864 5.812-1.074.451-.911-.287-.874-.537l.137-.85c.034-.262.068-.65-.032-.9-.112-.277-.556-.424-.881-.492C5.558 18.059 2 14.7 2 10.69c0-4.475 4.487-8.118 10-8.118 5.512 0 10 3.643 10 8.118zm-3.6 3.625c1.113-1.22 1.6-2.361 1.6-3.625 0-3.268-3.51-6.118-8-6.118s-8 2.85-8 6.118c0 2.905 2.728 5.507 6.626 6.024l.147.026c1.078.226 1.884.614 2.329 1.708l.036.096c1.806-1.176 4.174-2.98 5.261-4.229zm-.262-4a.526.526 0 010 1.05h-1.463v.938h1.462a.525.525 0 110 1.049H16.15a.526.526 0 01-.522-.524V8.852c0-.287.235-.525.525-.525h1.988a.525.525 0 01-.003 1.05h-1.462v.938h1.462zm-3.213 2.513a.524.524 0 01-.526.522.515.515 0 01-.425-.208l-2.036-2.764v2.45a.525.525 0 01-1.047 0V8.852a.522.522 0 01.52-.523c.162 0 .312.086.412.211l2.052 2.775V8.852c0-.287.235-.525.525-.525.287 0 .525.238.525.525v3.976zm-4.784 0a.527.527 0 01-.526.524.526.526 0 01-.523-.524V8.852c0-.287.236-.525.525-.525.289 0 .524.238.524.525v3.976zm-2.055.524H6.097a.528.528 0 01-.525-.524V8.852a.527.527 0 011.05 0v3.45h1.464a.525.525 0 010 1.05z"
            })
        ]
    });
/* harmony default export */ var LineLine = ((/* unused pure expression or super */ null && (SvgLineLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/LinkedinBoxFill.tsx

const SvgLinkedinBoxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.335 18.339H15.67v-4.177c0-.996-.02-2.278-1.39-2.278-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387 2.7 0 3.2 1.778 3.2 4.091v4.715zM7.003 8.575a1.546 1.546 0 01-1.548-1.549 1.548 1.548 0 111.547 1.549zm1.336 9.764H5.666V9.75H8.34v8.589zM19.67 3H4.329C3.593 3 3 3.58 3 4.297v15.406C3 20.42 3.594 21 4.328 21h15.338C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3h.003z"
            })
        ]
    });
/* harmony default export */ var LinkedinBoxFill = ((/* unused pure expression or super */ null && (SvgLinkedinBoxFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/LinkedinBoxLine.tsx

const SvgLinkedinBoxLine = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5zm2.5 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-1 1h2v7.5h-2V10zm5.5.43c.584-.565 1.266-.93 2-.93 2.071 0 3.5 1.679 3.5 3.75v4.25h-2v-4.25a1.75 1.75 0 00-3.5 0v4.25h-2V10h2v.43z"
            })
        ]
    });
/* harmony default export */ var LinkedinBoxLine = (SvgLinkedinBoxLine);

;// CONCATENATED MODULE: ./src/components/icons/Logos/LinkedinFill.tsx

const SvgLinkedinFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.94 5a2 2 0 11-4-.002 2 2 0 014 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z"
            })
        ]
    });
/* harmony default export */ var LinkedinFill = ((/* unused pure expression or super */ null && (SvgLinkedinFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/LinkedinLine.tsx

const SvgLinkedinLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9.55C12.917 8.613 14.111 8 15.5 8a5.5 5.5 0 015.5 5.5V21h-2v-7.5a3.5 3.5 0 00-7 0V21h-2V8.5h2v1.05zM5 6.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-1 2h2V21H4V8.5z"
            })
        ]
    });
/* harmony default export */ var LinkedinLine = ((/* unused pure expression or super */ null && (SvgLinkedinLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MastercardFill.tsx

const SvgMastercardFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6.654a6.786 6.786 0 012.596 5.344A6.786 6.786 0 0112 17.34a6.786 6.786 0 01-2.596-5.343A6.786 6.786 0 0112 6.654zm-.87-.582A7.783 7.783 0 008.4 12a7.783 7.783 0 002.728 5.926 6.798 6.798 0 11.003-11.854zm1.742 11.854A7.783 7.783 0 0015.6 12a7.783 7.783 0 00-2.73-5.928 6.798 6.798 0 11.003 11.854z"
            })
        ]
    });
/* harmony default export */ var MastercardFill = ((/* unused pure expression or super */ null && (SvgMastercardFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MastercardLine.tsx

const SvgMastercardLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18.294a7.3 7.3 0 110-12.588 7.3 7.3 0 110 12.588zm1.702-1.384a5.3 5.3 0 100-9.82A7.273 7.273 0 0115.6 12c0 1.89-.719 3.614-1.898 4.91zm-3.404-9.82a5.3 5.3 0 100 9.82A7.273 7.273 0 018.4 12c0-1.89.719-3.614 1.898-4.91zM12 8.205A5.284 5.284 0 0010.4 12c0 1.488.613 2.832 1.6 3.795A5.284 5.284 0 0013.6 12 5.284 5.284 0 0012 8.205z"
            })
        ]
    });
/* harmony default export */ var MastercardLine = ((/* unused pure expression or super */ null && (SvgMastercardLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MastodonFill.tsx

const SvgMastodonFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.258 13.99c-.274 1.41-2.456 2.955-4.962 3.254-1.306.156-2.593.3-3.965.236-2.243-.103-4.014-.535-4.014-.535 0 .218.014.426.04.62.292 2.215 2.196 2.347 4 2.41 1.82.062 3.44-.45 3.44-.45l.076 1.646s-1.274.684-3.542.81c-1.25.068-2.803-.032-4.612-.51-3.923-1.039-4.598-5.22-4.701-9.464-.031-1.26-.012-2.447-.012-3.44 0-4.34 2.843-5.611 2.843-5.611 1.433-.658 3.892-.935 6.45-.956h.062c2.557.02 5.018.298 6.451.956 0 0 2.843 1.272 2.843 5.61 0 0 .036 3.201-.397 5.424zm-2.956-5.087c0-1.074-.273-1.927-.822-2.558-.567-.631-1.308-.955-2.229-.955-1.065 0-1.871.41-2.405 1.228l-.518.87-.519-.87C11.276 5.8 10.47 5.39 9.405 5.39c-.921 0-1.663.324-2.229.955-.549.631-.822 1.484-.822 2.558v5.253h2.081V9.057c0-1.075.452-1.62 1.357-1.62 1 0 1.501.647 1.501 1.927v2.79h2.07v-2.79c0-1.28.5-1.927 1.5-1.927.905 0 1.358.545 1.358 1.62v5.1h2.08V8.902z"
            })
        ]
    });
/* harmony default export */ var MastodonFill = ((/* unused pure expression or super */ null && (SvgMastodonFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MastodonLine.tsx

const SvgMastodonLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.018 12.008c-.032-1.26-.012-2.448-.012-3.442 0-4.338 2.843-5.61 2.843-5.61 1.433-.658 3.892-.935 6.45-.956h.062c2.557.02 5.018.298 6.451.956 0 0 2.843 1.272 2.843 5.61 0 0 .036 3.201-.396 5.424-.275 1.41-2.457 2.955-4.963 3.254-1.306.156-2.593.3-3.965.236-2.243-.103-4.014-.535-4.014-.535 0 .218.014.426.04.62.084.633.299 1.095.605 1.435.766.85 2.106.93 3.395.974 1.82.063 3.44-.449 3.44-.449l.076 1.646s-1.274.684-3.542.81c-1.25.068-2.803-.032-4.612-.51-1.532-.406-2.568-1.29-3.27-2.471-1.093-1.843-1.368-4.406-1.431-6.992zm3.3 4.937v-2.548l2.474.605a20.54 20.54 0 001.303.245c.753.116 1.538.2 2.328.235 1.019.047 1.901-.017 3.636-.224 1.663-.199 3.148-1.196 3.236-1.65.082-.422.151-.922.206-1.482a33.6 33.6 0 00.137-2.245c.015-.51.02-.945.017-1.256v-.059c0-1.43-.369-2.438-.963-3.158a3.008 3.008 0 00-.584-.548c-.09-.064-.135-.089-.13-.087-1.013-.465-3.093-.752-5.617-.773h-.046c-2.54.02-4.62.308-5.65.782.023-.01-.021.014-.112.078a3.008 3.008 0 00-.584.548c-.594.72-.963 1.729-.963 3.158 0 .232 0 .397-.003.875a77.483 77.483 0 00.014 2.518c.054 2.197.264 3.835.7 5.041.212.587.472 1.07.78 1.45a5.7 5.7 0 01-.18-1.505zM8.084 6.37a1.143 1.143 0 110 2.287 1.143 1.143 0 010-2.287z"
            })
        ]
    });
/* harmony default export */ var MastodonLine = ((/* unused pure expression or super */ null && (SvgMastodonLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MediumFill.tsx

const SvgMediumFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm13.3 12.94c-.1-.05-.15-.2-.15-.301V8.006c0-.1.05-.25.15-.351l.955-1.105V6.5H14.84l-2.56 6.478L9.366 6.5H5.852v.05l.903 1.256c.201.2.251.502.251.753v5.523c.05.302 0 .653-.15.954L5.5 16.894v.05h3.616v-.05L7.76 15.087c-.15-.302-.201-.603-.15-.954V9.11c.05.1.1.1.15.301l3.414 7.633h.05L14.54 8.76c-.05.3-.05.652-.05.904v5.925c0 .15-.05.25-.15.351l-1.005.954v.05h4.921v-.05l-.954-.954z"
            })
        ]
    });
/* harmony default export */ var MediumFill = ((/* unused pure expression or super */ null && (SvgMediumFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MediumLine.tsx

const SvgMediumLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5zm12.3 10.94l.955.954v.05h-4.921v-.05l1.004-.954c.1-.1.15-.2.15-.351V9.664c0-.252 0-.603.051-.904l-3.314 8.285h-.05L7.76 9.412c-.05-.2-.1-.2-.15-.3v5.02c-.051.352 0 .653.15.955l1.356 1.807v.05H5.5v-.05l1.356-1.858c.15-.3.2-.652.15-.954V8.56c0-.251-.05-.553-.25-.753L5.851 6.55V6.5h3.515l2.912 6.478L14.84 6.5h3.415v.05l-.954 1.105c-.1.1-.15.251-.15.351v7.633c0 .1.05.251.15.301z"
            })
        ]
    });
/* harmony default export */ var MediumLine = ((/* unused pure expression or super */ null && (SvgMediumLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MessengerFill.tsx

const SvgMessengerFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.634 0 10 4.127 10 9.7 0 5.573-4.366 9.7-10 9.7a10.894 10.894 0 01-2.895-.384.8.8 0 00-.534.039l-1.984.876a.8.8 0 01-1.123-.707l-.055-1.78a.797.797 0 00-.268-.57C3.195 17.135 2 14.617 2 11.7 2 6.127 6.367 2 12 2zM5.995 14.537c-.282.447.268.951.689.631l3.155-2.394a.6.6 0 01.723 0l2.337 1.75a1.5 1.5 0 002.169-.4l2.937-4.66c.282-.448-.268-.952-.689-.633l-3.155 2.396a.6.6 0 01-.723 0l-2.337-1.75a1.5 1.5 0 00-2.169.4l-2.937 4.66z"
            })
        ]
    });
/* harmony default export */ var MessengerFill = ((/* unused pure expression or super */ null && (SvgMessengerFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MessengerLine.tsx

const SvgMessengerLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.764 19.225c.59-.26 1.25-.309 1.868-.139.77.21 1.565.316 2.368.314 4.585 0 8-3.287 8-7.7S16.585 4 12 4s-8 3.287-8 7.7c0 2.27.896 4.272 2.466 5.676a2.8 2.8 0 01.942 2.006l.356-.157zM12 2c5.634 0 10 4.127 10 9.7 0 5.573-4.366 9.7-10 9.7a10.894 10.894 0 01-2.895-.384.8.8 0 00-.534.039l-1.984.876a.8.8 0 01-1.123-.707l-.055-1.78a.797.797 0 00-.268-.57C3.195 17.135 2 14.617 2 11.7 2 6.127 6.367 2 12 2zM5.995 14.537l2.937-4.66a1.5 1.5 0 012.17-.4l2.336 1.75a.6.6 0 00.723 0l3.155-2.396c.421-.319.971.185.689.633l-2.937 4.66a1.5 1.5 0 01-2.17.4l-2.336-1.75a.6.6 0 00-.723 0l-3.155 2.395c-.421.319-.971-.185-.689-.633z"
            })
        ]
    });
/* harmony default export */ var MessengerLine = ((/* unused pure expression or super */ null && (SvgMessengerLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MicrosoftFill.tsx

const SvgMicrosoftFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.5 3v8.5H3V3h8.5zm0 18H3v-8.5h8.5V21zm1-18H21v8.5h-8.5V3zm8.5 9.5V21h-8.5v-8.5H21z"
            })
        ]
    });
/* harmony default export */ var MicrosoftFill = ((/* unused pure expression or super */ null && (SvgMicrosoftFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MicrosoftLine.tsx

const SvgMicrosoftLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 5H5v6h6V5zm2 0v6h6V5h-6zm6 8h-6v6h6v-6zm-8 6v-6H5v6h6zM3 3h18v18H3V3z"
            })
        ]
    });
/* harmony default export */ var MicrosoftLine = ((/* unused pure expression or super */ null && (SvgMicrosoftLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MiniProgramFill.tsx

const SvgMiniProgramFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.84 12.691l-.067.02a1.522 1.522 0 01-.414.062c-.61 0-.954-.412-.77-.921.136-.372.491-.686.925-.831.672-.245 1.142-.804 1.142-1.455 0-.877-.853-1.587-1.905-1.587s-1.904.71-1.904 1.587v4.868c0 1.17-.679 2.197-1.694 2.778a3.829 3.829 0 01-1.904.502c-1.984 0-3.598-1.471-3.598-3.28 0-.576.164-1.117.451-1.587.444-.73 1.184-1.287 2.07-1.541a1.55 1.55 0 01.46-.073c.612 0 .958.414.773.924-.126.347-.466.645-.861.803a2.162 2.162 0 00-.139.052c-.628.26-1.061.798-1.061 1.422 0 .877.853 1.587 1.905 1.587s1.904-.71 1.904-1.587V9.566c0-1.17.679-2.197 1.694-2.778a3.829 3.829 0 011.904-.502c1.984 0 3.598 1.471 3.598 3.28 0 .576-.164 1.117-.451 1.587-.442.726-1.178 1.282-2.058 1.538zM2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z"
            })
        ]
    });
/* harmony default export */ var MiniProgramFill = ((/* unused pure expression or super */ null && (SvgMiniProgramFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/MiniProgramLine.tsx

const SvgMiniProgramLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-6a3.5 3.5 0 11-4.977-3.174 1 1 0 11.845 1.813A1.5 1.5 0 1011 14v-4a3.5 3.5 0 114.977 3.174 1 1 0 01-.845-1.813A1.5 1.5 0 1013 10v4z"
            })
        ]
    });
/* harmony default export */ var MiniProgramLine = ((/* unused pure expression or super */ null && (SvgMiniProgramLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/NeteaseCloudMusicFill.tsx

const SvgNeteaseCloudMusicFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1.086-10.432c.24-.84 1.075-1.541 1.99-1.648.187.694.388 1.373.545 2.063.053.23.037.495-.018.727-.213.892-1.248 1.242-1.978.685-.53-.405-.742-1.12-.539-1.827zm3.817-.197c-.125-.465-.256-.927-.393-1.42.5.13.908.36 1.255.698 1.257 1.221 1.385 3.3.294 4.731-1.135 1.49-3.155 2.134-5.028 1.605-2.302-.65-3.808-2.952-3.441-5.316.274-1.768 1.27-3.004 2.9-3.733.407-.182.58-.56.42-.93-.157-.364-.54-.504-.944-.343-2.721 1.089-4.32 4.134-3.67 6.987.713 3.118 3.495 5.163 6.675 4.859 1.732-.165 3.164-.948 4.216-2.347 1.506-2.002 1.297-4.783-.463-6.499-.666-.65-1.471-1.018-2.39-1.153-.083-.013-.217-.052-.232-.106-.087-.313-.18-.632-.206-.954-.029-.357.29-.64.65-.645.253-.003.434.13.603.3.303.3.704.322.988.062.29-.264.296-.678.018-1.008-.566-.672-1.586-.891-2.43-.523-.847.37-1.321 1.187-1.2 2.093.038.28.11.557.167.842l-.26.072a3.863 3.863 0 00-2.098 1.414c-.921 1.22-.936 2.828-.041 3.947 1.274 1.594 3.747 1.284 4.523-.568.284-.676.275-1.368.087-2.065z"
            })
        ]
    });
/* harmony default export */ var NeteaseCloudMusicFill = ((/* unused pure expression or super */ null && (SvgNeteaseCloudMusicFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/NeteaseCloudMusicLine.tsx

const SvgNeteaseCloudMusicLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.421 11.375c-.294 1.028.012 2.064.784 2.653 1.061.81 2.565.3 2.874-.995.08-.337.103-.722.027-1.056-.23-1.001-.52-1.988-.792-2.996-1.33.154-2.543 1.172-2.893 2.394zm5.548-.287c.273 1.012.285 2.017-.127 3-1.128 2.69-4.721 3.14-6.573.826-1.302-1.627-1.28-3.961.06-5.734.78-1.032 1.804-1.707 3.048-2.054l.379-.104c-.084-.415-.188-.816-.243-1.224-.176-1.317.512-2.503 1.744-3.04 1.226-.535 2.708-.216 3.53.76.406.479.395 1.08-.025 1.464-.412.377-.996.346-1.435-.09-.247-.246-.51-.44-.877-.436-.525.006-.987.418-.945.937.037.468.173.93.3 1.386.022.078.216.135.338.153 1.334.197 2.504.731 3.472 1.676 2.558 2.493 2.861 6.531.672 9.44-1.529 2.032-3.61 3.168-6.127 3.409-4.621.44-8.664-2.53-9.7-7.058-.945-4.144 1.38-8.568 5.335-10.149.586-.234 1.143-.031 1.371.498.232.537-.019 1.086-.61 1.35-2.368 1.06-3.817 2.855-4.215 5.424-.533 3.433 1.656 6.776 5 7.72 2.723.77 5.658-.166 7.308-2.33 1.586-2.08 1.4-5.099-.427-6.873a3.979 3.979 0 00-1.823-1.013c.198.716.389 1.388.57 2.062z"
            })
        ]
    });
/* harmony default export */ var NeteaseCloudMusicLine = ((/* unused pure expression or super */ null && (SvgNeteaseCloudMusicLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/NetflixFill.tsx

const SvgNetflixFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.29 3.814l2.02 5.707.395 1.116.007-4.81.01-4.818h4.27L18 11.871c.003 5.98-.003 10.89-.015 10.9-.012.009-.209 0-.436-.027a48.722 48.722 0 00-3.34-.282 14.57 14.57 0 01-.636-.038c-.003-.004-.273-.762-.776-2.184v-.004l-2.144-6.061-.34-.954-.008 4.586c-.006 4.365-.01 4.61-.057 4.61-.163 0-1.57.09-2.04.136-.308.027-.926.09-1.37.145-.446.051-.816.085-.823.078C6.006 22.77 6 17.867 6 11.883V1.002h.005V1h4.288l.028.08c.007.016.065.176.157.437l.641 1.778.173.496-.001.023z"
            })
        ]
    });
/* harmony default export */ var NetflixFill = ((/* unused pure expression or super */ null && (SvgNetflixFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/NetflixLine.tsx

const SvgNetflixLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.984 17.208L16 2h2v20a7.593 7.593 0 00-2.02-.5L8 6.302V21.5a7.335 7.335 0 00-2 .5V2h2l7.984 15.208z"
            })
        ]
    });
/* harmony default export */ var NetflixLine = ((/* unused pure expression or super */ null && (SvgNetflixLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/NpmjsFill.tsx

const SvgNpmjsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16zm-3 4H7v10h5V9.5h2.5V17H17V7z"
            })
        ]
    });
/* harmony default export */ var NpmjsFill = ((/* unused pure expression or super */ null && (SvgNpmjsFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/NpmjsLine.tsx

const SvgNpmjsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16zm-1 2H5v14h14V5zm-2 2v10h-2.5V9.5H12V17H7V7h10z"
            })
        ]
    });
/* harmony default export */ var NpmjsLine = ((/* unused pure expression or super */ null && (SvgNpmjsLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/OpenSourceFill.tsx

const SvgOpenSourceFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10 0 4.13-2.504 7.676-6.077 9.201l-2.518-6.55a3 3 0 10-2.809.001l-2.518 6.55A10.005 10.005 0 012 12C2 6.477 6.477 2 12 2z"
            })
        ]
    });
/* harmony default export */ var OpenSourceFill = ((/* unused pure expression or super */ null && (SvgOpenSourceFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/OpenSourceLine.tsx

const SvgOpenSourceLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10 0 4.4-2.841 8.136-6.789 9.473l-.226.074-2.904-7.55A2.016 2.016 0 0014 12a2 2 0 10-2.083 1.998l-2.903 7.549-.225-.074A10.001 10.001 0 012 12C2 6.477 6.477 2 12 2zm0 2a8 8 0 00-4.099 14.872l1.48-3.849A3.999 3.999 0 0112 8a3.999 3.999 0 012.62 7.023c.565 1.474 1.059 2.757 1.479 3.85A8 8 0 0012 4z"
            })
        ]
    });
/* harmony default export */ var OpenSourceLine = ((/* unused pure expression or super */ null && (SvgOpenSourceLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/OperaFill.tsx

const SvgOperaFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.71 6.365c-1.108 1.305-1.823 3.236-1.873 5.4v.47c.051 2.165.766 4.093 1.872 5.4 1.434 1.862 3.566 3.044 5.95 3.044a7.208 7.208 0 004.005-1.226 9.94 9.94 0 01-7.139 2.535A9.998 9.998 0 012 12C2 6.476 6.478 2 12 2h.037a9.97 9.97 0 016.628 2.546 7.239 7.239 0 00-4.008-1.226c-2.382 0-4.514 1.183-5.95 3.045h.002zM22 12a9.969 9.969 0 01-3.335 7.454c-2.565 1.25-4.955.376-5.747-.17 2.52-.554 4.423-3.6 4.423-7.284 0-3.685-1.903-6.73-4.423-7.283.791-.545 3.182-1.42 5.747-.171A9.967 9.967 0 0122 12z"
            })
        ]
    });
/* harmony default export */ var OperaFill = ((/* unused pure expression or super */ null && (SvgOperaFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/OperaLine.tsx

const SvgOperaLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.766 19.51a8.003 8.003 0 000-15.02C16.71 5.977 18 8.935 18 12s-1.289 6.024-3.234 7.51zM9.234 4.49a8.003 8.003 0 000 15.02C7.29 18.023 6 15.065 6 12s1.289-6.024 3.234-7.51zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-3.5c2 0 4-3.033 4-6.5s-2-6.5-4-6.5S8 8.533 8 12s2 6.5 4 6.5z"
            })
        ]
    });
/* harmony default export */ var OperaLine = ((/* unused pure expression or super */ null && (SvgOperaLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PatreonFill.tsx

const SvgPatreonFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 17a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM2 2h4v20H2V2z"
            })
        ]
    });
/* harmony default export */ var PatreonFill = ((/* unused pure expression or super */ null && (SvgPatreonFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PatreonLine.tsx

const SvgPatreonLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 17a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-2a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM2 2h5v20H2V2zm2 2v16h1V4H4z"
            })
        ]
    });
/* harmony default export */ var PatreonLine = ((/* unused pure expression or super */ null && (SvgPatreonLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PaypalFill.tsx

const SvgPaypalFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.067 8.478c.492.88.556 2.014.3 3.327-.74 3.806-3.276 5.12-6.514 5.12h-.5a.805.805 0 00-.794.68l-.04.22-.63 3.993-.032.17a.804.804 0 01-.794.679H7.72a.483.483 0 01-.477-.558L7.418 21h1.518l.95-6.02h1.385c4.678 0 7.75-2.203 8.796-6.502zm-2.96-5.09c.762.868.983 1.81.752 3.285-.019.123-.04.24-.062.36-.735 3.773-3.089 5.446-6.956 5.446H8.957c-.63 0-1.174.414-1.354 1.002l-.014-.002-.93 5.894H3.121a.051.051 0 01-.05-.06l2.598-16.51A.95.95 0 016.607 2h5.976c2.183 0 3.716.469 4.523 1.388z"
            })
        ]
    });
/* harmony default export */ var PaypalFill = ((/* unused pure expression or super */ null && (SvgPaypalFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PaypalLine.tsx

const SvgPaypalLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.495 20.667h1.551l.538-3.376a2.805 2.805 0 012.77-2.366h.5c2.677 0 4.06-.983 4.55-3.503.208-1.066.117-1.73-.171-2.102-1.207 3.054-3.79 4.16-6.962 4.16h-.884c-.384 0-.794.209-.852.58l-1.04 6.607zm-4.944-.294a.551.551 0 01-.544-.637L5.68 2.776A.92.92 0 016.59 2h6.424c2.212 0 3.942.467 4.899 1.558.87.99 1.123 2.084.871 3.692.36.191.668.425.916.706.818.933.978 2.26.668 3.85-.74 3.805-3.276 5.12-6.514 5.12h-.5a.805.805 0 00-.794.679l-.702 4.383a.804.804 0 01-.794.679H6.72a.483.483 0 01-.477-.558l.274-1.736H3.55zm6.836-8.894h.884c3.19 0 4.895-1.212 5.483-4.229.02-.101.037-.203.053-.309.166-1.06.05-1.553-.398-2.063-.465-.53-1.603-.878-3.396-.878h-5.5L5.246 18.373h1.561l.73-4.628.007.001a2.915 2.915 0 012.843-2.267z"
            })
        ]
    });
/* harmony default export */ var PaypalLine = ((/* unused pure expression or super */ null && (SvgPaypalLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PinterestFill.tsx

const SvgPinterestFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.37 2.094A10.003 10.003 0 008.002 21.17a7.757 7.757 0 01.163-2.293c.185-.839 1.296-5.463 1.296-5.463a3.739 3.739 0 01-.324-1.577c0-1.485.857-2.593 1.923-2.593a1.334 1.334 0 011.342 1.508c0 .9-.578 2.262-.88 3.54a1.544 1.544 0 001.575 1.923c1.898 0 3.17-2.431 3.17-5.301 0-2.2-1.457-3.848-4.143-3.848a4.746 4.746 0 00-4.93 4.794 2.96 2.96 0 00.648 1.97.48.48 0 01.162.554c-.046.184-.162.623-.208.784a.354.354 0 01-.51.254c-1.384-.554-2.036-2.077-2.036-3.816 0-2.847 2.384-6.255 7.154-6.255 3.796 0 6.32 2.777 6.32 5.747 0 3.909-2.177 6.848-5.394 6.848a2.861 2.861 0 01-2.454-1.246s-.578 2.316-.692 2.754a8.026 8.026 0 01-1.019 2.131c.923.28 1.882.42 2.846.416a9.988 9.988 0 009.996-10.003 10.002 10.002 0 00-8.635-9.903z"
            })
        ]
    });
/* harmony default export */ var PinterestFill = ((/* unused pure expression or super */ null && (SvgPinterestFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PinterestLine.tsx

const SvgPinterestLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.49 19.191c.024-.336.072-.671.144-1.001.063-.295.254-1.13.534-2.34l.007-.03.387-1.668c.079-.34.14-.604.181-.692a3.46 3.46 0 01-.284-1.423c0-1.337.756-2.373 1.736-2.373.36-.006.704.15.942.426.238.275.348.644.302.996 0 .453-.085.798-.453 2.035-.071.238-.12.404-.166.571-.051.188-.095.358-.132.522-.096.386-.008.797.237 1.106a1.2 1.2 0 001.006.456c1.492 0 2.6-1.985 2.6-4.548 0-1.97-1.29-3.274-3.432-3.274A3.878 3.878 0 009.2 9.1a4.13 4.13 0 00-1.195 2.961 2.553 2.553 0 00.512 1.644c.181.14.25.383.175.59-.041.168-.14.552-.176.68a.41.41 0 01-.216.297.388.388 0 01-.355.002c-1.16-.479-1.796-1.778-1.796-3.44 0-2.985 2.491-5.584 6.192-5.584 3.135 0 5.481 2.329 5.481 5.14 0 3.532-1.932 6.104-4.69 6.104a2.508 2.508 0 01-2.046-.959l-.043.177-.207.852-.002.007c-.146.6-.248 1.017-.288 1.174-.106.355-.24.703-.4 1.04a8 8 0 10-1.656-.593zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
            })
        ]
    });
/* harmony default export */ var PinterestLine = ((/* unused pure expression or super */ null && (SvgPinterestLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PixelfedFill.tsx

const SvgPixelfedFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm1.031 6.099h-2.624c-.988 0-1.789.776-1.789 1.733v6.748l2.595-2.471h1.818c1.713 0 3.101-1.345 3.101-3.005s-1.388-3.005-3.1-3.005z"
            })
        ]
    });
/* harmony default export */ var PixelfedFill = ((/* unused pure expression or super */ null && (SvgPixelfedFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PixelfedLine.tsx

const SvgPixelfedLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm1.031 4.099c1.713 0 3.101 1.345 3.101 3.005s-1.388 3.005-3.1 3.005h-1.819L8.618 16.58V9.832c0-.957.801-1.733 1.79-1.733h2.623z"
            })
        ]
    });
/* harmony default export */ var PixelfedLine = ((/* unused pure expression or super */ null && (SvgPixelfedLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PlaystationFill.tsx

const SvgPlaystationFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.584 17.011c-.43.543-1.482.93-1.482.93l-7.833 2.817V18.68l5.764-2.057c.655-.234.755-.566.223-.74-.53-.175-1.491-.125-2.146.111l-3.84 1.354v-2.155l.22-.075s1.11-.394 2.671-.567c1.56-.172 3.472.024 4.972.593 1.69.535 1.88 1.323 1.451 1.866zm-8.57-3.537V8.162c0-.624-.114-1.198-.699-1.36-.447-.144-.725.272-.725.895V21l-3.584-1.139V4c1.524.283 3.744.953 4.937 1.355 3.035 1.043 4.064 2.342 4.064 5.267 0 2.851-1.758 3.932-3.992 2.852zm-11.583 4.99c-1.735-.49-2.024-1.51-1.233-2.097.731-.542 1.974-.95 1.974-.95l5.138-1.83v2.086l-3.697 1.325c-.653.234-.754.566-.223.74.531.175 1.493.125 2.147-.11l1.773-.644v1.865l-.353.06c-1.774.29-3.664.169-5.526-.445z"
            })
        ]
    });
/* harmony default export */ var PlaystationFill = ((/* unused pure expression or super */ null && (SvgPlaystationFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/PlaystationLine.tsx

const SvgPlaystationLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.584 17.011c-.43.543-1.482.93-1.482.93l-7.833 2.817V18.68l5.764-2.057c.655-.234.755-.566.223-.74-.53-.175-1.491-.125-2.146.111l-3.84 1.354v-2.155l.22-.075s1.11-.394 2.671-.567c1.56-.172 3.472.024 4.972.593 1.69.535 1.88 1.323 1.451 1.866zm-8.57-3.537V8.162c0-.624-.114-1.198-.699-1.36-.447-.144-.725.272-.725.895V21l-3.584-1.139V4c1.524.283 3.744.953 4.937 1.355 3.035 1.043 4.064 2.342 4.064 5.267 0 2.851-1.758 3.932-3.992 2.852zm-11.583 4.99c-1.735-.49-2.024-1.51-1.233-2.097.731-.542 1.974-.95 1.974-.95l5.138-1.83v2.086l-3.697 1.325c-.653.234-.754.566-.223.74.531.175 1.493.125 2.147-.11l1.773-.644v1.865l-.353.06c-1.774.29-3.664.169-5.526-.445z"
            })
        ]
    });
/* harmony default export */ var PlaystationLine = ((/* unused pure expression or super */ null && (SvgPlaystationLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ProductHuntFill.tsx

const SvgProductHuntFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1.334-10H10.5V9h2.834a1.5 1.5 0 010 3zm0-5H8.5v10h2v-3h2.834a3.5 3.5 0 000-7z"
            })
        ]
    });
/* harmony default export */ var ProductHuntFill = ((/* unused pure expression or super */ null && (SvgProductHuntFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ProductHuntLine.tsx

const SvgProductHuntLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1.334-8a1.5 1.5 0 000-3H10.5v3h2.834zm0-5a3.5 3.5 0 010 7H10.5v3h-2V7h4.834z"
            })
        ]
    });
/* harmony default export */ var ProductHuntLine = ((/* unused pure expression or super */ null && (SvgProductHuntLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/QqFill.tsx

const SvgQqFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.913 14.529a31.977 31.977 0 00-.675-1.886l-.91-2.246c0-.026.012-.468.012-.696C18.34 5.86 16.507 2 12 2S5.66 5.86 5.66 9.7c0 .229.011.671.012.697l-.91 2.246a32.777 32.777 0 00-.675 1.886c-.86 2.737-.581 3.87-.369 3.895.455.054 1.771-2.06 1.771-2.06 0 1.224.637 2.822 2.016 3.976-.515.157-1.147.399-1.554.695-.365.267-.319.54-.253.65.289.481 4.955.307 6.303.157 1.347.15 6.014.324 6.302-.158.066-.11.112-.382-.253-.649-.407-.296-1.039-.538-1.555-.696 1.379-1.153 2.016-2.751 2.016-3.976 0 0 1.316 2.115 1.771 2.06.212-.025.49-1.157-.37-3.894"
            })
        ]
    });
/* harmony default export */ var QqFill = ((/* unused pure expression or super */ null && (SvgQqFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/QqLine.tsx

const SvgQqLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.535 12.514l-.696-1.796c0-.021.01-.375.01-.558C16.848 7.088 15.446 4 12 4s-4.848 3.088-4.848 6.16c0 .183.009.537.01.558l-.696 1.796c-.19.515-.38 1.05-.517 1.51-.657 2.189-.444 3.095-.282 3.115.348.043 1.354-1.648 1.354-1.648 0 .98.488 2.258 1.542 3.18-.394.127-.878.32-1.188.557-.28.214-.245.431-.194.52.22.385 3.79.245 4.82.125 1.03.12 4.599.26 4.82-.126.05-.088.085-.305-.194-.519-.311-.237-.795-.43-1.19-.556 1.055-.923 1.542-2.202 1.542-3.181 0 0 1.007 1.691 1.355 1.648.162-.02.378-.928-.283-3.116-.14-.463-.325-.994-.516-1.509zm1.021 8.227c-.373.652-.833.892-1.438 1.057a4.91 4.91 0 01-.794.138c-.44.045-.986.065-1.613.064a33.23 33.23 0 01-2.71-.116c-.692.065-1.785.114-2.71.116a16.07 16.07 0 01-1.614-.064 4.928 4.928 0 01-.793-.138c-.605-.164-1.065-.405-1.44-1.059a2.274 2.274 0 01-.239-1.652c-.592-.132-1.001-.483-1.279-.911a2.43 2.43 0 01-.309-.71 4.028 4.028 0 01-.116-1.106c.013-.785.187-1.762.532-2.912.14-.466.327-1.008.568-1.655l.553-1.43a15.496 15.496 0 01-.002-.203C5.152 5.605 7.588 2 12 2c4.413 0 6.848 3.605 6.848 8.16l-.001.203.553 1.43.01.026c.225.606.413 1.153.556 1.626.348 1.15.522 2.129.535 2.916.007.407-.03.776-.118 1.108-.066.246-.161.48-.31.708-.276.427-.684.776-1.277.91.13.554.055 1.14-.24 1.654z"
            })
        ]
    });
/* harmony default export */ var QqLine = ((/* unused pure expression or super */ null && (SvgQqLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ReactjsFill.tsx

const SvgReactjsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.448 16.24a21.877 21.877 0 01-1.747 2.175c1.672 1.623 3.228 2.383 4.09 1.884.864-.498.983-2.225.414-4.484-.853.19-1.78.334-2.757.425zm-1.31.087a27.512 27.512 0 01-2.276 0c.377.492.758.948 1.138 1.364.38-.416.76-.872 1.138-1.364zm5.04-7.894c2.665.764 4.405 2.034 4.405 3.567 0 1.533-1.74 2.803-4.405 3.567.67 2.69.441 4.832-.886 5.598-1.328.767-3.298-.105-5.292-2.03-1.994 1.925-3.964 2.797-5.292 2.03-1.327-.766-1.557-2.908-.886-5.598-2.665-.764-4.405-2.034-4.405-3.567 0-1.533 1.74-2.803 4.405-3.567-.67-2.69-.441-4.832.886-5.598 1.328-.767 3.298.105 5.292 2.03 1.994-1.925 3.964-2.797 5.292-2.03 1.327.766 1.557 2.908.886 5.598zm-.973-.248c.57-2.26.45-3.986-.413-4.484-.863-.499-2.419.261-4.09 1.884a22.049 22.049 0 011.746 2.175c.978.09 1.904.234 2.757.425zm-10.41 7.63c-.57 2.26-.45 3.986.413 4.484.863.499 2.419-.261 4.09-1.884a21.877 21.877 0 01-1.746-2.175 21.877 21.877 0 01-2.757-.425zm4.067-8.142a27.512 27.512 0 012.276 0A20.523 20.523 0 0012 6.31c-.38.416-.76.872-1.138 1.364zm-1.31.087A21.877 21.877 0 0111.3 5.585C9.627 3.962 8.07 3.202 7.209 3.701c-.864.498-.983 2.225-.414 4.484.853-.19 1.78-.334 2.757-.425zm4.342 7.52A25.368 25.368 0 0015.787 12a25.368 25.368 0 00-1.893-3.28 25.368 25.368 0 00-3.788 0A25.368 25.368 0 008.213 12a25.368 25.368 0 001.893 3.28 25.368 25.368 0 003.788 0zm1.284-.131c.615-.08 1.2-.183 1.75-.304a20.523 20.523 0 00-.612-1.667 27.512 27.512 0 01-1.138 1.97zM8.822 8.85c-.615.08-1.2.183-1.75.304.17.536.374 1.094.612 1.667a27.512 27.512 0 011.138-1.97zm-1.75 5.994c.55.121 1.135.223 1.75.304a27.512 27.512 0 01-1.138-1.97 20.42 20.42 0 00-.612 1.666zm-.978-.245c.261-.834.6-1.708 1.01-2.6a22.002 22.002 0 01-1.01-2.6c-2.242.637-3.677 1.604-3.677 2.6s1.435 1.963 3.677 2.6zm10.834-5.445a20.808 20.808 0 00-1.75-.304 27.511 27.511 0 011.138 1.97c.238-.572.442-1.13.612-1.666zm.978.245c-.261.834-.6 1.708-1.01 2.6.41.892.749 1.766 1.01 2.6 2.242-.637 3.677-1.604 3.677-2.6s-1.435-1.963-3.677-2.6zM12 13.88a1.88 1.88 0 110-3.76 1.88 1.88 0 010 3.76z"
            })
        ]
    });
/* harmony default export */ var ReactjsFill = ((/* unused pure expression or super */ null && (SvgReactjsFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ReactjsLine.tsx

const SvgReactjsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-.528 2.994c.175.21.351.414.528.609.177-.195.353-.398.528-.609a24.883 24.883 0 01-1.056 0zm-1.995-.125a20.678 20.678 0 01-2.285-.368c-.075.35-.132.69-.17 1.016-.19 1.583.075 2.545.478 2.777.403.233 1.368-.019 2.645-.974.263-.197.528-.416.794-.655a20.678 20.678 0 01-1.462-1.796zm7.331-.368a20.17 20.17 0 01-2.285.368 20.678 20.678 0 01-1.462 1.796c.266.24.531.458.794.655 1.277.955 2.242 1.207 2.645.974.403-.232.667-1.194.479-2.777a11.36 11.36 0 00-.17-1.016zm1.45-.387c.577 2.639.274 4.74-1.008 5.48-1.282.74-3.253-.048-5.25-1.867-1.997 1.819-3.968 2.606-5.25 1.866-1.282-.74-1.585-2.84-1.009-5.48C3.167 14.794 1.5 13.48 1.5 12s1.667-2.793 4.241-3.614c-.576-2.639-.273-4.74 1.009-5.48 1.282-.74 3.253.048 5.25 1.867 1.997-1.819 3.968-2.606 5.25-1.866 1.282.74 1.585 2.84 1.009 5.48C20.833 9.206 22.5 10.52 22.5 12s-1.667 2.793-4.241 3.614zm-7.32-9.779a11.36 11.36 0 00-.793-.655C8.868 4.225 7.903 3.973 7.5 4.206c-.403.232-.667 1.194-.479 2.777.04.327.096.666.17 1.016a20.678 20.678 0 012.286-.368c.475-.653.965-1.254 1.462-1.796zm3.585 1.796c.802.084 1.568.209 2.285.368.075-.35.132-.69.17-1.016.19-1.583-.075-2.545-.478-2.777-.403-.233-1.368.019-2.645.974a11.36 11.36 0 00-.794.655c.497.542.987 1.143 1.462 1.796zm-1.995-.125c-.175-.21-.351-.414-.528-.609-.177.195-.353.398-.528.609a24.884 24.884 0 011.056 0zm-4.156 7.198a24.884 24.884 0 01-.528-.914c-.095.257-.183.51-.263.761.257.056.521.107.79.153zm1.932.234a22.897 22.897 0 003.392 0A22.897 22.897 0 0015.392 12a22.897 22.897 0 00-1.696-2.938 22.897 22.897 0 00-3.392 0A22.897 22.897 0 008.608 12a22.897 22.897 0 001.696 2.938zm5.852-4.728c.095-.257.183-.51.263-.761a17.974 17.974 0 00-.79-.153 24.884 24.884 0 01.527.914zM6.13 9.837c-.34.11-.662.23-.964.36C3.701 10.825 3 11.535 3 12c0 .465.7 1.175 2.166 1.803.302.13.624.25.964.36.222-.7.497-1.426.825-2.163a20.678 20.678 0 01-.825-2.163zm1.45-.388c.081.25.169.504.264.76a24.884 24.884 0 01.528-.913c-.27.046-.534.097-.791.153zm10.29 4.714c.34-.11.662-.23.964-.36C20.299 13.175 21 12.465 21 12c0-.465-.7-1.175-2.166-1.803a11.36 11.36 0 00-.964-.36c-.222.7-.497 1.426-.825 2.163.328.737.603 1.462.825 2.163zm-1.45.388a19.17 19.17 0 00-.264-.76 24.884 24.884 0 01-.528.913c.27-.046.534-.097.791-.153z"
            })
        ]
    });
/* harmony default export */ var ReactjsLine = ((/* unused pure expression or super */ null && (SvgReactjsLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/RedditFill.tsx

const SvgRedditFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm6.67-10a1.46 1.46 0 00-2.47-1 7.12 7.12 0 00-3.85-1.23L13 6.65l2.14.45a1 1 0 10.13-.61L12.82 6a.31.31 0 00-.37.24l-.74 3.47a7.14 7.14 0 00-3.9 1.23 1.46 1.46 0 10-1.61 2.39 2.87 2.87 0 000 .44c0 2.24 2.61 4.06 5.83 4.06s5.83-1.82 5.83-4.06a2.87 2.87 0 000-.44 1.46 1.46 0 00.81-1.33zm-10 1a1 1 0 112 0 1 1 0 01-2 0zm5.81 2.75a3.84 3.84 0 01-2.47.77 3.84 3.84 0 01-2.47-.77.27.27 0 01.38-.38A3.27 3.27 0 0012 16a3.28 3.28 0 002.09-.61.28.28 0 11.39.4v-.04zm-.18-1.71a1 1 0 111-1 1 1 0 01-1.01 1.04l.01-.04z"
            })
        ]
    });
/* harmony default export */ var RedditFill = ((/* unused pure expression or super */ null && (SvgRedditFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/RedditLine.tsx

const SvgRedditLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.102 7.815l.751-3.536a2 2 0 012.373-1.54l3.196.68a2 2 0 11-.416 1.956l-3.196-.68-.666 3.135c1.784.137 3.557.73 5.163 1.7a3.192 3.192 0 014.741 2.673v.021a3.192 3.192 0 01-1.207 2.55 2.855 2.855 0 01-.008.123c0 3.998-4.45 7.03-9.799 7.03-5.332 0-9.708-3.024-9.705-6.953a5.31 5.31 0 01-.01-.181 3.192 3.192 0 013.454-5.35 11.446 11.446 0 015.329-1.628zm9.286 5.526c.408-.203.664-.62.661-1.075a1.192 1.192 0 00-2.016-.806l-.585.56-.67-.455c-1.615-1.098-3.452-1.725-5.23-1.764h-1.006c-1.875.029-3.651.6-5.237 1.675l-.663.45-.584-.55a1.192 1.192 0 10-1.314 1.952l.633.29-.054.695c-.013.17-.013.339.003.584 0 2.71 3.356 5.03 7.708 5.03 4.371 0 7.799-2.336 7.802-5.106a3.31 3.31 0 000-.508l-.052-.672.604-.3zM7 13.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm7 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-1.984 5.103c-1.397 0-2.767-.37-3.882-1.21a.424.424 0 01.597-.597c.945.693 2.123.99 3.269.99s2.33-.275 3.284-.959a.439.439 0 01.732.206.469.469 0 01-.119.423c-.684.797-2.484 1.147-3.881 1.147z"
            })
        ]
    });
/* harmony default export */ var RedditLine = ((/* unused pure expression or super */ null && (SvgRedditLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/RemixiconFill.tsx

const SvgRemixiconFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.53 17.53L20 21H3V4h10.667v.008A7.118 7.118 0 0114.136 4c-.089.37-.136.76-.136 1.166C14 7.485 16.015 9.5 18.667 9.5a4.18 4.18 0 002.032-.538 7.003 7.003 0 01-4.17 8.567zM18.5 7.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
            })
        ]
    });
/* harmony default export */ var RemixiconFill = ((/* unused pure expression or super */ null && (SvgRemixiconFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/RemixiconLine.tsx

const SvgRemixiconLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.364 6l8.784 9.663.72-.283c1.685-.661 2.864-2.156 3.092-3.896A6.502 6.502 0 0112.077 6H6.363zM14 5a4.5 4.5 0 006.714 3.918c.186.618.286 1.271.286 1.947 0 2.891-1.822 5.364-4.4 6.377L20 21H3V4h11.111A4.515 4.515 0 0014 5zm4.5 2.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM5 7.47V19h10.48L5 7.47z"
            })
        ]
    });
/* harmony default export */ var RemixiconLine = ((/* unused pure expression or super */ null && (SvgRemixiconLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SafariFill.tsx

const SvgSafariFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.7 6.8l-6.114 3.786L6.8 16.7l-.104-.104-1.415 1.414.708.708 1.414-1.415L7.3 17.2l6.114-3.785L17.2 7.3l.104.104 1.415-1.414-.708-.708-1.414 1.415.104.104zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.5-19v2h1V3h-1zm0 16v2h1v-2h-1zM8.094 3.876l.765 1.848.924-.382-.765-1.848-.924.382zm6.123 14.782l.765 1.848.924-.382-.765-1.848-.924.382zm.765-15.164l-.765 1.848.924.382.765-1.848-.924-.382zM8.86 18.276l-.765 1.848.924.382.765-1.848-.924-.382zM21 11.5h-2v1h2v-1zm-16 0H3v1h2v-1zm15.458 3.615l-1.835-.794-.397.918 1.835.794.397-.918zM5.774 8.761L3.94 7.967l-.397.918 1.835.794.397-.918zm14.35-.667l-1.848.765.382.924 1.848-.765-.382-.924zM5.342 14.217l-1.848.765.382.924 1.848-.765-.382-.924zm13.376 3.793l-1.415-1.414-.707.707 1.414 1.415.708-.708zM7.404 6.697L5.99 5.282l-.708.708 1.415 1.414.707-.707zm3.908 4.615l3.611-2.235-2.235 3.61-1.376-1.375z"
            })
        ]
    });
/* harmony default export */ var SafariFill = ((/* unused pure expression or super */ null && (SvgSafariFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SafariLine.tsx

const SvgSafariLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.812 6.503l-4.398 6.911-6.911 4.398A7.973 7.973 0 0011 19.938V18h2v1.938a7.96 7.96 0 003.906-1.618l-1.37-1.37 1.414-1.414 1.37 1.37A7.96 7.96 0 0019.938 13H18v-2h1.938a7.973 7.973 0 00-2.126-4.497zm-.315-.315A7.973 7.973 0 0013 4.062V6h-2V4.062A7.96 7.96 0 007.094 5.68l1.37 1.37L7.05 8.464l-1.37-1.37A7.96 7.96 0 004.062 11H6v2H4.062a7.973 7.973 0 002.126 4.497l4.398-6.911 6.911-4.398zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
            })
        ]
    });
/* harmony default export */ var SafariLine = ((/* unused pure expression or super */ null && (SvgSafariLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SkypeFill.tsx

const SvgSkypeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.31 20.4a8.5 8.5 0 01-9.71-9.71 5.25 5.25 0 017.09-7.09 8.5 8.5 0 019.71 9.71 5.25 5.25 0 01-7.09 7.09zm-1.258-3.244h-.04c2.872 0 4.303-1.386 4.303-3.243 0-1.198-.551-2.471-2.726-2.958l-1.983-.44c-.755-.172-1.622-.4-1.622-1.115s.62-1.213 1.724-1.213c2.23 0 2.027 1.528 3.131 1.528.576 0 1.093-.342 1.093-.93 0-1.37-2.197-2.4-4.056-2.4-2.021 0-4.173.859-4.173 3.144 0 1.098.394 2.27 2.56 2.813l2.689.671c.816.202 1.018.659 1.018 1.072 0 .687-.684 1.358-1.918 1.358-2.417 0-2.078-1.857-3.374-1.857-.58 0-1.003.398-1.003.971 0 1.114 1.352 2.598 4.377 2.598z"
            })
        ]
    });
/* harmony default export */ var SkypeFill = ((/* unused pure expression or super */ null && (SvgSkypeFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SkypeLine.tsx

const SvgSkypeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.004 18.423a2 2 0 011.237.207 3.25 3.25 0 004.389-4.389 2 2 0 01-.207-1.237 6.5 6.5 0 00-7.427-7.427 2 2 0 01-1.237-.207A3.25 3.25 0 005.37 9.76a2 2 0 01.207 1.237 6.5 6.5 0 007.427 7.427zM12 20.5a8.5 8.5 0 01-8.4-9.81 5.25 5.25 0 017.09-7.09 8.5 8.5 0 019.71 9.71 5.25 5.25 0 01-7.09 7.09c-.427.066-.865.1-1.31.1zm.053-3.5C9.25 17 8 15.62 8 14.586c0-.532.39-.902.928-.902 1.2 0 .887 1.725 3.125 1.725 1.143 0 1.776-.624 1.776-1.261 0-.384-.188-.808-.943-.996l-2.49-.623c-2.006-.504-2.37-1.592-2.37-2.612C8.026 7.797 10.018 7 11.89 7c1.72 0 3.756.956 3.756 2.228 0 .545-.48.863-1.012.863-1.023 0-.835-1.418-2.9-1.418-1.023 0-1.596.462-1.596 1.126 0 .663.803.876 1.502 1.035l1.836.409C15.49 11.695 16 12.876 16 13.989 16 15.713 14.675 17 12.015 17h.038z"
            })
        ]
    });
/* harmony default export */ var SkypeLine = ((/* unused pure expression or super */ null && (SvgSkypeLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SlackFill.tsx

const SvgSlackFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.527 14.514A1.973 1.973 0 014.56 16.48a1.973 1.973 0 01-1.967-1.967c0-1.083.884-1.968 1.967-1.968h1.968v1.968zm.992 0c0-1.083.884-1.968 1.967-1.968 1.083 0 1.968.885 1.968 1.968v4.927a1.973 1.973 0 01-1.968 1.967 1.973 1.973 0 01-1.967-1.967v-4.927zm1.967-7.987A1.973 1.973 0 017.52 4.56c0-1.083.884-1.967 1.967-1.967 1.083 0 1.968.884 1.968 1.967v1.968H9.486zm0 .992c1.083 0 1.968.884 1.968 1.967a1.973 1.973 0 01-1.968 1.968H4.56a1.973 1.973 0 01-1.967-1.968c0-1.083.884-1.967 1.967-1.967h4.927zm7.987 1.967c0-1.083.885-1.967 1.968-1.967s1.967.884 1.967 1.967a1.973 1.973 0 01-1.967 1.968h-1.968V9.486zm-.992 0a1.973 1.973 0 01-1.967 1.968 1.973 1.973 0 01-1.968-1.968V4.56c0-1.083.885-1.967 1.968-1.967s1.967.884 1.967 1.967v4.927zm-1.967 7.987c1.083 0 1.967.885 1.967 1.968a1.973 1.973 0 01-1.967 1.967 1.973 1.973 0 01-1.968-1.967v-1.968h1.968zm0-.992a1.973 1.973 0 01-1.968-1.967c0-1.083.885-1.968 1.968-1.968h4.927c1.083 0 1.967.885 1.967 1.968a1.973 1.973 0 01-1.967 1.967h-4.927z"
            })
        ]
    });
/* harmony default export */ var SlackFill = ((/* unused pure expression or super */ null && (SvgSlackFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SlackLine.tsx

const SvgSlackLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 3A1.5 1.5 0 0116 4.5v5a1.5 1.5 0 01-3 0v-5A1.5 1.5 0 0114.5 3zm-10 10H6v1.5A1.5 1.5 0 114.5 13zm8.5 5h1.5a1.5 1.5 0 11-1.5 1.5V18zm1.5-5h5a1.5 1.5 0 010 3h-5a1.5 1.5 0 010-3zm5-5a1.5 1.5 0 010 3H18V9.5A1.5 1.5 0 0119.5 8zm-15 0h5a1.5 1.5 0 010 3h-5a1.5 1.5 0 010-3zm5-5A1.5 1.5 0 0111 4.5V6H9.5a1.5 1.5 0 010-3zm0 10a1.5 1.5 0 011.5 1.5v5a1.5 1.5 0 01-3 0v-5A1.5 1.5 0 019.5 13z"
            })
        ]
    });
/* harmony default export */ var SlackLine = ((/* unused pure expression or super */ null && (SvgSlackLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SnapchatFill.tsx

const SvgSnapchatFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.871 21.764c-1.19 0-1.984-.561-2.693-1.056-.503-.357-.976-.696-1.533-.79a4.568 4.568 0 00-.803-.066c-.472 0-.847.071-1.114.125-.17.03-.312.058-.424.058-.116 0-.263-.032-.32-.228-.05-.16-.081-.312-.112-.459-.08-.37-.147-.597-.286-.62-1.489-.227-2.38-.57-2.554-.976-.014-.044-.031-.09-.031-.125-.01-.125.08-.227.205-.25 1.181-.196 2.242-.824 3.138-1.858.696-.803 1.035-1.579 1.066-1.663 0-.01.009-.01.009-.01.17-.351.205-.65.102-.895-.191-.46-.825-.656-1.257-.79-.111-.03-.205-.066-.285-.093-.37-.147-.986-.46-.905-.892.058-.312.472-.535.811-.535.094 0 .174.014.24.05.38.173.723.262 1.017.262.366 0 .54-.138.584-.182a24.93 24.93 0 00-.035-.593c-.09-1.365-.192-3.059.24-4.03 1.298-2.907 4.053-3.14 4.869-3.14L12.156 3h.05c.815 0 3.57.227 4.868 3.139.437.971.33 2.67.24 4.03l-.008.067c-.01.182-.023.356-.032.535.045.035.205.169.535.173.286-.008.598-.102.954-.263a.804.804 0 01.312-.066c.125 0 .25.03.357.066h.009c.299.112.495.321.495.54.009.205-.152.517-.914.825-.08.03-.174.067-.285.093-.424.13-1.057.335-1.258.79-.111.24-.066.548.103.895 0 .01.009.01.009.01.049.124 1.337 3.049 4.204 3.526a.246.246 0 01.205.25.267.267 0 01-.031.129c-.174.41-1.057.744-2.555.976-.138.022-.205.25-.285.62a6.831 6.831 0 01-.112.459c-.044.147-.138.227-.298.227h-.023a2.24 2.24 0 01-.423-.049 5.285 5.285 0 00-1.115-.116 4.97 4.97 0 00-.802.067c-.553.09-1.03.433-1.534.79-.717.49-1.515 1.051-2.697 1.051h-.254z"
            })
        ]
    });
/* harmony default export */ var SnapchatFill = ((/* unused pure expression or super */ null && (SvgSnapchatFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SnapchatLine.tsx

const SvgSnapchatLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.396 10.58l.02-.249a32.392 32.392 0 00.083-2.326c0-.87-.294-1.486-.914-2.063-.66-.614-1.459-.942-2.59-.942-1.137 0-1.958.335-2.51.888-.696.695-.958 1.218-.958 2.1 0 .521.061 1.994.096 2.618a2 2 0 01-.469 1.402c.055.098.105.204.153.317.3.771.198 1.543-.152 2.271-.392.818-.731 1.393-1.41 2.154a7.973 7.973 0 01-.642.643 1.999 1.999 0 01.412.565 5.886 5.886 0 011.585.074c.81.146 1.324.434 2.194 1.061l.016.011.213.152c.619.44.877.546 1.473.546.609 0 .91-.121 1.523-.552l.207-.146c.876-.632 1.407-.928 2.231-1.076a6.664 6.664 0 011.559-.074 1.999 1.999 0 01.417-.567 8.409 8.409 0 01-.616-.616 9.235 9.235 0 01-1.447-2.16c-.363-.749-.47-1.54-.137-2.321.04-.098.085-.19.132-.276a2 2 0 01-.469-1.435zm-10.315-.102c.419 0 .6.305 1.219.305.157 0 .26-.035.326-.066-.009-.156-.099-1.986-.099-2.729 0-1.688.72-2.69 1.543-3.514C8.893 3.65 10.175 3 11.996 3c1.82 0 3.066.653 3.952 1.478.886.825 1.551 1.93 1.551 3.528 0 1.555-.099 2.594-.108 2.716a.59.59 0 00.279.065c.63 0 .63-.31 1.33-.31.685 0 .983.57.983.823 0 .621-.833.967-1.33 1.126-.369.117-.931.291-1.075.635-.074.174-.043.4.092.678.003.008 1.26 2.883 3.93 3.326.235.035.391.241.391.483 0 .332-.37.617-.726.782-.443.2-1.091.37-1.952.505-.043.078-.134.485-.235.887-.135.542-.801.366-.991.326A4.997 4.997 0 0016.291 20c-.482.087-.913.378-1.395.726-.713.504-1.465 1.076-2.9 1.076-1.436 0-2.144-.572-2.857-1.076-.482-.348-.905-.637-1.396-.726-.898-.163-1.57.036-1.795.057-.226.02-.842.244-.996-.327-.045-.166-.191-.808-.235-.895-.856-.135-1.508-.313-1.952-.513-.365-.165-.726-.443-.726-.779 0-.235.158-.44.391-.482 2.644-.483 3.766-3.005 3.922-3.33.132-.276.161-.5.091-.679-.143-.343-.704-.513-1.073-.635-.105-.034-1.336-.373-1.336-1.117 0-.24.205-.573.582-.73a1.36 1.36 0 01.465-.092z"
            })
        ]
    });
/* harmony default export */ var SnapchatLine = ((/* unused pure expression or super */ null && (SvgSnapchatLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SoundcloudFill.tsx

const SvgSoundcloudFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.464 8.596c.265 0 .48 2.106.48 4.704l-.001.351c-.019 2.434-.226 4.353-.479 4.353-.256 0-.465-1.965-.48-4.44v-.352c.005-2.558.218-4.616.48-4.616zm-1.664.96c.259 0 .47 1.8.48 4.054v.34c-.01 2.254-.221 4.054-.48 4.054-.255 0-.464-1.755-.48-3.97v-.34l.002-.34c.025-2.133.23-3.798.478-3.798zm-1.664 0c.255 0 .464 1.755.48 3.97v.34l-.002.34c-.025 2.133-.23 3.798-.478 3.798-.259 0-.47-1.8-.48-4.054v-.34c.01-2.254.221-4.054.48-4.054zm-1.664.576c.265 0 .48 1.762.48 3.936l-.002.335c-.02 2.017-.227 3.601-.478 3.601-.262 0-.474-1.717-.48-3.852v-.168c.006-2.135.218-3.852.48-3.852zM3.808 11.86c.265 0 .48 1.375.48 3.072v.158c-.013 1.623-.223 2.914-.48 2.914-.265 0-.48-1.375-.48-3.072v-.158c.013-1.623.223-2.914.48-2.914zm10.784-4.8c2.58 0 4.72 1.886 5.118 4.354a3.36 3.36 0 11.993 6.589l-.063.001h-8.16a.768.768 0 01-.768-.768V7.933a5.16 5.16 0 012.88-.873zM2.144 11.668c.265 0 .48 1.332.48 2.976v.156c-.014 1.57-.223 2.82-.48 2.82-.26 0-.473-1.29-.48-2.898v-.078c0-1.644.215-2.976.48-2.976zm-1.664.96c.265 0 .48.946.48 2.112v.131c-.016 1.105-.225 1.981-.48 1.981-.265 0-.48-.946-.48-2.112v-.131c.016-1.105.225-1.981.48-1.981z"
            })
        ]
    });
/* harmony default export */ var SoundcloudFill = ((/* unused pure expression or super */ null && (SvgSoundcloudFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SoundcloudLine.tsx

const SvgSoundcloudLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10a1 1 0 011 1v7a1 1 0 01-2 0v-7a1 1 0 011-1zm3 1a1 1 0 011 1v6a1 1 0 01-2 0v-6a1 1 0 011-1zm3-4a1 1 0 011 1v10a1 1 0 01-2 0V8a1 1 0 011-1zm5-1a6 6 0 015.996 5.775l.003.26a3.5 3.5 0 01-.307 6.96L20.5 19h-3.501a1 1 0 01-.117-1.993L17 17h3.447l.138-.002a1.5 1.5 0 00.267-2.957l-.135-.026-1.77-.252.053-1.787-.004-.176A4 4 0 0015.2 8.005L15 8c-.268 0-.531.026-.788.077L14 8.126V18a1 1 0 01-.883.993L13 19a1 1 0 01-1-1l-.001-11.197A5.972 5.972 0 0115 6zM1 12a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1z"
            })
        ]
    });
/* harmony default export */ var SoundcloudLine = ((/* unused pure expression or super */ null && (SvgSoundcloudLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SpectrumFill.tsx

const SvgSpectrumFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.2 2.006C21.24 2.093 22 3.25 22 12l-.006 1.2C21.907 21.24 20.75 22 12 22l-1.2-.006c-7.658-.083-8.711-1.136-8.794-8.795L2 11.691l.006-.89c.085-7.85 1.19-8.76 9.382-8.8l1.811.005zM8.25 7h-.583a.667.667 0 00-.66.568L7 7.667v3.666c0 .335.247.612.568.66l.099.007h.583a3.75 3.75 0 013.745 3.55l.005.2v.583c0 .335.247.612.568.66l.099.007h3.666a.667.667 0 00.66-.568l.007-.099v-.583a8.75 8.75 0 00-8.492-8.746L8.25 7z"
            })
        ]
    });
/* harmony default export */ var SpectrumFill = ((/* unused pure expression or super */ null && (SvgSpectrumFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SpectrumLine.tsx

const SvgSpectrumLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.388 2.001l1.811.005.844.014c7.161.164 7.938 1.512 7.957 9.667l-.006 1.512-.014.844c-.164 7.161-1.512 7.938-9.667 7.957l-1.512-.006-.888-.015c-6.853-.163-7.827-1.428-7.907-8.78L2 11.691l.006-.89.014-.865c.165-7.053 1.487-7.897 9.368-7.935zM14.12 4.01L10.882 4l-1.322.01c-5.489.082-5.544.82-5.559 7.403l.001 2.175.01 1.04c.089 4.982.793 5.343 6.4 5.369l3.454-.002.776-.009c5.108-.091 5.347-.837 5.358-6.877l-.003-2.743-.012-1.055c-.094-4.796-.785-5.25-5.865-5.303zM8.25 7A8.75 8.75 0 0117 15.75v.583a.667.667 0 01-.667.667h-3.666a.667.667 0 01-.667-.667v-.583A3.75 3.75 0 008.25 12h-.583A.667.667 0 017 11.333V7.667C7 7.299 7.299 7 7.667 7h.583z"
            })
        ]
    });
/* harmony default export */ var SpectrumLine = ((/* unused pure expression or super */ null && (SvgSpectrumLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SpotifyFill.tsx

const SvgSpotifyFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.55 2 12 2zm3.75 14.65c-2.35-1.45-5.3-1.75-8.8-.95-.35.1-.65-.15-.75-.45-.1-.35.15-.65.45-.75 3.8-.85 7.1-.5 9.7 1.1.35.15.4.55.25.85-.2.3-.55.4-.85.2zm1-2.7c-2.7-1.65-6.8-2.15-9.95-1.15-.4.1-.85-.1-.95-.5-.1-.4.1-.85.5-.95 3.65-1.1 8.15-.55 11.25 1.35.3.15.45.65.2 1s-.7.5-1.05.25zM6.3 9.75c-.5.15-1-.15-1.15-.6-.15-.5.15-1 .6-1.15 3.55-1.05 9.4-.85 13.1 1.35.45.25.6.85.35 1.3-.25.35-.85.5-1.3.25C14.7 9 9.35 8.8 6.3 9.75z"
            })
        ]
    });
/* harmony default export */ var SpotifyFill = ((/* unused pure expression or super */ null && (SvgSpotifyFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SpotifyLine.tsx

const SvgSpotifyLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c5.55 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0 2c-4.395 0-8 3.605-8 8s3.605 8 8 8 8-3.605 8-8c0-4.414-3.573-8-8-8zm3.75 12.65c-2.35-1.45-5.3-1.75-8.8-.95-.35.1-.65-.15-.75-.45-.1-.35.15-.65.45-.75 3.8-.85 7.1-.5 9.7 1.1.35.15.4.55.25.85-.2.3-.55.4-.85.2zm1-2.7c-2.7-1.65-6.8-2.15-9.95-1.15-.4.1-.85-.1-.95-.5-.1-.4.1-.85.5-.95 3.65-1.1 8.15-.55 11.25 1.35.3.15.45.65.2 1s-.7.5-1.05.25zM6.3 9.75c-.5.15-1-.15-1.15-.6-.15-.5.15-1 .6-1.15 3.55-1.05 9.4-.85 13.1 1.35.45.25.6.85.35 1.3-.25.35-.85.5-1.3.25C14.7 9 9.35 8.8 6.3 9.75z"
            })
        ]
    });
/* harmony default export */ var SpotifyLine = ((/* unused pure expression or super */ null && (SvgSpotifyLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/StackOverflowFill.tsx

const SvgStackOverflowFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 20.002V14.67h2v7.333H4V14.67h2v5.333h12zM7.599 14.736l.313-1.98 8.837 1.7-.113 1.586-9.037-1.306zm1.2-4.532l.732-1.6 7.998 3.733-.733 1.599-7.998-3.732zm2.265-3.932l1.133-1.333 6.798 5.665-1.133 1.333-6.798-5.665zm4.332-4.132l5.265 7.064-1.4 1.067-5.264-7.065 1.4-1.066zM7.332 18.668v-2h9.33v2h-9.33z"
            })
        ]
    });
/* harmony default export */ var StackOverflowFill = ((/* unused pure expression or super */ null && (SvgStackOverflowFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/StackOverflowLine.tsx

const SvgStackOverflowLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 20.002V15h2v7.002H4V15h2v5.002h12zM7.5 18v-2h9v2h-9zm.077-4.38l.347-1.97 8.864 1.563-.348 1.97-8.863-1.563zm1.634-5.504l1-1.732 7.794 4.5-1 1.732-7.794-4.5zm3.417-4.613l1.532-1.286 5.785 6.895-1.532 1.285-5.785-6.894z"
            })
        ]
    });
/* harmony default export */ var StackOverflowLine = ((/* unused pure expression or super */ null && (SvgStackOverflowLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/StackshareFill.tsx

const SvgStackshareFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zm-4.208 2.621a2.223 2.223 0 00-2.133 1.6h-1.998l-2.46 4.185H8.763a2.22 2.22 0 100 1.242h1.471l2.417 4.133h2.018a2.221 2.221 0 100-1.243h-1.317l-2.056-3.536 2.053-3.538h1.31a2.223 2.223 0 102.133-2.843zm.011 9.427a1.169 1.169 0 11-1.144 1.395s-.031-.227 0-.454c.106-.535.578-.94 1.144-.94zm-10.152-4.21a1.17 1.17 0 011.168 1.168 1.168 1.168 0 01-2.335 0c0-.644.523-1.167 1.167-1.167zm10.15-4.209a1.169 1.169 0 010 2.335 1.17 1.17 0 01-1.144-.941c-.026-.206 0-.446 0-.446a1.168 1.168 0 011.144-.948z"
            })
        ]
    });
/* harmony default export */ var StackshareFill = ((/* unused pure expression or super */ null && (SvgStackshareFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/StackshareLine.tsx

const SvgStackshareLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.536 13H7.329a3 3 0 11.001-2h2.206L13 5h3.17a3 3 0 11.001 2h-2.017l-2.886 4.999L14.155 17h2.016a3 3 0 110 2H13l-3.464-6zM19 17a1 1 0 100 2 1 1 0 000-2zM4.5 11a1 1 0 100 2 1 1 0 000-2zM19 5a1 1 0 100 2 1 1 0 000-2z"
            })
        ]
    });
/* harmony default export */ var StackshareLine = ((/* unused pure expression or super */ null && (SvgStackshareLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SteamFill.tsx

const SvgSteamFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.004 2c-5.25 0-9.556 4.05-9.964 9.197l5.36 2.216a2.815 2.815 0 011.593-.492c.053 0 .104.003.157.005l2.384-3.452v-.049c0-2.08 1.69-3.77 3.77-3.77 2.079 0 3.77 1.692 3.77 3.772s-1.692 3.771-3.77 3.771h-.087l-3.397 2.426c0 .043.003.088.003.133a2.826 2.826 0 01-2.825 2.83 2.843 2.843 0 01-2.775-2.273l-3.838-1.589C3.573 18.922 7.427 22 12.005 22c5.522 0 9.998-4.477 9.998-10 0-5.522-4.477-10-9.999-10zM7.078 16.667c.218.452.595.832 1.094 1.041a2.126 2.126 0 001.634-3.922 2.119 2.119 0 00-1.565-.025l1.269.525a1.563 1.563 0 01.84 2.046 1.563 1.563 0 01-2.044.843l-1.228-.508zm10.74-7.245a2.516 2.516 0 00-2.513-2.512 2.514 2.514 0 000 5.025 2.513 2.513 0 002.512-2.513zM15.31 7.53a1.889 1.889 0 11-.002 3.774 1.889 1.889 0 01.002-3.774z"
            })
        ]
    });
/* harmony default export */ var SteamFill = ((/* unused pure expression or super */ null && (SvgSteamFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SteamLine.tsx

const SvgSteamLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 4a5 5 0 11-.892 9.92l-2.651 1.989A3.999 3.999 0 019.5 20.5a3.999 3.999 0 01-3.966-4.524L1.708 14.43l.75-1.854 3.826 1.545a3.996 3.996 0 013.696-1.592l2.042-3.061A5 5 0 0117 4zM9.5 14.5c-.464 0-.892.158-1.231.424l1.606.649a1 1 0 11-.75 1.854L7.52 16.78a2.001 2.001 0 003.981-.279 2 2 0 00-2-2zm3.364-2.69l-.983 1.476c.284.21.54.458.758.735l1.36-1.02a5.056 5.056 0 01-1.135-1.191zM17 6a3 3 0 100 6 3 3 0 000-6zm0 1a2 2 0 11.001 3.999A2 2 0 0117 7z"
            })
        ]
    });
/* harmony default export */ var SteamLine = ((/* unused pure expression or super */ null && (SvgSteamLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SwitchFill.tsx

const SvgSwitchFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.619 21c-.085 0-.141-.057-.127-.127V3.127c0-.056.042-.113.113-.113h2.785A4.61 4.61 0 0121 7.624v8.766A4.61 4.61 0 0116.39 21h-2.77zm3.422-9.926c-1.004 0-1.824.82-1.824 1.824s.82 1.824 1.824 1.824 1.824-.82 1.824-1.824-.82-1.824-1.824-1.824zM5.8 8.4a1.7 1.7 0 011.696-1.696A1.7 1.7 0 019.193 8.4c0 .934-.763 1.697-1.697 1.697A1.702 1.702 0 015.8 8.401zM11.54 3c.085 0 .142.057.128.127V20.86c0 .07-.057.127-.128.127H7.61A4.61 4.61 0 013 16.376V7.61A4.61 4.61 0 017.61 3h3.93zm-1.315 16.544V4.442H7.61c-.849 0-1.64.34-2.235.933a3.088 3.088 0 00-.933 2.235v8.766c0 .849.34 1.64.933 2.234a3.088 3.088 0 002.235.934h2.615z"
            })
        ]
    });
/* harmony default export */ var SwitchFill = ((/* unused pure expression or super */ null && (SvgSwitchFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/SwitchLine.tsx

const SvgSwitchLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18H7.6A4.6 4.6 0 013 16.4V7.6A4.6 4.6 0 017.6 3H12zm-2 2H7.6A2.6 2.6 0 005 7.6v8.8A2.6 2.6 0 007.6 19H10V5zm-2.5 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM14 3h2.4A4.6 4.6 0 0121 7.6v8.8a4.6 4.6 0 01-4.6 4.6H14V3zm3 11.7a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z"
            })
        ]
    });
/* harmony default export */ var SwitchLine = ((/* unused pure expression or super */ null && (SvgSwitchLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TaobaoFill.tsx

const SvgTaobaoFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.576 8.277l-1.193 1.842 2.2 1.371s1.464.754.763 2.169c-.65 1.338-3.846 4.27-3.846 4.27l2.862 1.798c1.984-4.326 1.85-3.75 2.347-5.306.512-1.58.624-2.794-.242-3.677-1.113-1.125-1.238-1.23-2.891-2.467zm1.564-.694c1.04 0 1.883-.758 1.883-1.693 0-.943-.843-1.701-1.883-1.701-1.048 0-1.887.762-1.887 1.701.005.931.84 1.693 1.887 1.693zm17.005.21s-.624-4.87-11.207-1.854c.455-.795.669-1.307.669-1.307l-2.64-.75s-1.07 3.508-2.972 5.14c0 0 1.846 1.073 1.826 1.04a17.07 17.07 0 001.407-1.596c.424-.19.83-.363 1.226-.524-.492.887-1.278 2.218-2.068 3.056l1.112.984s.762-.738 1.589-1.62h.943v1.636H8.345v1.306h3.685v3.133l-.14-.004c-.408-.02-1.037-.089-1.287-.484-.298-.484-.077-1.359-.064-1.903H7.995l-.093.052s-.935 4.205 2.689 4.113c3.386.092 5.33-.956 6.265-1.677l.37 1.394 2.09-.882-1.416-3.484-1.693.536.314 1.19c-.427.33-.93.572-1.467.754v-2.738h3.592v-1.31h-3.592v-1.637h3.604V9.051h-6.41c.464-.569.822-1.089.92-1.415l-1.122-.307c4.798-1.733 7.47-1.435 7.45 1.403v7.475s.283 2.564-2.636 2.383l-1.58-.343-.367 1.512s6.817 1.967 7.374-3.314c.552-5.282-.142-8.652-.142-8.652z"
            })
        ]
    });
/* harmony default export */ var TaobaoFill = ((/* unused pure expression or super */ null && (SvgTaobaoFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TaobaoLine.tsx

const SvgTaobaoLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.172 14H14.5v1.375c.55-.221 1.153-.49 1.812-.81l-.082-.238.942-.327zm.828-.287l.12-.042c.641 1.851 1.034 3.012 1.185 3.5l-1.912.59c-.074-.24-.216-.672-.427-1.293-6.081 2.885-8.671 2.054-9.008-1.907l1.993-.17c.1 1.165.344 1.622.897 1.752.393.093.94.063 1.652-.104V14H9v-2h.513l-1.167-1.39c1.043-.876 1.858-1.83 2.448-2.864-.518.135-1.037.28-1.551.435a13.955 13.955 0 01-1.754 2.109l-1.4-1.428c1.272-1.248 2.333-2.91 3.176-4.994l1.854.75a21.71 21.71 0 01-.48 1.101c3.702-.936 7.275-1.317 9.138-.68 1.223.418 1.919 1.391 2.187 2.584.17.756.313 2.689.313 5.123 0 2.807-.056 3.77-.34 4.622-.297.89-.696 1.418-1.407 1.984-.657.523-1.553.763-2.645.823-.673.037-1.368.003-2.095-.08a19.614 19.614 0 01-.596-.075l.264-1.982a57.039 57.039 0 00.556.07c.625.07 1.216.1 1.762.07.714-.04 1.245-.181 1.508-.39.426-.34.591-.558.756-1.054.186-.554.237-1.448.237-3.988 0-2.299-.133-4.102-.264-4.683-.13-.577-.41-.97-.883-1.132-1.207-.412-3.801-.194-6.652.417l.615.262c-.13.302-.273.6-.43.89H18v2h-3.5V12H18v1.713zM12.5 10.5h-1.208A13.685 13.685 0 019.798 12H12.5v-1.5zm-10.039-.438L3.54 8.377c1.062.679 2.935 2.427 3.338 3.161 1.239 2.26.197 4.176-3.122 7.997l-1.51-1.311c2.687-3.094 3.5-4.59 2.878-5.724-.214-.39-1.857-1.924-2.662-2.438zm2.68-2.479c-1.049 0-1.883-.762-1.888-1.693 0-.94.84-1.701 1.887-1.701 1.04 0 1.883.758 1.883 1.701 0 .935-.843 1.693-1.883 1.693z"
            })
        ]
    });
/* harmony default export */ var TaobaoLine = ((/* unused pure expression or super */ null && (SvgTaobaoLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TelegramFill.tsx

const SvgTelegramFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-3.11-8.83l.013-.007.87 2.87c.112.311.266.367.453.341.188-.025.287-.126.41-.244l1.188-1.148 2.55 1.888c.466.257.801.124.917-.432l1.657-7.822c.183-.728-.137-1.02-.702-.788l-9.733 3.76c-.664.266-.66.638-.12.803l2.497.78z"
            })
        ]
    });
/* harmony default export */ var TelegramFill = ((/* unused pure expression or super */ null && (SvgTelegramFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TelegramLine.tsx

const SvgTelegramLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-3.11-8.83l-2.498-.779c-.54-.165-.543-.537.121-.804l9.733-3.76c.565-.23.885.061.702.79l-1.657 7.82c-.116.557-.451.69-.916.433l-2.551-1.888-1.189 1.148c-.122.118-.221.219-.409.244-.187.026-.341-.03-.454-.34l-.87-2.871-.012.008z"
            })
        ]
    });
/* harmony default export */ var TelegramLine = ((/* unused pure expression or super */ null && (SvgTelegramLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TrelloFill.tsx

const SvgTrelloFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.25 3h13.5A2.25 2.25 0 0121 5.25v13.5A2.25 2.25 0 0118.75 21H5.25A2.25 2.25 0 013 18.75V5.25A2.25 2.25 0 015.25 3zm7.92 3.42v5.76c0 .596.484 1.08 1.08 1.08h3.33a1.08 1.08 0 001.08-1.08V6.42a1.08 1.08 0 00-1.08-1.08h-3.33a1.08 1.08 0 00-1.08 1.08zm-7.83 0v10.26c0 .596.484 1.08 1.08 1.08h3.33a1.08 1.08 0 001.08-1.08V6.42a1.08 1.08 0 00-1.08-1.08H6.42a1.08 1.08 0 00-1.08 1.08z"
            })
        ]
    });
/* harmony default export */ var TrelloFill = ((/* unused pure expression or super */ null && (SvgTrelloFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TrelloLine.tsx

const SvgTrelloLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 5v14h14V5H5zm0-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm3 4h2a1 1 0 011 1v8a1 1 0 01-1 1H8a1 1 0 01-1-1V8a1 1 0 011-1zm6 0h2a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1V8a1 1 0 011-1z"
            })
        ]
    });
/* harmony default export */ var TrelloLine = ((/* unused pure expression or super */ null && (SvgTrelloLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TumblrFill.tsx

const SvgTumblrFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.27 7.63A5.76 5.76 0 0010.815 2h3.03v5.152h3.637v3.636h-3.636v5.454c0 .515.197 1.207.909 1.667.474.307 1.484.458 3.03.455V22h-4.242a4.545 4.545 0 01-4.546-4.545v-6.667H6.27V7.63z"
            })
        ]
    });
/* harmony default export */ var TumblrFill = ((/* unused pure expression or super */ null && (SvgTumblrFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TumblrLine.tsx

const SvgTumblrLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8c1.075 0 3.497-.673 3.497-4.5V2h1.5v6H18v2h-5.003v2.91C13 15.39 13 16.595 13 17c-.002 2.208 1.615 3.4 4.785 3.4V22h-2.242c-2.402.002-4.546-2.035-4.546-4.545V10H7V8h1z"
            })
        ]
    });
/* harmony default export */ var TumblrLine = ((/* unused pure expression or super */ null && (SvgTumblrLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TwitchFill.tsx

const SvgTwitchFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3v11.74l-4.696 4.695h-3.913l-2.437 2.348H6.913v-2.348H3V6.13L4.227 3H21zm-1.565 1.565H6.13v11.74h3.13v2.347l2.349-2.348h4.695l3.13-3.13V4.565zm-3.13 3.13v4.696h-1.566V7.696h1.565zm-3.914 0v4.696h-1.565V7.696h1.565z"
            })
        ]
    });
/* harmony default export */ var TwitchFill = ((/* unused pure expression or super */ null && (SvgTwitchFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TwitchLine.tsx

const SvgTwitchLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.3 3H21v11.7l-4.7 4.7h-3.9l-2.5 2.4H7v-2.4H3V6.2L4.3 3zM5 17.4h4v2.4h.095l2.5-2.4h3.877L19 13.872V5H5v12.4zM15 8h2v4.7h-2V8zm0 0h2v4.7h-2V8zm-5 0h2v4.7h-2V8z"
            })
        ]
    });
/* harmony default export */ var TwitchLine = ((/* unused pure expression or super */ null && (SvgTwitchLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TwitterFill.tsx

const SvgTwitterFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.162 5.656a8.384 8.384 0 01-2.402.658A4.196 4.196 0 0021.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 00-7.126 3.814 11.874 11.874 0 01-8.62-4.37 4.168 4.168 0 00-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 01-1.894-.523v.052a4.185 4.185 0 003.355 4.101 4.21 4.21 0 01-1.89.072A4.185 4.185 0 007.97 16.65a8.394 8.394 0 01-6.191 1.732 11.83 11.83 0 006.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 002.087-2.165z"
            })
        ]
    });
/* harmony default export */ var TwitterFill = ((/* unused pure expression or super */ null && (SvgTwitterFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/TwitterLine.tsx

const SvgTwitterLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.3 5.55a2.9 2.9 0 00-2.9 2.847l-.028 1.575a.6.6 0 01-.68.583l-1.561-.212c-2.054-.28-4.022-1.226-5.91-2.799-.598 3.31.57 5.603 3.383 7.372l1.747 1.098a.6.6 0 01.034.993L7.793 18.17c.947.059 1.846.017 2.592-.131 4.718-.942 7.855-4.492 7.855-10.348 0-.478-1.012-2.141-2.94-2.141zm-4.9 2.81a4.9 4.9 0 018.385-3.355c.711-.005 1.316.175 2.669-.645-.335 1.64-.5 2.352-1.214 3.331 0 7.642-4.697 11.358-9.463 12.309-3.268.652-8.02-.419-9.382-1.841.694-.054 3.514-.357 5.144-1.55C5.16 15.7-.329 12.47 3.278 3.786c1.693 1.977 3.41 3.323 5.15 4.037 1.158.475 1.442.465 1.973.538z"
            })
        ]
    });
/* harmony default export */ var TwitterLine = ((/* unused pure expression or super */ null && (SvgTwitterLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/UbuntuFill.tsx

const SvgUbuntuFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12c0 5.522-4.477 10-10 10S2 17.522 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10zM5.2 10.664a1.335 1.335 0 100 2.67 1.335 1.335 0 000-2.67zm9.533 6.069a1.334 1.334 0 101.334 2.31 1.334 1.334 0 00-1.334-2.31zM8.1 12c0-1.32.656-2.485 1.659-3.19l-.976-1.636a5.813 5.813 0 00-2.399 3.371 1.875 1.875 0 010 2.91 5.813 5.813 0 002.398 3.371l.977-1.636A3.892 3.892 0 018.1 12zM12 8.1a3.9 3.9 0 013.884 3.554l1.903-.028a5.781 5.781 0 00-1.723-3.762A1.872 1.872 0 0113.55 6.41a5.829 5.829 0 00-4.12.39l.927 1.663A3.885 3.885 0 0112 8.1zm0 7.8c-.587 0-1.143-.13-1.643-.363l-.927 1.662a5.774 5.774 0 004.12.39 1.872 1.872 0 012.514-1.454 5.782 5.782 0 001.723-3.762l-1.903-.027A3.898 3.898 0 0112 15.9zm2.732-8.633a1.335 1.335 0 101.335-2.312 1.335 1.335 0 00-1.335 2.312z"
            })
        ]
    });
/* harmony default export */ var UbuntuFill = ((/* unused pure expression or super */ null && (SvgUbuntuFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/UbuntuLine.tsx

const SvgUbuntuLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.667 19.273l1.006-1.742a6.001 6.001 0 008.282-4.781h2.012A7.97 7.97 0 0118.928 16a8 8 0 01-1.452 1.835 2.493 2.493 0 00-1.976.227 2.493 2.493 0 00-1.184 1.596 7.979 7.979 0 01-5.65-.385zm-1.3-.75a7.979 7.979 0 01-3.156-4.7A2.494 2.494 0 005 12c0-.72-.304-1.369-.791-1.825A8 8 0 015.072 8a7.97 7.97 0 012.295-2.524l1.006 1.742a6.001 6.001 0 000 9.563l-1.005 1.742zm1.3-13.796a8.007 8.007 0 015.648-.387 2.497 2.497 0 003.161 1.825 8.007 8.007 0 012.49 5.085h-2.013A5.99 5.99 0 0015 6.804a5.99 5.99 0 00-5.327-.335L8.667 4.727zM16 5.072a1.5 1.5 0 111.5-2.598A1.5 1.5 0 0116 5.072zM4 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm12 6.928a1.5 1.5 0 111.5 2.598 1.5 1.5 0 01-1.5-2.598z"
            })
        ]
    });
/* harmony default export */ var UbuntuLine = ((/* unused pure expression or super */ null && (SvgUbuntuLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/UnsplashFill.tsx

const SvgUnsplashFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 11v5h7v-5H21v10H3V11h5.5zm7-8v5h-7V3h7z"
            })
        ]
    });
/* harmony default export */ var UnsplashFill = ((/* unused pure expression or super */ null && (SvgUnsplashFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/UnsplashLine.tsx

const SvgUnsplashLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10v4h4v-4h7v11H3V10h7zm-2 2H5v7h14v-7h-3l-.001 4H8v-4zm8-9v6H8V3h8zm-2 2h-4v2h4V5z"
            })
        ]
    });
/* harmony default export */ var UnsplashLine = ((/* unused pure expression or super */ null && (SvgUnsplashLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/VimeoFill.tsx

const SvgVimeoFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.173 8.301c-.281-.413-.252-.413.328-.922 1.232-1.082 2.394-2.266 3.736-3.212 1.215-.852 2.826-1.402 3.927-.047 1.014 1.249 1.038 3.142 1.295 4.65.257 1.564.503 3.164 1.051 4.66.152.421.443 1.217.968 1.284.678.093 1.368-1.096 1.683-1.54.817-1.18 1.925-2.769 1.785-4.286-.138-1.612-1.878-1.309-2.966-.924.175-1.809 1.858-3.843 3.48-4.53 1.72-.714 4.276-.702 5.14 1.237.923 2.102.093 4.543-.912 6.448-1.097 2.068-2.509 3.982-4.018 5.77-1.331 1.588-2.906 3.33-4.89 4.089-2.267.864-3.61-.82-4.382-2.77-.843-2.123-1.262-4.506-1.87-6.717-.256-.934-.56-1.997-1.167-2.768-.792-.995-1.692-.06-2.474.477-.269-.267-.491-.607-.714-.899z"
            })
        ]
    });
/* harmony default export */ var VimeoFill = ((/* unused pure expression or super */ null && (SvgVimeoFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/VimeoLine.tsx

const SvgVimeoLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.993 3.004c2.433 0 4.005 1.512 4.005 4.496 0 1.72-.998 3.94-1.832 5.235-2.789 4.333-6.233 8.74-9.643 8.74-3.706 0-4.67-6.831-5.092-8.432-.422-1.601-.533-2.21-1.17-3.233-.317.22-.76.529-1.33.93a.5.5 0 01-.693-.117L.925 8.807a.5.5 0 01.027-.62C3.779 4.915 6.128 3.278 8 3.278c2.392 0 3.124 2.816 3.324 4.223.3 2.117.69 4.738 1.244 5.872.557-.792 2.18-2.888 1.967-3.99-.094-.486-1.317.183-1.887.078-.425-.08-.806-.402-.806-1.026 0-1.31 1.852-5.43 6.151-5.43zm.007 2c-2.195 0-3.251 1.533-3.653 2.208 1.25.046 1.97.818 2.133 1.803.389 2.33-1.916 4.92-2.339 5.565-.396.603-3.061 3.328-4.25-3.36a160.44 160.44 0 01-.665-4.186c-.17-1.151-.873-1.763-1.23-1.763-.842 0-1.92.65-3.855 2.515 1.905-.115 2.545 2.276 2.916 3.633.816 2.984 1.571 8.056 3.62 8.056 1.727 0 4.439-2.646 7.37-7.04.209-.311 1.966-3.024 1.966-5.036 0-2.395-1.469-2.395-2.013-2.395z"
            })
        ]
    });
/* harmony default export */ var VimeoLine = ((/* unused pure expression or super */ null && (SvgVimeoLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/VisaFill.tsx

const SvgVisaFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1 4h22v2H1V4zm0 14h22v2H1v-2zm18.622-3.086l-.174-.87h-1.949l-.31.863-1.562.003c1.005-2.406 1.75-4.19 2.236-5.348.127-.303.353-.457.685-.455.254.002.669.002 1.245 0L21 14.912l-1.378.003zm-1.684-2.062h1.256l-.47-2.18-.786 2.18zM7.872 9.106l1.57.002-2.427 5.806-1.59-.001c-.537-2.07-.932-3.606-1.184-4.605-.077-.307-.23-.521-.526-.622-.263-.09-.701-.23-1.315-.419v-.16h2.509c.434 0 .687.21.769.64l.62 3.289 1.574-3.93zm3.727.002l-1.24 5.805-1.495-.002 1.24-5.805 1.495.002zM14.631 9c.446 0 1.01.138 1.334.267l-.262 1.204c-.293-.118-.775-.277-1.18-.27-.59.009-.954.256-.954.493 0 .384.632.578 1.284.999.743.48.84.91.831 1.378-.01.971-.831 1.929-2.564 1.929-.791-.012-1.076-.078-1.72-.306l.272-1.256c.656.274.935.361 1.495.361.515 0 .956-.207.96-.568.002-.257-.155-.384-.732-.702-.577-.317-1.385-.756-1.375-1.64C12.033 9.759 13.107 9 14.63 9z"
            })
        ]
    });
/* harmony default export */ var VisaFill = ((/* unused pure expression or super */ null && (SvgVisaFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/VisaLine.tsx

const SvgVisaLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.222 15.768l-.225-1.125h-2.514l-.4 1.117-2.015.004a4199.19 4199.19 0 012.884-6.918c.164-.391.455-.59.884-.588.328.003.863.003 1.606.001L24 15.765l-1.778.003zm-2.173-2.666h1.62l-.605-2.82-1.015 2.82zM7.06 8.257l2.026.002-3.132 7.51-2.051-.002a950.849 950.849 0 01-1.528-5.956c-.1-.396-.298-.673-.679-.804A63.566 63.566 0 000 8.465V8.26h3.237c.56 0 .887.271.992.827.106.557.372 1.975.8 4.254L7.06 8.257zm4.81.002l-1.602 7.508-1.928-.002 1.6-7.508 1.93.002zm3.91-.139c.577 0 1.304.18 1.722.345l-.338 1.557c-.378-.152-1-.357-1.523-.35-.76.013-1.23.332-1.23.638 0 .498.816.749 1.656 1.293.959.62 1.085 1.177 1.073 1.782-.013 1.256-1.073 2.495-3.309 2.495-1.02-.015-1.388-.101-2.22-.396l.352-1.625c.847.355 1.206.468 1.93.468.663 0 1.232-.268 1.237-.735.004-.332-.2-.497-.944-.907-.744-.411-1.788-.98-1.774-2.122.017-1.462 1.402-2.443 3.369-2.443z"
            })
        ]
    });
/* harmony default export */ var VisaLine = ((/* unused pure expression or super */ null && (SvgVisaLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/VuejsFill.tsx

const SvgVuejsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1 3h4l7 12 7-12h4L12 22 1 3zm8.667 0L12 7l2.333-4h4.035L12 14 5.632 3h4.035z"
            })
        ]
    });
/* harmony default export */ var VuejsFill = ((/* unused pure expression or super */ null && (SvgVuejsFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/VuejsLine.tsx

const SvgVuejsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.316 3L12 18l8.684-15H23L12 22 1 3h2.316zm4.342 0L12 10.5 16.342 3h2.316L12 14.5 5.342 3h2.316z"
            })
        ]
    });
/* harmony default export */ var VuejsLine = ((/* unused pure expression or super */ null && (SvgVuejsLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/Wechat2Fill.tsx

const SvgWechat2Fill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.457 18.185C3.358 16.677 2 14.4 2 11.908 2 7.323 6.475 3.6 12 3.6s10 3.723 10 8.308c0 4.584-4.475 8.307-10 8.307a11.36 11.36 0 01-3.272-.461c-.092-.03-.216-.03-.308-.03-.185 0-.37.06-.525.153l-2.191 1.261a.44.44 0 01-.185.062.342.342 0 01-.34-.338c0-.093.03-.154.062-.247.03-.03.308-1.046.463-1.661 0-.062.03-.154.03-.216 0-.246-.092-.43-.277-.553zm3.21-7.674c.717 0 1.285-.568 1.285-1.285 0-.718-.568-1.286-1.285-1.286-.718 0-1.285.568-1.285 1.286 0 .717.567 1.285 1.285 1.285zm6.666 0c.718 0 1.285-.568 1.285-1.285 0-.718-.567-1.286-1.285-1.286-.717 0-1.285.568-1.285 1.286 0 .717.568 1.285 1.285 1.285z"
            })
        ]
    });
/* harmony default export */ var Wechat2Fill = ((/* unused pure expression or super */ null && (SvgWechat2Fill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/Wechat2Line.tsx

const SvgWechat2Line = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.667 11.511a1.276 1.276 0 01-1.285-1.285c0-.718.567-1.286 1.285-1.286.717 0 1.285.568 1.285 1.286 0 .717-.568 1.285-1.285 1.285zm6.666 0a1.276 1.276 0 01-1.285-1.285c0-.718.568-1.286 1.285-1.286.718 0 1.285.568 1.285 1.286 0 .717-.567 1.285-1.285 1.285zm-8.51 7.704l.715-.436a4 4 0 012.705-.536c.212.033.386.059.52.076.406.054.82.081 1.237.081 4.42 0 7.9-3.022 7.9-6.6S16.42 5.2 12 5.2s-7.9 3.022-7.9 6.6c0 1.366.5 2.673 1.432 3.781.048.057.12.137.214.235a4 4 0 011.101 3.102l-.025.297zm-.63 2.727a1 1 0 01-1.527-.93l.188-2.26a2 2 0 00-.55-1.551A6.993 6.993 0 014 16.868c-1.194-1.421-1.9-3.173-1.9-5.068 0-4.75 4.432-8.6 9.9-8.6s9.9 3.85 9.9 8.6-4.432 8.6-9.9 8.6c-.51 0-1.01-.033-1.499-.098a23.61 23.61 0 01-.569-.084 2 2 0 00-1.353.268l-2.387 1.456z"
            })
        ]
    });
/* harmony default export */ var Wechat2Line = ((/* unused pure expression or super */ null && (SvgWechat2Line)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WechatFill.tsx

const SvgWechatFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.574 13.711a.91.91 0 00.898-.898c0-.498-.399-.898-.898-.898s-.898.4-.898.898c0 .5.4.898.898.898zm-4.425 0a.91.91 0 00.898-.898c0-.498-.4-.898-.898-.898-.5 0-.898.4-.898.898 0 .5.399.898.898.898zm6.567 5.04a.347.347 0 00-.172.37c0 .048 0 .097.025.147.098.417.294 1.081.294 1.106 0 .073.025.122.025.172a.22.22 0 01-.221.22c-.05 0-.074-.024-.123-.048l-1.449-.836a.799.799 0 00-.344-.098c-.073 0-.147 0-.196.024-.688.197-1.4.295-2.161.295-3.66 0-6.607-2.457-6.607-5.505 0-3.047 2.947-5.505 6.607-5.505 3.659 0 6.606 2.458 6.606 5.505 0 1.647-.884 3.146-2.284 4.154zM16.673 8.099a9.105 9.105 0 00-.28-.005c-4.174 0-7.606 2.86-7.606 6.505 0 .554.08 1.09.228 1.6h-.089a9.963 9.963 0 01-2.584-.368c-.074-.025-.148-.025-.222-.025a.832.832 0 00-.418.123l-1.748 1.005c-.05.025-.099.05-.148.05a.273.273 0 01-.27-.27c0-.074.024-.123.049-.197.024-.024.246-.834.369-1.324 0-.05.024-.123.024-.172a.556.556 0 00-.221-.442C2.058 13.376 1 11.586 1 9.598 1 5.945 4.57 3 8.95 3c3.765 0 6.93 2.169 7.723 5.098zm-5.154.418c.573 0 1.026-.477 1.026-1.026 0-.573-.453-1.026-1.026-1.026s-1.026.453-1.026 1.026.453 1.026 1.026 1.026zm-5.26 0c.573 0 1.027-.477 1.027-1.026 0-.573-.454-1.026-1.027-1.026-.572 0-1.026.453-1.026 1.026s.454 1.026 1.026 1.026z"
            })
        ]
    });
/* harmony default export */ var WechatFill = ((/* unused pure expression or super */ null && (SvgWechatFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WechatLine.tsx

const SvgWechatLine = (props)=>/*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ _jsxs("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    fill: "none",
                    d: "M0 0h24v24H0z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "nonzero",
                    d: "M10 14.676v-.062c0-2.508 2.016-4.618 4.753-5.233C14.389 7.079 11.959 5.2 8.9 5.2 5.58 5.2 3 7.413 3 9.98c0 .969.36 1.9 1.04 2.698.032.038.083.094.152.165a3.568 3.568 0 011.002 2.238 3.612 3.612 0 012.363-.442c.166.026.302.046.405.06A7.254 7.254 0 0010 14.675zm.457 1.951a9.209 9.209 0 01-2.753.055 19.056 19.056 0 01-.454-.067 1.612 1.612 0 00-1.08.212l-1.904 1.148a.806.806 0 01-.49.117.791.791 0 01-.729-.851l.15-1.781a1.565 1.565 0 00-.439-1.223 5.537 5.537 0 01-.241-.262C1.563 12.855 1 11.473 1 9.979 1 6.235 4.537 3.2 8.9 3.2c4.06 0 7.403 2.627 7.85 6.008 3.372.153 6.05 2.515 6.05 5.406 0 1.193-.456 2.296-1.229 3.19-.051.06-.116.13-.195.21a1.24 1.24 0 00-.356.976l.121 1.423a.635.635 0 01-.59.68.66.66 0 01-.397-.094l-1.543-.917a1.322 1.322 0 00-.874-.169c-.147.023-.27.04-.368.053a7.72 7.72 0 01-.969.062c-2.694 0-4.998-1.408-5.943-3.401zm6.977 1.31a3.325 3.325 0 011.676.174 3.25 3.25 0 01.841-1.502c.05-.05.087-.09.106-.112.489-.565.743-1.213.743-1.883 0-1.804-1.903-3.414-4.4-3.414-2.497 0-4.4 1.61-4.4 3.414s1.903 3.414 4.4 3.414c.241 0 .48-.016.714-.046.08-.01.188-.025.32-.046z"
                })
            ]
        })
    });
/* harmony default export */ var WechatLine = ((/* unused pure expression or super */ null && (SvgWechatLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WechatPayFill.tsx

const SvgWechatPayFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.27 14.669a.662.662 0 01-.88-.269l-.043-.095-1.818-3.998a.473.473 0 010-.145.327.327 0 01.335-.328.305.305 0 01.196.066l2.18 1.527a.989.989 0 00.546.167.894.894 0 00.342-.066l10.047-4.5a10.73 10.73 0 00-8.171-3.526C6.478 3.502 2 7.232 2 11.87a7.83 7.83 0 003.46 6.296.662.662 0 01.24.727l-.45 1.701a.945.945 0 00-.051.24.327.327 0 00.334.334.414.414 0 00.19-.058l2.18-1.265c.16-.098.343-.151.531-.152.099 0 .197.014.29.043 1.063.3 2.161.452 3.265.45 5.525 0 10.01-3.729 10.01-8.33a7.226 7.226 0 00-1.097-3.883L9.35 14.625l-.08.044z"
            })
        ]
    });
/* harmony default export */ var WechatPayFill = ((/* unused pure expression or super */ null && (SvgWechatPayFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WechatPayLine.tsx

const SvgWechatPayLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.145 8.993l-9.799 5.608-.07.046a.646.646 0 01-.3.068.655.655 0 01-.58-.344l-.046-.092-1.83-3.95c-.024-.046-.024-.092-.024-.138 0-.184.139-.321.324-.321.07 0 .14.023.209.069l2.155 1.515c.162.092.348.161.556.161a.937.937 0 00.348-.069l8.275-3.648C16.934 6.273 14.634 5.2 12 5.2c-4.42 0-7.9 3.022-7.9 6.6 0 1.366.5 2.673 1.432 3.781.048.057.12.137.214.235a4 4 0 011.101 3.102l-.025.297.716-.436a4 4 0 012.705-.536c.212.033.386.059.52.076.406.054.82.081 1.237.081 4.42 0 7.9-3.022 7.9-6.6 0-.996-.27-1.95-.755-2.807zM6.192 21.943a1 1 0 01-1.526-.932l.188-2.259a2 2 0 00-.55-1.551A6.993 6.993 0 014 16.868c-1.194-1.421-1.9-3.173-1.9-5.068 0-4.75 4.432-8.6 9.9-8.6s9.9 3.85 9.9 8.6-4.432 8.6-9.9 8.6c-.51 0-1.01-.033-1.499-.098a23.61 23.61 0 01-.569-.084 2 2 0 00-1.353.268l-2.387 1.456z"
            })
        ]
    });
/* harmony default export */ var WechatPayLine = ((/* unused pure expression or super */ null && (SvgWechatPayLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WeiboFill.tsx

const SvgWeiboFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.525 11.378c1.263.392 2.669 1.336 2.669 3.004 0 2.763-3.98 6.239-9.964 6.239-4.565 0-9.23-2.213-9.23-5.852 0-1.902 1.204-4.102 3.277-6.177 2.773-2.77 6.004-4.033 7.219-2.816.537.537.588 1.464.244 2.572-.178.557.525.25.525.25 2.24-.938 4.196-.994 4.909.027.38.543.343 1.306-.008 2.19-.163.407.048.471.36.563zm-7.282 7.939c3.641-.362 6.401-2.592 6.167-4.983-.237-2.391-3.382-4.038-7.023-3.677-3.64.36-6.403 2.59-6.167 4.98.237 2.394 3.382 4.039 7.023 3.68zM6.16 14.438c.754-1.527 2.712-2.39 4.446-1.94 1.793.463 2.707 2.154 1.976 3.8-.744 1.682-2.882 2.578-4.695 1.993-1.752-.566-2.493-2.294-1.727-3.853zm1.446 2.587c.568.257 1.325.013 1.676-.55.346-.568.163-1.217-.407-1.459-.563-.237-1.291.008-1.64.553-.354.547-.189 1.202.371 1.456zm2.206-1.808c.219.092.501-.012.628-.231.123-.22.044-.466-.178-.548-.216-.084-.486.018-.613.232-.123.214-.054.458.163.547zM19.873 9.5a.725.725 0 11-1.378-.451 1.38 1.38 0 00-.288-1.357 1.395 1.395 0 00-1.321-.425.723.723 0 11-.303-1.416 2.836 2.836 0 013.29 3.649zm-3.916-6.575A5.831 5.831 0 0121.5 4.72a5.836 5.836 0 011.22 5.704.838.838 0 01-1.06.54.844.844 0 01-.542-1.062 4.143 4.143 0 00-4.807-5.327.845.845 0 01-.354-1.65z"
            })
        ]
    });
/* harmony default export */ var WeiboFill = ((/* unused pure expression or super */ null && (SvgWeiboFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WeiboLine.tsx

const SvgWeiboLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.194 14.197c0 3.362-4.53 6.424-9.926 6.424C5.318 20.62 1 18.189 1 14.534c0-1.947 1.18-4.087 3.24-6.088 2.832-2.746 6.229-4.033 7.858-2.448.498.482.723 1.122.719 1.858 1.975-.576 3.65-.404 4.483.752.449.623.532 1.38.326 2.207 1.511.61 2.568 1.77 2.568 3.382zm-4.44-2.07c-.386-.41-.4-.92-.198-1.41.208-.508.213-.812.12-.94-.264-.368-1.533-.363-3.194.311a2.043 2.043 0 01-.509.14c-.344.046-.671.001-.983-.265-.419-.359-.474-.855-.322-1.316.215-.67.18-1.076.037-1.215-.186-.18-.777-.191-1.659.143-1.069.405-2.298 1.224-3.414 2.306C3.925 11.54 3 13.218 3 14.534c0 2.242 3.276 4.087 7.268 4.087 4.42 0 7.926-2.37 7.926-4.424 0-.738-.637-1.339-1.673-1.652-.394-.113-.536-.171-.767-.417zm7.054-1.617a1 1 0 01-1.936-.502 4 4 0 00-4.693-4.924 1 1 0 11-.407-1.958 6 6 0 017.036 7.384z"
            })
        ]
    });
/* harmony default export */ var WeiboLine = ((/* unused pure expression or super */ null && (SvgWeiboLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WhatsappFill.tsx

const SvgWhatsappFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.004 22l1.352-4.968A9.954 9.954 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 01-5.03-1.355L2.004 22zM8.391 7.308a.961.961 0 00-.371.1 1.293 1.293 0 00-.294.228c-.12.113-.188.211-.261.306A2.729 2.729 0 006.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.971 2.742.214.213.423.427.648.626a9.448 9.448 0 003.84 2.046l.569.087c.185.01.37-.004.556-.013a1.99 1.99 0 00.833-.231 4.83 4.83 0 00.383-.22s.043-.028.125-.09c.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.401-.621a.498.498 0 00-.177-.041.482.482 0 00-.378.127v-.002c-.005 0-.072.057-.795.933a.35.35 0 01-.368.13 1.416 1.416 0 01-.191-.066c-.124-.052-.167-.072-.252-.109l-.005-.002a6.01 6.01 0 01-1.57-1c-.126-.11-.243-.23-.363-.346a6.296 6.296 0 01-1.02-1.268l-.059-.095a.923.923 0 01-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41a4.38 4.38 0 00.263-.373c.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 00-.403.004z"
            })
        ]
    });
/* harmony default export */ var WhatsappFill = ((/* unused pure expression or super */ null && (SvgWhatsappFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WhatsappLine.tsx

const SvgWhatsappLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.253 18.494l.724.423A7.953 7.953 0 0012 20a8 8 0 10-8-8 7.95 7.95 0 001.084 4.024l.422.724-.653 2.401 2.4-.655zM2.004 22l1.352-4.968A9.954 9.954 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 01-5.03-1.355L2.004 22zM8.391 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537a4.38 4.38 0 01-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.049.191.066a.35.35 0 00.367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 01.378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.57-.188.733a1.155 1.155 0 01-.21.302 2.378 2.378 0 01-.33.288 3.71 3.71 0 01-.125.09 5.024 5.024 0 01-.383.22 1.99 1.99 0 01-.833.23c-.185.01-.37.024-.556.014-.008 0-.568-.087-.568-.087a9.448 9.448 0 01-3.84-2.046c-.226-.199-.435-.413-.649-.626-.89-.885-1.562-1.84-1.97-2.742A3.47 3.47 0 016.9 9.62a2.729 2.729 0 01.564-1.68c.073-.094.142-.192.261-.305.127-.12.207-.184.294-.228a.961.961 0 01.371-.1z"
            })
        ]
    });
/* harmony default export */ var WhatsappLine = ((/* unused pure expression or super */ null && (SvgWhatsappLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WindowsFill.tsx

const SvgWindowsFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5.479l7.377-1.016v7.127H3V5.48zm0 13.042l7.377 1.017v-7.04H3v6.023zm8.188 1.125L21 21v-8.502h-9.812v7.148zm0-15.292v7.236H21V3l-9.812 1.354z"
            })
        ]
    });
/* harmony default export */ var WindowsFill = ((/* unused pure expression or super */ null && (SvgWindowsFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/WindowsLine.tsx

const SvgWindowsLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 2.5v19l-18-2v-15l18-2zm-2 10.499L12 13v5.487l7 .778V13zm-14 4.71l5 .556V13l-5-.001v4.71zM19 11V4.735l-7 .777V11l7-.001zm-9-5.265L5 6.29V11h5V5.734z"
            })
        ]
    });
/* harmony default export */ var WindowsLine = ((/* unused pure expression or super */ null && (SvgWindowsLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/XboxFill.tsx

const SvgXboxFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.418 19.527A9.956 9.956 0 0012 22a9.967 9.967 0 006.585-2.473c1.564-1.593-3.597-7.257-6.585-9.514-2.985 2.257-8.15 7.921-6.582 9.514zm9.3-12.005c2.084 2.468 6.237 8.595 5.064 10.76A9.952 9.952 0 0022 12.003a9.958 9.958 0 00-2.975-7.113s-.022-.018-.068-.035a.686.686 0 00-.235-.038c-.493 0-1.654.362-4.004 2.705zM5.045 4.856c-.048.017-.068.034-.072.035A9.963 9.963 0 002 12.003c0 2.379.832 4.561 2.218 6.278C3.05 16.11 7.2 9.988 9.284 7.523 6.934 5.178 5.771 4.818 5.28 4.818a.604.604 0 00-.234.039v-.002zM12 4.959S9.546 3.523 7.63 3.455c-.753-.027-1.212.246-1.268.282C8.149 2.538 10.049 2 11.987 2H12c1.945 0 3.838.538 5.638 1.737-.056-.038-.512-.31-1.266-.282-1.917.068-4.372 1.5-4.372 1.5v.004z"
            })
        ]
    });
/* harmony default export */ var XboxFill = ((/* unused pure expression or super */ null && (SvgXboxFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/XboxLine.tsx

const SvgXboxLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.797 15.485c1.124-2.52 3.2-5.44 4.487-6.962-1.248-1.246-2.162-1.931-2.818-2.3A7.977 7.977 0 004 12c0 1.25.286 2.432.797 3.485zm4.051-10.84C10.448 5.05 12 5.959 12 5.959v-.005s1.552-.904 3.151-1.31A7.974 7.974 0 0012 4c-1.12 0-2.185.23-3.152.645zm8.686 1.578c-.655.37-1.568 1.055-2.816 2.3 1.287 1.523 3.362 4.441 4.486 6.961A7.968 7.968 0 0020 12c0-2.27-.946-4.32-2.466-5.777zm.408 11.133c-1.403-2.236-4.09-4.944-5.942-6.343-1.85 1.4-4.539 4.108-5.941 6.345A7.98 7.98 0 0012 20a7.98 7.98 0 005.942-2.644zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
            })
        ]
    });
/* harmony default export */ var XboxLine = ((/* unused pure expression or super */ null && (SvgXboxLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/XingFill.tsx

const SvgXingFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.462 3.23c.153 0 .307.078.384.155a.49.49 0 010 .461l-6.077 10.77 3.846 7.076a.49.49 0 010 .462.588.588 0 01-.384.154h-2.77c-.384 0-.615-.308-.769-.539l-3.923-7.154C11 14.308 16.923 3.77 16.923 3.77c.154-.307.385-.538.77-.538h2.769zM8.923 7c.385 0 .615.308.77.538l1.922 3.308c-.153.154-3 5.23-3 5.23-.153.232-.384.54-.769.54H5.154a.588.588 0 01-.385-.154.49.49 0 010-.462l2.846-5.154-1.846-3.23a.49.49 0 010-.462A.588.588 0 016.154 7h2.77z"
            })
        ]
    });
/* harmony default export */ var XingFill = ((/* unused pure expression or super */ null && (SvgXingFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/XingLine.tsx

const SvgXingLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.444 3.5L13.81 14.99 17.857 22h-2.31l-4.045-7.009H11.5L18.134 3.5h2.31zM8.31 7l2.422 4.196-.002.001L7.67 16.5H5.361l3.06-5.305L6.002 7H8.31z"
            })
        ]
    });
/* harmony default export */ var XingLine = ((/* unused pure expression or super */ null && (SvgXingLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/YoutubeFill.tsx

const SvgYoutubeFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5l6-3.5-6-3.5v7z"
            })
        ]
    });
/* harmony default export */ var YoutubeFill = ((/* unused pure expression or super */ null && (SvgYoutubeFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/YoutubeLine.tsx

const SvgYoutubeLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.606 6.995c-.076-.298-.292-.523-.539-.592C18.63 6.28 16.5 6 12 6s-6.628.28-7.069.403c-.244.068-.46.293-.537.592C4.285 7.419 4 9.196 4 12s.285 4.58.394 5.006c.076.297.292.522.538.59C5.372 17.72 7.5 18 12 18s6.629-.28 7.069-.403c.244-.068.46-.293.537-.592C19.715 16.581 20 14.8 20 12s-.285-4.58-.394-5.005zm1.937-.497C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5v-7l6 3.5-6 3.5z"
            })
        ]
    });
/* harmony default export */ var YoutubeLine = ((/* unused pure expression or super */ null && (SvgYoutubeLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ZcoolFill.tsx

const SvgZcoolFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.902 21.839A7.903 7.903 0 012 13.935C2 10.29 4.467 7.06 7.824 6.31 11.745 5.43 13.528 4.742 14.9 2c.998 1.935.323 3.71 0 4.677 4.698-1.129 6.371-3.28 6.774-3.548 0 3.952-1.231 6.452-2.419 8.065 1.476-.056 2.009-.484 2.744-.587-.325 1.448-1.5 3.49-4.33 4.795a7.905 7.905 0 01-7.768 6.437zm3.71-6.452c0 .323-.053.484-.403.484l-3.15.002 2.96-3.248c.86-.86.86-1.29.86-2.388 0-.334-.048-.717.048-1.05.047-.144-.048-.192-.191-.144-.335.095-.908.095-1.863.095H7.575c-.239 0-.335-.143-.239-.334 0-.048 0-.191-.096-.191-.62.286-.764 1.576-.716 2.388 0 .43.239.669.573.669h3.391l-3.486 3.725c-.24.287-.478.669-.478 1.194v1.051c0 .478.287.764.812.86h5.988c.555 0 .933-.233.933-.855v-1.129c0-.208 0-.968-.645-1.129z"
            })
        ]
    });
/* harmony default export */ var ZcoolFill = ((/* unused pure expression or super */ null && (SvgZcoolFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ZcoolLine.tsx

const SvgZcoolLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.26 8.26C5.838 8.803 4 11.208 4 13.935a5.903 5.903 0 0011.703 1.098 2 2 0 011.129-1.448c.482-.222.91-.473 1.284-.743-.863-.603-1.186-1.862-.47-2.834a9.796 9.796 0 001.391-2.651 19.04 19.04 0 01-3.668 1.265c-1.261.303-2.392-.638-2.466-1.814-1.18.572-2.67 1.01-4.642 1.452zm10.996 2.934c1.166 0 1.917-.424 2.744-.587-.325 1.448-1.5 3.49-4.33 4.795A7.903 7.903 0 012 13.936C2 10.29 4.467 7.06 7.824 6.308 11.745 5.43 13.528 4.742 14.9 2c.689 1.333.689 2.892 0 4.677 2.816-.67 5.074-1.852 6.774-3.548 0 4.802-1.822 7.186-2.419 8.065zm-5.84 3.932c.584.145.584.832.584 1.02v1.022c0 .561-.342.773-.844.773H7.742c-.475-.087-.734-.346-.734-.778v-.95c0-.475.216-.82.432-1.08l3.152-3.369H7.526c-.302 0-.518-.216-.518-.604-.044-.735.086-1.9.647-2.16.087 0 .087.13.087.173-.087.173 0 .302.216.302h3.887c.863 0 1.381 0 1.684-.086.13-.043.216 0 .173.13-.087.302-.044.647-.044.95 0 .993 0 1.382-.777 2.159l-2.678 2.937 2.85-.002c.316 0 .364-.146.364-.437z"
            })
        ]
    });
/* harmony default export */ var ZcoolLine = ((/* unused pure expression or super */ null && (SvgZcoolLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ZhihuFill.tsx

const SvgZhihuFill = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.373 18.897h1.452l.478 1.637 2.605-1.637h3.07V5.395h-7.605v13.502zM14.918 6.86h4.515v10.57h-1.732l-1.73 1.087-.314-1.084-.739-.003V6.861zm-2.83 4.712H8.846a70.3 70.3 0 00.136-4.56h3.172s.122-1.4-.532-1.384H6.135c.216-.814.488-1.655.813-2.524 0 0-1.493 0-2 1.339-.211.552-.82 2.677-1.904 4.848.365-.04 1.573-.073 2.284-1.378.131-.366.156-.413.318-.902h1.79c0 .651-.074 4.151-.104 4.558h-3.24c-.729 0-.965 1.466-.965 1.466h4.066C6.92 16.131 5.456 18.74 2.8 20.8c1.27.363 2.536-.057 3.162-.614 0 0 1.425-1.297 2.206-4.298l3.346 4.03s.49-1.668-.077-2.481c-.47-.554-1.74-2.052-2.281-2.595l-.907.72c.27-.867.433-1.71.488-2.524h3.822s-.005-1.466-.47-1.466z"
            })
        ]
    });
/* harmony default export */ var ZhihuFill = ((/* unused pure expression or super */ null && (SvgZhihuFill)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/ZhihuLine.tsx

const SvgZhihuLine = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.344 17.963l-1.688 1.074-2.131-3.35c-.44 1.402-1.172 2.665-2.139 3.825-.402.483-.82.918-1.301 1.375-.155.147-.775.717-.878.82l-1.414-1.414c.139-.139.787-.735.915-.856.43-.408.795-.79 1.142-1.206 1.266-1.518 2.03-3.21 2.137-5.231H3v-2h4V7h-.868c-.689 1.266-1.558 2.222-2.618 2.857L2.486 8.143c1.395-.838 2.425-2.604 3.038-5.36l1.952.434c-.14.633-.303 1.227-.489 1.783H11.5v2H9v4h2.5v2H9.185l3.159 4.963zm3.838-.07L17.298 17H19V7h-4v10h.736l.446.893zM13 5h8v14h-3l-2.5 2-1-2H13V5z"
            })
        ]
    });
/* harmony default export */ var ZhihuLine = ((/* unused pure expression or super */ null && (SvgZhihuLine)));

;// CONCATENATED MODULE: ./src/components/icons/Logos/index.tsx































































































































































































// EXTERNAL MODULE: ./src/navigation/urls.ts
var urls = __webpack_require__(6633);
;// CONCATENATED MODULE: ./src/navigation/footerNavigation.ts

const ABOUT_LINKS = [
    {
        text: "About Hurtigruten Group",
        href: urls/* getAboutUsUrl */.Bx()
    },
    {
        text: "Our Brands",
        href: urls/* getOurBrandsUrl */.nJ()
    },
    {
        text: "Our History",
        href: urls/* getHistoryUrl */.ek()
    },
    {
        text: "Work With Us",
        href: urls/* getPeopleUrl */.L6()
    },
    {
        text: "Hurtigruten Foundation",
        href: urls/* getFoundationUrl */.XA()
    }
];
const STAY_UPDATED_LINKS = [
    {
        text: "Press and Media",
        href: urls/* getPressAndMediaUrl */.zS()
    },
    {
        text: "Sustainability",
        href: urls/* getSustainabilityUrl */.E_()
    },
    {
        text: "Investor Relations",
        href: urls/* getInvestorsUrl */.Ye()
    }
];

// EXTERNAL MODULE: ./src/components/atoms/IconButton.tsx
var IconButton = __webpack_require__(1051);
// EXTERNAL MODULE: ./src/constants/ButtonModes.ts
var ButtonModes = __webpack_require__(9413);
// EXTERNAL MODULE: ./src/components/atoms/StyledLink.tsx
var StyledLink = __webpack_require__(7169);
// EXTERNAL MODULE: ./src/components/icons/System/index.tsx + 298 modules
var System = __webpack_require__(3857);
;// CONCATENATED MODULE: ./src/components/molecules/FooterLinkList.tsx



const FooterLinkList = (param)=>/*#__PURE__*/ {
    let { title , links , externalLinks =false  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-4 h5",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "list-none",
                children: links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mb-4 list-none last:mb-0",
                        children: !externalLinks ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink/* StyledLink */.F, {
                            link: link,
                            underline: false
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink/* StyledLink */.F, {
                            className: "w-full",
                            iconClassName: "ml-auto",
                            link: link,
                            underline: false,
                            icon: System/* ArrowRightLine */.dT3
                        })
                    }, link.href))
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/navigation/mainNavigation.ts + 1 modules
var mainNavigation = __webpack_require__(3951);
;// CONCATENATED MODULE: ./src/components/organisms/Footer.tsx








const Footer = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-hrg-red-70",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-6 pt-12 mx-auto mb-24 max-w-page-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-4 h5",
                        children: "Follow us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                mode: ButtonModes/* ButtonModes.secondaryBlack */.r.secondaryBlack,
                                "aria-label": "Hurtigruten Norge Facebook",
                                href: "https://www.facebook.com/HurtigrutenNorge",
                                icon: FacebookBoxLine,
                                className: "px-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                mode: ButtonModes/* ButtonModes.secondaryBlack */.r.secondaryBlack,
                                "aria-label": "Hurtigreutn Group Linkedin",
                                href: "https://www.linkedin.com/company/hurtigrutengroup",
                                icon: LinkedinBoxLine,
                                className: "px-0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "grid grid-cols-1 gap-12 px-6 mx-auto mb-12 tablet:grid-cols-2 laptop:grid-cols-3 max-w-page-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkList, {
                        title: "About",
                        links: ABOUT_LINKS
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkList, {
                        title: "Stay updated",
                        links: STAY_UPDATED_LINKS
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkList, {
                        title: "Go to",
                        links: mainNavigation/* GO_TO_LINKS */.M,
                        externalLinks: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t border-hrg-black-60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 px-6 py-12 mx-auto gap-y-4 gap-x-12 tablet:grid-cols-2 laptop:grid-cols-3 max-w-page-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "body",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " Hurtigruten Group"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col laptop:col-span-2 gap-y-4 gap-x-6 tablet:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink/* StyledLink */.F, {
                                    href: "https://global.hurtigruten.com/practical-information/statement-of-privacy/",
                                    children: "Privacy statement"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink/* StyledLink */.F, {
                                    className: "ot-sdk-show-settings",
                                    children: "Manage Preferences"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });


/***/ }),

/***/ 9413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ButtonModes; }
/* harmony export */ });
var ButtonModes;
(function(ButtonModes) {
    ButtonModes["primary"] = "primary";
    ButtonModes["secondary"] = "secondary";
    ButtonModes["secondaryBlack"] = "secondary-black";
    ButtonModes["secondaryWhite"] = "secondary-white";
    ButtonModes["secondaryBeige"] = "secondary-beige";
    ButtonModes["secondaryWarmGray2"] = "secondary-warm-gray-2";
    ButtonModes["tertiary"] = "tertiary";
    ButtonModes["flat"] = "flat";
    ButtonModes["flatBlack"] = "flat black";
    ButtonModes["flatWhite"] = "flat white";
    ButtonModes["fab"] = "fab";
    ButtonModes["menuLink"] = "menu-link";
    ButtonModes["none"] = "none";
})(ButtonModes || (ButtonModes = {}));


/***/ }),

/***/ 259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ useIsVisible; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/hooks/useIntersectionObserver.ts

const useIntersectionObserver = (ref, callback, options)=>{
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver(callback, options);
        if (ref.current) {
            observer.observe(ref.current);
        }
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        callback,
        options
    ]);
    return ref;
};

;// CONCATENATED MODULE: ./src/hooks/useIsVisible.tsx


const useIsVisible = (ref, options)=>{
    const [isIntersecting, setIntersecting] = (0,react.useState)(false);
    const onIntersect = (0,react.useCallback)((param)=>{
        let [entry] = param;
        if (entry) {
            setIntersecting(entry.isIntersecting);
        }
    }, []);
    useIntersectionObserver(ref, onIntersect, options);
    return isIntersecting;
};


/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useKeypress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useKeypress = function(key, action) {
    let deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const onKeyup = (e)=>{
            if (e.key === key) action();
        };
        window.addEventListener("keyup", onKeyup);
        return ()=>window.removeEventListener("keyup", onKeyup);
    }, deps);
};


/***/ }),

/***/ 3951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ GO_TO_LINKS; },
  "E": function() { return /* binding */ MAIN_NAVIGATION; }
});

;// CONCATENATED MODULE: ./src/utils/array.ts
const pickFirst = (item)=>{
    if (Array.isArray(item)) {
        return item[0];
    }
    return item;
};
const filterNotNull = (value)=>value !== null;

// EXTERNAL MODULE: ./src/utils/featureToggles/index.ts + 1 modules
var featureToggles = __webpack_require__(7098);
// EXTERNAL MODULE: ./src/navigation/urls.ts
var urls = __webpack_require__(6633);
;// CONCATENATED MODULE: ./src/navigation/mainNavigation.ts



const MAIN_NAVIGATION = [
    {
        href: urls/* getIndexUrl */.TY(),
        text: "Home",
        isNewTab: false
    },
    {
        href: urls/* getAboutUsUrl */.Bx(),
        text: "About Us",
        isNewTab: true
    },
    {
        href: urls/* getPeopleUrl */.L6(),
        text: "People",
        isNewTab: true
    },
    featureToggles/* featureToggles.DEIPages */.f.DEIPages ? {
        href: urls/* getDEIUrl */.iw(),
        text: "Diversity, Equity and Inclusion",
        isNewTab: false
    } : null,
    {
        href: urls/* getSustainabilityUrl */.E_(),
        text: "Sustainability",
        isNewTab: true
    },
    {
        href: urls/* getInvestorsUrl */.Ye(),
        text: "Investor Relations",
        isNewTab: false
    },
    {
        href: urls/* getPressAndMediaUrl */.zS(),
        text: "Press and Media",
        isNewTab: true
    },
    {
        href: urls/* getFoundationUrl */.XA(),
        text: "Hurtigruten Foundation",
        isNewTab: true
    }
].filter(filterNotNull);
const GO_TO_LINKS = [
    {
        href: "https://www.hurtigruten.com/destinations/",
        text: "Hurtigruten Expeditions"
    },
    {
        href: "https://www.hurtigruten.com/destinations/norway/",
        text: "Hurtigruten Norwegian Coastal Express"
    },
    {
        href: "https://hurtigrutensvalbard.com/en",
        text: "Hurtigruten Svalbard"
    }
];


/***/ }),

/***/ 6646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ externalLinkMixin; }
/* harmony export */ });
const externalLinkMixin = (url)=>/^https?:\/\//.exec(url) ? {
        target: "_blank",
        rel: "noopener noreferrer"
    } : {};


/***/ }),

/***/ 7098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ featureToggles; }
});

// EXTERNAL MODULE: ./src/utils/time.ts
var time = __webpack_require__(5555);
;// CONCATENATED MODULE: ./src/utils/featureToggles/defaults.ts
const DEFAULT_FEATURE_TOGGLES = {
    foundationDonations: false,
    DEIPages: false,
    richTextAssetBlocks: false,
    richTextEntryBlocks: false,
    richTextTables: false,
    sendGridEmails: false
};

;// CONCATENATED MODULE: ./src/utils/featureToggles/index.ts


let _internalToggles = DEFAULT_FEATURE_TOGGLES;
if (false) {} else {
    _internalToggles = window.__FEATURE_TOGGLES;
}
const featureToggles = new Proxy(DEFAULT_FEATURE_TOGGLES, {
    get (target, prop) {
        var _prop;
        return (_prop = _internalToggles[prop]) !== null && _prop !== void 0 ? _prop : target[prop];
    }
});


/***/ })

}]);